export default [
	{
		name: "Abergele",
		description: 'The Abergele cattle are the smallest breed of north Ethiopia. They are reared in the Abergele lowlands and at the southwestern lower slopes of Dogu’a Tembien district. Abergelle cattle are part of the Zenga breed group. The Abergele breed is known for its adaptation to the hotter and drier lowlands. It is also very tolerant to diseases and parasites and can cope with feed shortages during long dry periods.',
		region: 'Ethiopia',
		image:'abergele.jpg'
	},
	{
		name: "Abigar",
		description: 'Abigar are a breed of cattle found in Eastern Africa. They are classified as Sanga cattle. Although primarily dairy cattle, they are also slaughtered for their beef.<br/>' +
			'<br/>' +
			'Cows produce approximately 750 kg of milk per lactation. The origin of Abigar cattle breed is found to be Gambella Regional State, especially the districts occupied by the Nuer people. The observed production & reproduction performance of the breed is promising under the prevailing stressful and challenging environment in the region. The Abigar cattle is said to be hardy animals in response to frequent disease outbreaks, drought and seasonal feed and water shortages and high temperature and heat loads. However, a gradually decreasing trend of Abigar cattle was reported in the study areas. Frequent disease outbreaks coupled with lack of veterinary service, lack of security, flood, cattle raiders, recurrent drought, rangeland degradation, illegal cattle marketing, seasonal feed and water shortages and lack of extension service were among the identified threats to the decreasing trend of the Abigar cattle in the study areas',
		region: 'Ethiopia',
		image:''
	},
	{
		name: "Abondance",
		description: 'The Abondance is a mixed race breed of cattle which originated in the high valleys of Haute-Savoie, France.',
		region: 'France',
		image:'abondance.jpg'
	},
	{
		name: "Abyssinian Shorthorned Zebu",
		description: 'The Abyssinian Shorthorned Zebu is a breed of cattle found in Ethiopia. ',
		region: 'Ethiopia',
		image:''
	},
	{
		name: "Aceh",
		description: '',
		region: 'Indonesia',
		image:''
	},
	{
		name: "Achham",
		description: 'Achham cattle are a breed of zebu cattle found in the Achham region of Nepal. Achham cattle are a small breed less than 1 meter in height at the withers. It is also called Naumuthe cow as it measures only nine fists from its hoof to hump[1].<br/>' +
			'<br/>' +
			'Achhami cattle (Bos indicus) are in the list of unique flora/fauna of Nepal.[2] They are suitable for hill conditions and low input systems, used mainly for milk production.[3] Body color varies from black to white, i.e. black, brown, grey, white, spotted black and white. According to the annual report of Animal Breeding Division, Nepal Agriculture Research Council (2005), cows average 88 cm in height at the withers with an average weight of 110 kg. Bulls average 97 cm at the withers and weigh on average 150 kg. They are reared by the farmers of the Far Western Development Region of Nepal, particularly in Achham, Bajhang, Bajura, And Doti districts.',
		region: 'Nepal',
		image:''
	},
	{
		name: 'Adamawa',
		description: 'Adamawa are a breed of cattle indigenous to Adamawa, Nigeria. They are a multipurpose breed, used as a draught animal, and for beef and dairy production. The breed makes up 2% of Nigeria\'s total herd. This breed resembles white Fulani or bunaji having a medium to large size, with respect to horn medium size and also crescent in shape. The hump is pendulous in shape which is the main characteristics that differentiate it from white Fulani.',
		region: 'Nigeria',
		image:''
	},
	{
		name: 'Adaptaur',
		description: 'The Adaptaur is a tropically-adapted Bos taurus beef cattle breed which was developed in Australia in the 1950s from crosses between Herefords and Shorthorns. ',
		region: 'Australia',
		image:'adaptaur.jpg'
	},
	{
		name: 'Afar',
		description: 'The Afar cattle are mainly found on the western margins of the Danakil Depression in Ethiopia. The Afar cattle have thick and long horns and a cervicothoracic hump; they are essentially reared for milk production.',
		region: 'Ethiopia',
		image: '',
	},
	{
		name: 'Africangus',
		description: 'Africangus is a breed of beef cattle that originated in the United States of America in the 1950s. This breed is a composite of Africander (30%) and Aberdeen Angus (70%).',
		region: 'United States',
		image: '',
	},
	{
		name: 'Afrikaner',
		description: 'The Afrikaner, also known as the Africander, is a breed of taurine-indicine ("Sanga")[1] cattle indigenous to South Africa. Huge herds of Sanga type cattle were herded by the Khoikhoi (Hottentots) when the Dutch established the Cape Colony in 1652.',
		region: 'South Africa',
		image: 'afrikaner.jpg',
	},
	{
		name: 'Agerolese',
		description: 'The Agerolese is a breed of dairy cattle from the area of Agerola, in Campania in southern Italy. It is particularly associated with the Sorrento Peninsula and Monti Lattari.[3] It derives from cross-breeding of indigenous Podolica cattle with Italian Holstein-Friesian, Bruna Italiana and Jersey cattle. It is one of the sixteen minor Italian cattle breeds of limited diffusion recognised and protected by the Ministero delle Politiche Agricole Alimentari e Forestali, the Italian ministry of agriculture.',
		region: 'Italy',
		image: '',
	},
	{
		name: 'Akaushi',
		description: 'The Japanese Brown (Japanese: 褐毛和種, Akage Washu or 赤牛, Aka Ushi) is a breed of small Japanese beef cattle. It is one of six native Japanese cattle breeds,[2] and one of the four Japanese breeds known as wagyū, the others being the Japanese Black, the Japanese Polled and the Japanese Shorthorn.[3]:420 All wagyū cattle derive from cross-breeding in the early twentieth century of native Japanese cattle with imported stock, mostly from Europe.[4]:5 In the case of the Japanese Brown, the principal foreign influence was from the Korean Hanwoo and Swiss Simmental breeds',
		region: 'Japan',
		image: 'akaushi.jpg',
	},
	{
		name: 'Ala Tau',
		description: 'The Alatau cattle (also Ala Tau) are a breed of cattle of Kazakhstan, named after the Alatau (Turkic "Motley Mountain"[citation needed]) Mountains. Ala Tau cattle are used for beef and dairy production.',
		region: 'Kazakhstan',
		image: '',
	},
	{
		name: 'Alambadi',
		description: 'Alambadi is a breed of cattle that originated in the southern state of Tamil Nadu in India. In the past it was generally kept as a draught animal,[3] although modern breeders are attempting to increase the milk output of this traditional breed. Alambadi breed is almost extinct and it is rare to find one. Farmers and breeders are complaining that the reason for the extinction of breed is due to the banning of bio-cultural sports like Raekla racing and usage of exotic foreign crossbred cows.',
		region: 'India',
		image: '',
	},
	{
		name: 'Alatau cattle',
		description: 'The Alatau cattle (also Ala Tau) are a breed of cattle of Kazakhstan, named after the Alatau (Turkic "Motley Mountain"[citation needed]) Mountains. Ala Tau cattle are used for beef and dairy production.',
		region: 'Kazakhstan',
		image: '',
	},
	{
		name: 'Albanian',
		description: 'The Albanian is a breed of cattle, originally from Albania. They are generally used as a draught animal and for dairy production.',
		region: 'Albania',
		image: '',
	},
	{
		name: 'Albera',
		description: 'The Albera is an endangered breed of small cattle indigenous to the Albera Massif, which divides Catalonia from France and lies partly in the comarca of Alt Empordà in the Catalan province of Girona, and partly in the comarca of Vallespir in the French département of Pyrénées-Orientales.[4] The cattle are highly resistant to cold, though susceptible to heat, and are well adapted to the steep terrain of the massif.',
		region: 'Spain',
		image: 'albera.jpg',
	},
	{
		name: 'Alderney',
		description: 'The Alderney was a breed of dairy cattle originating from the British Channel Island of Alderney, though no longer found on the island. The pure breed is now extinct, though hybrids still exist. The Alderney was one of three Channel Island cattle breeds, the others being the Jersey and the Guernsey.',
		region: 'Channel Islands',
		image: 'alderney.jpg',
	},
	{
		name: 'Alentejana',
		description: 'The Alentejana is a cattle breed from Portugal. The Alentejana breed has the protected geographical status of DOC (Denominação de Origem Controlada) from the European Commission',
		region: 'Portugal',
		image: '',
	},
	{
		name: 'Aleutian wild cattle',
		description: 'Aleutian wild cattle are feral wild cattle found on the Alaskan Aleutian islands. Several attempts have been made to round up these cattle for ranching.[1][2] In 1985–6 the cattle on the Shumagin Islands were eliminated by the U.S. Fish and Wildlife Service,[3][4] but they still remained on Umnak Island[2] and Chirikof Island[',
		region: 'United States',
		image: '',
	},
	{
		name: 'Aliab Dinka',
		description: '',
		region: 'South Sudan',
		image: '',
	},
	{
		name: 'Alistana-Sanabresa',
		description: '',
		region: 'Spain',
		image: '',
	},
	{
		name: 'Allmogekor',
		description: 'Allmogekor ("Allmoge cattle; singular Allmogeko [ˈâlːmuːɡɛˌkuː]) is a generic term for the old native breeds of cattle from Sweden.',
		region: 'Sweden',
		image: '',
	},
	{
		name: 'Alur',
		description: '',
		region: 'Democratic Republic of the Congo',
		image: '',
	},
	{
		name: 'American',
		description: 'The American is a breed of cattle originating in the United States and known for its heritage as an American Bison hybrid. It was developed in the 1950s by a New Mexico rancher looking for beef cattle which could survive on poor fodder in the arid Southwest.<br/>' +
			'<br/><br/>' +
			'Today the American is one of only a few pure breeds with any known Bison genetics, with the more well-known breed being the Beefalo.[1] Art Jones, the original breeder, began by crossing Hereford, Shorthorn and Charolais, and later added extensive crosses with Brahman cattle and Bison.[2] Today all individuals of this rare breed display the genetic marker for Bison ancestry.[1] American cattle are varying in appearance, though nearly all display the floppy Brahman ears, slight humps, and many have horns. ',
		region: 'United States',
		image: '',
	},
	{
		name: 'American Angus',
		description: '',
		region: 'United States',
		image: '',
	},
	{
		name: 'American Beef Friesian',
		description: '',
		region: 'United States',
		image: '',
	},
	{
		name: 'American Brown Swiss',
		description: '',
		region: 'United States',
		image: '',
	},
	{
		name: 'American Milking Devon',
		description: 'The American Milking Devon is a breed of cattle from the United States. Originally derived from British North Devon cattle brought to North America in the 17th century, the two strains have since diverged significantly. Modern North Devons have been bred to be used almost exclusively for beef production, while American Milking Devons are a multi-purpose animal akin to the stock which first took the transatlantic journey. Despite their name, they are also suited to meat production and to work as draft animals (i.e. oxen). Considered to be one of the oldest and purest breeds of American cattle in existence, American Milking Devons are also exceedingly rare.',
		region: 'United States',
		image: 'american_milking_devon.jpg',
	},
	{
		name: 'American White Park',
		description: 'The American White Park is a large, mostly polled, white breed of cattle. The females have an average weight of roughly 1000 pounds (453 kilograms), while the males have an average weight between 1700-1800 pounds (771-816 kilograms).',
		region: 'United States',
		image: '',
	},
	{
		name: 'Amerifax',
		description: 'Amerifax is a breed of beef cattle, developed in the US in the 1970s. This breed is a combination of Angus (5/8th) and Beef Friesian (3/8th).',
		region: 'United States',
		image: '',
	},
	{
		name: 'Amrit Mahal',
		description: 'The Amrit Mahal (Kannada:ಅಮೃತ ಮಹಲ್) is a breed of cattle that originated from the erstwhile state of Mysore in Karnataka, India. They originated from the Hallikar and closely related breeds, Hagalavadi and Chithradurg. Originally developed for use in war for transporting equipage,[1] the bullocks are notable for their great endurance and speed. Their head is elongated with a ridge in the middle and a bulging forehead. The cows in contrast are poor milk-yielders and hence, are classified to be a draught breed.[2]<br/>' +
			'<br/>' +
			'The Amrit Mahal is one of the two breeds, along with Hallikar, which have received the royal patronage and care from the erstwhile Vijayanagara Kingdom, sultans and princely state of Mysore through conservation and development.[3]<br/>' +
			'<br/>' +
			'The breed was originally maintained by a cattle-herding community known as the Gollas, among whom were another group known as the Hallikars. During Chikka Devaraja Wadiyar\'s reign a department was created within his administration known as "Benne chavadi" literally "butter department" which maintained cows and bulls, branded (with his initial ದೇ /Dē/) and maintained for supplying butter and milk to the royal household. This was taken over by Hyder Ali and he renamed the administrative unit as "Amrit Mahal". The British took an interest in these cattle when Hyder Ali used them to move guns 100 miles in two days to Chelambram during the Battle of Porto Novo and when Tipu Sultan used them to march across south India in a month. They were then adopted for use in the army by the Duke of Wellington. After the defeat of Tipu Sultan, the British allowed them to be maintained by the Maharaja of Mysore but in thirteen years they were found to have regressed. In 1813, the pasture lands known as kaval or Kaaval (Kannada:ಕಾವಲ್) and the cattle were placed under a Captain Harvey of the Madras Commissariat for management of the breed. In 1842, a report stated that the English Army was served efficiently by 230 Mysore bullocks in Afghanistan. In 1860, Charles Trevelyan closed down this unit as being uneconomical but it was re-established in 1867 with the assistance of the Mysore Maharaja and by 1870 about 4000 cows and 100 bulls were under government care. The charge moved back to the Maharaja of Mysore in 1883.<br/>' +
			'<br/>' +
			'The kavals were classified for use in wet, dry and cold weather. The cows would not come into season in the wet malnad regions but had to be taken into the dry plains where they bred. Beginning in the 20th century, the kavals were increasingly diverted for other uses',
		region: 'India',
		image: 'amrit_mahal.jpg',
	},
	{
		name: 'Amsterdam Island cattle',
		description: 'Amsterdam Island cattle were a rare feral breed of cattle (Bos taurus) that were introduced in 1871 and existed in isolation on Amsterdam Island, a small French territory in the southern Indian Ocean. The population was eradicated in 2010 in the course of an environmental restoration program.',
		region: 'Amsterdam Island',
		image: '',
	},
	{
		name: 'Anatolian Black',
		description: 'The Anatolian Black (Turkish: Yerli Kara), also known as Native Black Cattle, is a breed of cattle that originated in Anatolia, in what is now Turkey. They are the most popular cattle breed in Turkey,[1] and are used in dairy production, meat production,[2] and as draught animals on small farms.[1] They are primarily raised in central Turkey.[3]<br/>' +
			'<br/>' +
			'The Anatolian Black is the smallest of the native cattle breeds of Turkey. It is closely related genetically to the East Anatolian Red and South Anatolian Red native Turkish breeds.[4] These three breeds are collectively referred to as "Anatolian Native" cattle, and are distinguished on morphological and regional grounds, rather than genetically.[5]<br/>' +
			'<br/>' +
			'The breed is considered at risk of extinction, and the number of genetically pure individuals has decreased. This is due to crossbreeding with European breeds to improve productivity and yields, unconscious crossbreeding and poor management, as well as rural-urban migration. In order to save the Anatolian Black and other native cattle breeds, research has been conducted into how to improve their productivity, in order to become a more viable option for farmers.[3] There is a conservation herd located at the Central Livestock Research Institute in Lalahan',
		region: 'Turkey',
		image: 'antolian_black.jpg',
	},
	{
		name: 'Andalusian Black',
		description: 'The Andalusian Black (Spanish: Negra Andaluza[1]), known locally as the Negra de las Campiñas, is a taurine breed of cattle that originated in west Andalusia, Spain. They are similar to the Avileña-Black Iberian breed, however the two are distinguished geographically.[2]<br/>' +
			'<br/>' +
			'Andalusian Blacks are found in two main areas of west Andalusia: from Cordova to the foothills of the Sierra Morena; and in the provinces of Seville, Cádiz and Huelva.[3]<br/>' +
			'<br/>' +
			'The first breed association was formed in Spain in 1996. There were only ~800 purebred individuals in 2007, their numbers reduced due to crossbreeding with other local Spanish breeds; the population increased to 1,883 by 2011.[2] It is now classified as endangered, with 1,415 animals registered with the stud book. The breed\'s decline is due to mechanisation of agriculture, segmentation and isolation of subpopulations, crossbreeding, lack of genetic programs, and unstructured breeding efforts.[1] The current breed association, formed in 2005, has undertaken a conservation program in partnership with the University of Cordoba to maintain the breed.[4]<br/>' +
			'<br/>' +
			'They are a strong, hardy breed that is able to adapt to adverse weather conditions. The head can be straight to convex in profile. They have long, upward-curving horns.[3] Females grow to 135cm at the withers and weigh 600-650kg. Males grow to 140cm at the withers and weigh 875-950kg. The coat colour is black.[2] They have a calm and docile nature.<br/>' +
			'<br/>' +
			'Heifers reach sexual maturity between 18-20 months. They have a fertility rate of 80-95%, with a 1.15% chance of producing twins. They have a strong maternal instinct.[5]<br/>' +
			'<br/>' +
			'A genetic defect common to the Andalusian breeds resulting in lowered fertility rate is present in Andalusian Blacks, however it likely occurs at a lower frequency within this breed compared to the others.[2] They are prone to developing hypermetria.[3]<br/>' +
			'<br/>' +
			'The breed was traditionally used as a draught animal, however it is now transitioning into a primarily beef breed due to the mechanisation of agriculture.[1] They are also crossed with other breeds to produce beef. They are often kept on unimproved farms with rudimentary infrastructure',
		region: 'Spain',
		image: '',
	},
	{
		name: 'Andalusian Blond',
		description: '',
		region: 'Spain',
		image: '',
	},
	{
		name: 'Andalusian Grey',
		description: 'The Angeln is a breed of cattle originally from Angeln in Schleswig-Holstein where they are first mentioned around 1600. however some people think that they may have existed for over 5000 years.[1] Breed management has been practiced since 1830. Angeln cattle are red in color and were one of the founders of the larger Danish Red Cattle breed. They are noted for the high milkfat level of their milk. Angeln cows produce an average 7570 kg (16,700 lb) of 4.81% fat milk.',
		region: 'Spain',
		image: '',
	},
	{
		name: 'Angeln cattle',
		description: '',
		region: 'Germany',
		image: '',
	},
	{
		name: 'Angoni',
		description: '',
		region: 'Malawi',
		image: '',
	},
	{
		name: 'Angus',
		description: 'The Aberdeen Angus, sometimes simply Angus, is a Scottish breed of small beef cattle. It derives from cattle native to the counties of Aberdeenshire and Angus in north-eastern Scotland.[1]<br/>' +
			'<br/>' +
			'The Angus is naturally polled and solid black or red, though the udder may be white. The native colour is black, but more recently red colours have emerged.[2] The United Kingdom registers both in the same herd book, but in the United States they are regarded as two separate breeds: Red Angus and Black Angus. Black Angus is the most common breed of beef cattle in the US, with 332,421 cattle registered in 2017.[3] In 2014, the British Cattle Movement Service named Angus the UK\'s most popular native beef breed, and the second most popular beef breed overall.',
		region: 'Scotland',
		image: 'angus.jpg',
	},
	{
		name: 'Ankina',
		description: '',
		region: 'United States',
		image: '',
	},
	{
		name: 'Ankole-Watusi',
		description: '',
		region: 'East Africa',
		image: 'ankole_watusi.jpg',
	},
	{
		name: 'Aosta cattle',
		description: '',
		region: 'Italy',
		image: '',
	},
	{
		name: 'Apulian Podolian',
		description: '',
		region: 'Italy',
		image: '',
	},
	{
		name: 'Aracena',
		description: '',
		region: 'Spain',
		image: '',
	},
	{
		name: 'Arado',
		description: 'The red and black coated Arado cattle are small and hardy. They are the most common cattle variety in the north Ethiopian highlands. The Arado breed is part of the Zenga breed group. It is essentially reared for draught power, particularly tillage. The breed feeds mainly on crop residues; it is adapted to seasonal feed shortages. This breed is often cross-bred through bull and artificial insemination services.',
		region: 'Ethiopia',
		image: 'arado.jpg',
	},
	{
		name: 'Argentine Criollo',
		description: 'The Argentine Criollo is one of the Criollo type cattle found in the Americas. Criollo cattle are descended from the first bovines brought by Christopher Columbus in his travels to America. [1] These cattle are known for their docility and workability in addition to tremendous genetic variability. Like their Criollo relatives, the Argentine Criollo exhibits the full range of Bos taurus color patterns. These animals are highly adapted to their environment due to feral - naturally selective breeding regimes over the past 500 years, therefore they are extremely desirable for crossbreeding with traditional European breeds to assure incredible hybrid vigor. The Asociación Argentina de Criadores de Ganado Bovino Criollo was established in 1990 as the official breed society. Owners who wish to register their livestock with the Criollo Association must have their cattle tested and examined for pureness of origin, before they can be considered purebred Argentine Criollo cattle',
		region: 'Argentina',
		image: 'argentine_criollo.png',
	},
	{
		name: 'Argentine Friesian',
		description: '',
		region: 'Argentina',
		image: '',
	},
	{
		name: 'Armorican',
		description: 'The Armoricaine or Armorican is an endangered French breed of domestic cattle. It originated in Brittany in the nineteenth century. It has a red coat with white markings, and has short horns.',
		region: 'France',
		image: 'amorican.jpg',
	},
	{
		name: 'Arouquesa Cattle',
		description: 'The Arouquesa is a cattle breed from Portugal.[1] The Arouquesa breed was granted protected geographical status of DOC (Denominação de Origem Controlada) from the European Commission',
		region: 'Portugal',
		image: 'arouquesa_cattle.jpg',
	},
	{
		name: 'Arsi',
		description: '',
		region: 'Ethiopia',
		image: '',
	},
	{
		name: 'Asturian Mountain',
		description: 'Asturian Mountain (Spanish: Asturiana de la Montaña)[1] is a local Spanish breed of cattle, which possess breeding capacity[1] and docility.[1] They are primarily raised in the east of Asturias,[1] in the north of Spain, particularly in the mountain range of the Picos de Europa, including within the National Park of Covadonga. The breed is also known as the Casina[1][2] They are beef cattle and one of three breeds used to produce Casín cheese.',
		region: 'Spain',
		image: 'asturian_mountain.jpg',
	},
	{
		name: 'Asturian Valley',
		description: 'Asturian Mountain (Spanish: Asturiana de la Montaña)[1] is a local Spanish breed of cattle, which possess breeding capacity[1] and docility.[1] They are primarily raised in the east of Asturias,[1] in the north of Spain, particularly in the mountain range of the Picos de Europa, including within the National Park of Covadonga. The breed is also known as the Casina[1][2] They are beef cattle and one of three breeds used to produce Casín cheese.',
		region: 'Spain',
		image: 'asturian_valley.jpg',
	},
	{
		name: 'Aubrac cattle',
		description: 'The Aubrac is a French breed of domestic beef cattle. It originates on the Plateau de l\'Aubrac in the Massif Central in central southern France, from which it also takes its name. It has a wheat-coloured coat and dark hooves, switch, muzzle and eyes.',
		region: 'France',
		image: 'aubrac.jpg',
	},
	{
		name: 'Aulie-Ata',
		description: 'Aulie-Ata is a breed of dairy cattle, developed in the town of Aulie-Ata (now Taraz) in Kazakhstan, in late 19th early 20th century by breeding local Kazakh cattle with Dutch Black Pied Cattle. Planned breeding began in 1935 and the new breed was officially recognised in 1950. On average, Aulie-Ata cows produce 3735 kg of milk per lactation.',
		region: 'Kazakhstan',
		image: '',
	},
	{
		name: 'Aure et Saint-Girons',
		description: 'The Aure et Saint-Girons or Casta is an endangered French breed of domestic cattle. The breed name derives from its two principal areas of origin, the Vallée d\'Aure in the département of the Hautes-Pyrénées, and the area of Saint-Girons and the Couserans in the Ariège. The name "Casta" derives from its chestnut colour.',
		region: 'France',
		image: 'aure_et_saint_girons.jpg',
	},
	{
		name: 'Australian Braford',
		description: 'The Australian Braford is a breed of beef cattle, developed in Queensland between 1946 and 1952 in a program to produce cattle that were resistant to cattle ticks and tolerated the heat better than some other breeds.<br/>' +
			'<br/>' +
			'The Braford breed originated at ‘Edengarry’ north of Rockhampton in Queensland in 1946 when the Rea Brothers introduced Brahman bulls into their Hereford breeders to help combat the effects of drought and ticks.<br/>' +
			'<br/>' +
			'Brafords have a small hump, loose skin and a short coat that is red and white, possessing a colour pattern similar to that of Hereford cattle.[1] Australian Brafords may be horned or polled.[2] The genetic background of the breed is approximately 50 per cent Hereford and 50 per cent Brahman.<br/>' +
			'<br/>' +
			'Brafords are mainly found in NSW and Queensland Australia. Braford semen has been exported into South America and South Africa. Live cattle exports have been made into Indonesia and Thailand.[',
		region: 'Australia',
		image: 'australian_braford.jpg',
	},
	{
		name: 'Australian Brangus',
		description: 'Australian Brangus are a polled breed of beef cattle, developed in the tropical coastal areas of Queensland, Australia by crossbreeding Brahman and Angus cattle during the 1950s.',
		region: 'Australia',
		image: 'australian_brangus.jpg',
	},
	{
		name: 'Australian Charbray',
		description: 'The Australian Charbray is a beef breed of cattle that is the result of the blending of two breeds, the Charolais and the Brahman. The Australian Charbray is within the range of 75% and 25% Charolais and Brahman, either way. The hump of the Brahman is often almost non-existent, but the loose skin and enlarged dewlap are indications of the Bos indicus blood in this breed.<br/>' +
			'<br/>' +
			'The Charbray is a large breed that is heavily muscled in the loin and quarters. They have been well accepted in those areas where cattle carrying at least some Brahman breeding are desired because of hot and humid conditions.[1]<br/>' +
			'<br/>' +
			'An Australian Charbray is cream to light red coloured. The calves are generally light tan when born but may lighten to a creamy white in a few weeks. The bull is structurally sound and has the ability to travel the distances required of bulls, even in hot humid environments. It has been selected for clean, tight sheaths, fertility and early testicular development. The Charbray female is also early maturing, reaching puberty at 14–17 months and calving at or near two years of age with rapid rebreeding and good milk production.[1]<br/>' +
			'<br/>' +
			'The Australian Charbrays have performed very well in weight gain trials including Aus-Meat National Livestock Feedback Trials and in hoof and hook competitions.<br/>' +
			'<br/>' +
			'Charbray calves show excellent performance in the feedlot. Their resistance to heat, humidity, parasites and diseases is to their benefit in southern feedlots. They grow rapidly and have outstanding feed converting ability. They reach slaughter weights at 12 to 15 months and produce lean, yield grade 1 and 2 carcasses that require little or no fat trimming. ',
		region: 'Australia',
		image: '',
	},
	{
		name: 'Australian Friesian Sahiwal',
		description: 'The Australian Friesian Sahiwal, is an Australian breed of dairy cattle whose development commenced in the 1960s by the Queensland Government. It is a combination of the Sahiwal, a dairy breed of Bos indicus from Pakistan and Holstein (Bos taurus) breeds, designed for the tropical regions of Australia. Cows produce approximately 3,000 litres of milk per lactation[1] under tropical pasture conditions with a high resistance to heat, humidity, ticks and other parasites.<br/>' +
			'<br/>' +
			'The AFS breed has now been successfully exported to many tropical countries of South East Asia, Central and South America and the Indian sub-continent.',
		region: 'Australia',
		image: 'australian_friesian_sahiwal.jpg',
	},
	{
		name: 'Australian Milking Zebu',
		description: 'The Australian Milking Zebu (AMZ) is a composite breed of dairy cattle, developed by the Commonwealth Scientific and Industrial Research Organisation (CSIRO) in Australia during the mid-1950s. To develop the breed, the CSIRO bred Sahiwal and Red Sindhi cattle from Pakistan with Jersey cattle. Some Illawarra, Guernsey and Friesian genetics were also included.[1] The development of the breed was governed by strict selection for heat tolerance, milk production and cattle tick (Boophilus microplus) resistance to result in the modern AMZ breed.<br/>' +
			'<br/>' +
			'AMZ cattle have the color, markings and general shape of Jersey cattle, but also show their Sahiwal and Red Sindhi ancestry with their loose skin.<br/>' +
			'<br/>' +
			'Cows produce approximately 2,700 kg of milk per lactation.',
		region: 'Australia',
		image: 'australian_milking_zebu.jpg',
	},
	{
		name: 'Australian Shorthorn',
		description: '',
		region: 'Australia',
		image: '',
	},
	{
		name: 'Austrian Simmental',
		description: '',
		region: 'Austria',
		image: '',
	},
	{
		name: 'Austrian Yellow',
		description: '',
		region: 'Austria',
		image: '',
	},
	{
		name: 'Avetonou',
		description: '',
		region: 'Togo',
		image: '',
	},
	{
		name: 'Avileña',
		description: '',
		region: 'Spain',
		image: 'avilena.jpg',
	},
	{
		name: 'Avilena-Black Iberian',
		description: '',
		region: 'Spain',
		image: 'avilena2.jpg',
	},
	{
		name: 'Aweil Dinka',
		description: '',
		region: 'South Sudan',
		image: '',
	},
	{
		name: 'Ayrshire',
		description: 'Ayrshire cattle (IPA /ˈɛərʃər/) are a breed of dairy cattle from Ayrshire in southwest Scotland. The adult Ayrshire cow weighs from 450 to 600 kilograms (990–1,320 lb). Ayrshires typically have red and white markings; the red can range from a shade of orange to a dark brown. They are known for their hardiness and their ability to convert grass into milk efficiently. The breed\'s strengths today are traits of easy calving and longevity.',
		region: 'Scotland',
		image: 'ayrshire.jpg',
	},
	{
		name: 'Azaouak cattle',
		description: '',
		region: 'Mali',
		image: '',
	},
	{
		name: 'Azebuado',
		description: '',
		region: 'Brazil',
		image: '',
	},
	{
		name: 'Azerbaijan Zebu',
		description: '',
		region: 'Azerbaijan',
		image: '',
	},
	{
		name: 'Azores',
		description: '',
		region: 'Portugal',
		image: '',
	},
	{
		name: 'Bachaur cattle',
		description: 'Bachaur is a breed of cattle native to India.[1][2] The districts of Madhubani, Darbhanga and Sitamarhi in north Bihar form the native tract of this breed. The animals are compact and small in size, and exhibit close similarity with Haryanvi cattle. The bulls are used for medium draft works and are adopted for pace.[3] The cows are better milk yielders compared to other draught breeds of India and are well known for their regular breeding cycle.[4] The cattle were reportedly widely popular in Bihar during the days of the English East India Company.',
		region: 'India',
		image: '',
	},
	{
		name: 'Baherie cattle',
		description: 'The Baherie cattle is a breed of cattle found on the coast of the Massawa region in eastern Eritrea. They have been called Bahari, meaning cattle from the sea/ocean, or Berbera, meaning cattle from Somalia or Aden of Yemen. These alternative names suggest recent origins of the cattle from the Arabian peninsula and a close relationship with the cattle of Somalia. They are in the Somali Shorthorned zebu subgroup. They are small with short horns; coat color varies from fawn to reddish brown.[1] They are used for their milk and their meat.',
		region: 'Eritrea',
		image: '',
	},
	{
		name: 'Bakosi cattle',
		description: 'Bakosi Cattle, also known as Bakuri or Kosi, are a Savannah Shorthorn breed of cattle in Cameroon maintained by the ethnic group Bakossi. They are found in the south-western mountains of Cameroon, west of the Nkongsamba on the border between the Southwest region and Littoral provinces. They are used for their meat, hides, payment of bride price and rituals.[1] Their coats vary from black to white but more than half are brown or black. Their calving interval is between 18 and 24 months.',
		region: 'Cameroon',
		image: '',
	},
	{
		name: 'Balancer cattle',
		description: 'Balancer are a hybrid breed of beef cattle, a combination of Gelbvieh and Angus. These cattle are bred for their hybrid vigour, resulting in a higher growth rate and better quality meat.',
		region: 'United States',
		image: '',
	},
	{
		name: 'Baoule',
		description: 'The Baoule (also known as Lobi or Mere) is a breed of Savannah Shorthorn cattle found in north and central Ivory Coast and the southern tip of Mali.[1] They are found in pure form in Bouaké, Bouna, and Dabakala. They are mostly kept by Fula herdsmen. They are dwarf animals with cows being 90–100 cm, and bulls being 100–110 cm.[2] They have a massive head and short, stout horns with a short neck that is thin in cows and heavy in bulls. Their bodies are well rounded with a straight back-line. The tail-head is high and thick, and their coat color varies from mostly black to black pied.[1] They produce 120–390 kg of milk in a lactation period lasting 280–340 days. The dressing percentage of a Baoule carcass is 50%.[2] There were 350,000 of them in 1985.',
		region: 'Ivory Coast',
		image: '',
	},
	{
		name: 'Bargur Cattle',
		description: 'Bargur (Tamil: பர்கூர் / Kannada: ಬರಗೂರು) is a breed of cattle native to the Bargur forest hills in Anthiyur Taluk of Erode District in Western Tamil Nadu in India.[1] The cattle are usually moderate and compact in build and have brown skin with white patches, though full white and brown complexions are sometimes found.[2] They are known to be very aggressive and of fiery disposition, and hence difficult to train. Accustomed to forest hills of the rugged and inhospitable forests of the Western Ghats, they are best known for their endurance, speed and trotting ability. Their milk is thought to be of medicinal value.[citation needed] They have been usually reared in herds exclusively by the Kannada-speaking Lingayats of the Bargur region.',
		region: 'India',
		image: 'bargur.jpg',
	},
	{
		name: 'Barrosã Cattle',
		description: 'The Barrosã is a cattle breed from Portugal. The Barrosã breed has the protected geographical status of DOC (Denominação de Origem Controlada) from the European Commission.',
		region: 'Portugal',
		image: 'barrosa_cattle.jpg',
	},
	{
		name: 'Barzona',
		description: 'The Barzona are a breed of beef cattle, developed in the United States, in the high desert, inter-mountain region of Arizona in the 1940s and 1950s.[1] They are, in approximately equal proportions, a combination of Africander, Hereford, Beef Shorthorn and Angus. They have been bred to be especially hardy, having good heat, insect and disease tolerance.',
		region: 'United States',
		image: '',
	},
	{
		name: 'Bazadaise',
		description: 'The Bazadaise or Grise de Bazas is a French breed of beef cattle. It takes its name from the town of Bazas in the département of the Gironde, in the Nouvelle-Aquitaine region of south-western France, and originates in the low-lying areas to the south of the River Garonne near that town.[4]:124 A festival, the Fête des Boeufs Gras, is held each year in Bazas to present fattened Bazadaise stock.',
		region: 'France',
		image: 'bazadaise.jpg',
	},
	{
		name: 'Beef Freisian',
		description: '',
		region: 'United States',
		image: '',
	},
	{
		name: 'Beefalo',
		description: 'Beefalo, are 3/8 Bison and 5/8 Bovine, a fertile hybrid offspring of domestic cattle (Bos taurus), usually a male in managed breeding programs, and the American bison (Bison bison), usually a female in managed breeding programs.[1][2] The breed was created to combine the characteristics of both animals for beef production.<br/>' +
			'<br/>' +
			'Beefalo are primarily cattle in genetics and appearance, with the breed association defining a full Beefalo as one with three-eighths (37.5%) bison genetics, while animals with higher percentages of bison genetics are called "bison hybrids".',
		region: 'United States',
		image: 'beefalo.jpg',
	},
	{
		name: 'Beefmaker',
		description: '',
		region: 'United States',
		image: '',
	},
	{
		name: 'Beefmaster',
		description: 'Beefmaster is a breed of beef cattle that was developed in the early 1930s by Tom Lasater (the breed founder), after his father Ed c. Lasater created the breed, from a crossing of Hereford cows and Shorthorn cows with Brahman bulls. The exact mixture of the foundation cattle is unknown, but is thought to be about 25% Hereford, 25% Milking Shorthorn and 50% Brahman. It was first recognized by the USDA as a new breed in 1954.[1] The original intention was to produce cattle that could produce economically in the difficult environment of South Texas. The cattle were selected by using the Six Essentials – weight, conformation, milking ability, fertility, hardiness and disposition. Though there are no standards for color, most are red to light red, with white mottled spots. Over the past decade black Beefmaster have become very popular among herd managers using the breed in their heterosis programs for hybrid vigor. These cattle are a versatile, multipurpose breed, meaning that they can be used for milk as well as beef.',
		region: 'United States',
		image: '',
	},
	{
		name: 'Begayt',
		description: 'Ethiopia has been at a crossroads for cattle immigration to Africa due to'+
			'    proximity to the geographical entry of Indian and Arabian zebu<br/>' +
			'    proximity to Near-Eastern and European taurine<br/>' +
			'    introgression with West African taurine due to pastoralism<br/>' +
			'<br/>' +
			'Furthermore, the diverse agro-ecology led to diverse farming systems which, in turn, made Ethiopia a centre of secondary diversiﬁcation for livestock :<br/>' +
			'<br/>' +
			'    The Sanga cattle originated in Ethiopia. They are a major bovine group in Africa – a cross-breeding of local long-horned taurines and Arabian zebus<br/>' +
			'    The Begayt are one of the Zenga (Zebu-Sanga) breeds, which resulted from a second introduction and crossing with Indian zebu',
		region: 'Ethiopia',
		image: '',
	},
	{
		name: 'Belgian Blue',
		description: 'The Belgian Blue (French: \'Blanc-Bleu Belge\', Dutch: \'Belgisch Witblauw\') is a breed of beef cattle from Belgium.[1] It may also be known as the Race de la Moyenne et Haute Belgique.[2]:95 Alternative names for this breed include Belgian Blue-White; Belgian White and Blue Pied; Belgian White Blue; Blue; and Blue Belgian.[3] The Belgian Blue\'s extremely lean, hyper-sculpted, ultra-muscular physique is termed "double-muscling". The double-muscling phenotype is a heritable condition resulting in an increased number of muscle fibers (hyperplasia), instead of the (normal) enlargement of individual muscle fibers (hypertrophy).[4]<br/>' +
			'<br/>' +
			'This particular trait is shared with another breed of cattle known as Piedmontese. Both of these breeds have an increased ability to convert feed into lean muscle, which causes these particular breeds\' meat to have a reduced fat content and reduced tenderness.[5] The Belgian Blue is named after their typically blue-grey mottled hair colour; however, its actual colour can vary from white to black. ',
		region: 'Belgium',
		image: 'belgian_blue.jpg',
	},
	{
		name: 'Belgian Red',
		description: 'The Belgian Red (known in Dutch as Rood West-Vlaams, literally "Red West-Flemish") is a cattle breed from Flanders in Belgium. It is considered in danger of extinction.',
		region: 'Belgium',
		image: 'belgian_red.png',
	},
	{
		name: 'Belgian Red Pied',
		description: '',
		region: 'Belgium',
		image: '',
	},
	{
		name: 'Belgian White-and-red',
		description: '',
		region: 'Belgium',
		image: 'belgian_white_and_red.png',
	},
	{
		name: 'Belmont Red',
		description: 'Belmont Red is a breed of beef cattle developed by the Commonwealth Scientific and Industrial Research Organisation (CSIRO) during 1954 in response to the need in the Australian Tropics for cattle which would improve the fertility of Bos indicus cattle. The breed was conceived at Belmont Research Station as a composite from several Bos taurus breeds: Africander (African Sanga), Hereford and Shorthorn. The breed was released to Australian breeders by the CSIRO in 1969.<br/>' +
			'<br/>' +
			'Selected traits were higher fertility, high resistance to ticks, superior heat tolerance, good growth, better meat quality, a placid temperament, and feed efficiency on grass or in the feedlot.<br/>' +
			'<br/>' +
			'Rigid selection for these traits of economical importance has resulted in the evolution of well adapted cattle to both a tropical and temperate environment.<br/>' +
			'<br/>' +
			'Large commercial herds running on native pastures in both Queensland and the Northern Territory have calving rates above 90% achieved in large breeder groups containing 5,000 head.<br/>' +
			'<br/>' +
			'Belmont Reds have achieved many wins and placings in Carcass competitions.',
		region: 'Australia',
		image: 'belmont_red.jpg',
	},
	{
		name: 'Belted Galloway',
		description: 'The Belted Galloway is a traditional Scottish breed of beef cattle. It derives from the Galloway cattle of the Galloway region of south-western Scotland, and was established as a separate breed in 1921. It is adapted to living on the poor upland pastures and windswept moorlands of the region. The exact origin of the breed is unclear, although the white belt for which they are named – and which distinguishes the breed from the native black Galloway cattle – is often surmised to be the result of cross-breeding with the similarly-coloured Dutch Lakenvelder breed.<br/>' +
			'<br/>' +
			'Belted Galloways are primarily raised for their quality marbled beef, although they are sometimes milked or kept for ornament. ',
		region: 'Scotland',
		image: 'belted_galloway.jpg',
	},
	{
		name: 'Bernese',
		description: '',
		region: 'Switzerland',
		image: '',
	},
	{
		name: 'Berrenda cattle',
		description: 'The Berrenda is a type of cattle from the Spanish region of Andalusia. It is subdivided into two breeds; the Red Berrenda and the Black Berrenda. Both breeds are rustic and very well adapted to the environment.',
		region: 'Spain',
		image: 'berrendo_cattle.jpg',
	},
	{
		name: 'Betizu',
		description: 'The Betizu is a breed of small mountain cattle which live in a semi-feral state in some mountainous parts of the Basque Country in both Spain and France. It is classified as an endangered breed by both the Ministerio de Agricultura, Pesca y Alimentación, the agriculture ministry of Spain,[4][5] and by the Conservatoire des Races d\'Aquitaine in France.[6]<br/>' +
			'<br/>' +
			'It is one of a small number of semi-feral cattle populations in Europe, with the Albera of the Pyrenees, the Monchina of Cantabria, and the Raço di Biòu of the Camargue.',
		region: 'Spain/France',
		image: 'betizu.jpg',
	},
	{
		name: 'Bianca Val Padana',
		description: '',
		region: 'Italy',
		image: '',
	},
	{
		name: 'Blaarkop',
		description: 'Blaarkop is a breed of dairy cattle. Blaarkop is Dutch for blister head. Its main breeding area is in Groningen (province), Netherlands.<br/>' +
			'<br/>' +
			'The breed has been mentioned as early as the 14th century. From the 19th century, there are also Blaarkoppen in the Utrecht and Leiden regions. The Blaarkop breed is sturdily built with matching muscles, a horned head, and strong legs. Both red (60% of the population) and black (40%) Blaarkoppen exist. The body is solid red or black, while the head is white with a red or black ring (blister) around the eyes; the tail has a white tip.<br/>' +
			'<br/>' +
			'Bulls are 1.45 to 1.50 m high and weigh 800 kg.<br/>' +
			'Cows are 1.35 to 1.40 m high and weigh 600 kg.<br/>' +
			'The average milk production is 6000 kg, with 4.35% butterfat and 3.60% protein. ',
		region: 'Netherlands',
		image: 'blaarkop.jpg',
	},
	{
		name: 'Black Angus',
		description: 'The Aberdeen Angus, sometimes simply Angus, is a Scottish breed of small beef cattle. It derives from cattle native to the counties of Aberdeenshire and Angus in north-eastern Scotland.[1]<br/>' +
			'<br/>' +
			'The Angus is naturally polled and solid black or red, though the udder may be white. The native colour is black, but more recently red colours have emerged.[2] The United Kingdom registers both in the same herd book, but in the United States they are regarded as two separate breeds: Red Angus and Black Angus. Black Angus is the most common breed of beef cattle in the US, with 332,421 cattle registered in 2017.[3] In 2014, the British Cattle Movement Service named Angus the UK\'s most popular native beef breed, and the second most popular beef breed overall.',
		region: 'Scotland',
		image: 'blackangus.jpg',
	},
	{
		name: 'Black Baldy',
		description: 'Black Baldy is a type of crossbred beef cattle produced by crossing Hereford cattle with a solid black breed, usually Aberdeen Angus. Angus bulls are also used on Hereford heifers in an attempt to produce smaller calves and reduce dystocia. The term is particularly used in Australia and New Zealand. In North America, the term "Black Whiteface" is also used in some regions.<br/>' +
			'<br/>' +
			'It is characterized by a white face similar to the Hereford, but the red body color of the Hereford is replaced by black from the Angus. This is because both the alleles for white faces and black coat color are both genetically dominant in cattle.<br/>' +
			'<br/>' +
			'Black Baldy cows are noted for their good mothering abilities. In addition to general hybrid vigor expected with a crossbred, the cross also produces black skin, which in sunny climates reduces the prevalence of sunburn on bare skin, such as the udder of the cow.<br/>' +
			'<br/>' +
			'The prevalence of Black Baldies significantly increases wherever cattle breeders switch from the traditional Hereford herds to the Aberdeen Angus breed.<br/>' +
			'<br/>' +
			'A cross of Hereford cattle on predominantly black-colored dairy breeds results in a similarly-marked crossbred called the Black Hereford in the British Isles. ',
		region: 'Australia',
		image: 'black_baldy.jpg',
	},
	{
		name: 'Black Hereford',
		description: 'The Black Hereford is a beef cattle breed, derived mainly from Hereford cattle (normally red and white), but with some mixture from black Angus cattle, resulting in black cattle with a white head and finching.',
		region: 'England',
		image: 'black_hereford.jpg',
	},
	{
		name: 'Blanca Cacereña',
		description: '',
		region: 'Spain',
		image: '',
	},
	{
		name: 'Blanco Orejinegro BON',
		description: '',
		region: 'Colombia',
		image: '',
	},
	{
		name: 'Blonde d\'Aquitaine',
		description: 'The Blonde d\'Aquitaine is a modern French breed of large domestic beef cattle. It was created in 1962 by merging three blonde draught breeds of south-western France, the Blonde des Pyrénées, the Blonde de Quercy and the Garonnaise.[3][4]:129 Since about 1970 it has been selectively bred specifically for beef production. It is the third-most numerous beef breed of France, after the Charolais and the Limousin. It has been exported to many countries round the world.',
		region: 'France',
		image: 'blonde_aquitaine.jpg',
	},
	{
		name: 'Blue Albion',
		description: 'The Blue Albion was a British breed of cattle that originated in the English Midlands. They were a multi-purpose breed, with potential in meat production alongside milk production. The breed became extinct in 1967 due to a foot-and-mouth outbreak and the subsequent culling required to get the disease under control.',
		region: 'Great Britain',
		image: '',
	},
	{
		name: 'Blue Grey',
		description: 'Blue Grey is a type of beef cattle popular in Scotland and the north of England.<br/>' +
			'<br/>' +
			'It is traditionally produced by crossing a Whitebred Shorthorn bull with black Galloway cows. The offspring gain beefiness from their sire and hardiness from their upland dams, and their colour is a blue roan which is regarded as attractive by many farmers.<br/>' +
			'<br/>' +
			'Due to the genetic origin of roan colouration in cattle, this colour does not breed true. This is because roan is the result of incomplete dominance between white and solid colour. Roan is produced consistently only in the first-generation cross between these. On average only half of the offspring of two blue roan cattle will be blue roan themselves, with the other half being either solid white or solid black.<br/>' +
			'<br/>' +
			'The Blue Grey cross became so popular that a special type of Shorthorn was developed to produce white Shorthorn bulls – the Whitebred Shorthorn.<br/>' +
			'<br/>' +
			'They are well-suited for rough grazing land and will utilize coarse grasses other breeds would shun. They are able to maintain good condition on less than ideal pasture and do not graze so intensively as sheep.',
		region: 'Great Britain',
		image: 'blue_grey.jpg',
	},
	{
		name: 'Bohus Polled',
		description: '',
		region: 'Sweden',
		image: '',
	},
	{
		name: 'Bonsmara',
		description: 'The Bonsmara is a breed of cattle known for its high quality beef and resistance to local diseases. Originating in South Africa as a scientific experiment of professor Jan Bonsma, the Bonsmara was created after many cross matings and back-crosses consisting of five-eighths Afrikaner (Sanga-type), three-sixteenths Hereford, and three-sixteenths Shorthorn (both taurine types).',
		region: 'South Africa',
		image: 'bonsmara.jpg',
	},
	{
		name: 'Boran',
		description: 'Boran cattle are a popular Zebu beef breed in eastern Africa.[1]<br/>' +
			'<br/>' +
			'Through DNA sampling Hanotte et al. have analyzed the genetic make-up of the Boran and it consists of the following genetic proportions:[2][3]<br/>' +
			'<br/>' +
			'● European Bos Taurus - 24% ● Bos Indicus - 64% ● African Bos Taurus - 12% ',
		region: 'eastern Africa',
		image: 'boran.jpg',
	},
	{
		name: 'Boškarin',
		description: '',
		region: 'Croatia, Slovenia',
		image: '',
	},
	{
		name: 'Braford',
		description: 'The Braford is a cross between a Hereford bull and a Brahman cow. Conversely, it can also be a cross between a Brahman bull and a Hereford cow. The make up of the Braford is 3/8 Brahman and 5/8 Hereford. Even though a true Braford meets those standards, 1/2 Brahman and 1/2 Hereford cross are known as F1 Brafords or F1 Baldies. They carry the characteristics of both parents. The Braford is red like a Hereford with white underbelly, head, and feet. It is stockier than a Hereford, though, getting the stockiness from the Brahman.<br/>' +
			'<br/>' +
			'The Braford is primarily used for beef, but sometimes used for rodeo. Brafords were developed both in Australia in 1946 and in Florida in 1947.<br/>' +
			'<br/>' +
			'Brafords have heat and insect resistance because of the increased number of sweat glands and oily skin inherited from their Brahman heritage. They have been known to be of an ornery disposition, though this may be due to their raising, any predisposition toward being difficult is still a subject of debate. They are often used in Rodeos due to their massive bulk and bone density, hardiness, heat endurance, and arguably their ornery disposition. They do well in warm climates though they have been raised in northern climates and seem to do well there as well, likely due to their great bulk.',
		region: 'United States',
		image: '',
	},
	{
		name: 'Brahman',
		description: 'The Brahman is an American breed of zebuine beef cattle. It was bred in the United States from 1885 from cattle Kankrej, originating in India, imported at various times from the United Kingdom, from India and from Brazil; these included Gir, Guzerá, Indu-Brasil and Ongole stock. The Brahman has a high tolerance of heat, sunlight and humidity, and good resistance to parasites. It has been exported to many countries, particularly in the tropics; in Australia it is the most numerous breed of cattle. It has been used in the creation of numerous taurine-indicine hybrids, some of which – such as the Brahmousin – are established as separate breeds.',
		region: 'India',
		image: 'brahman.jpg',
	},
	{
		name: 'Brahmousin',
		description: '',
		region: 'United States',
		image: '',
	},
	{
		name: 'Brangus',
		description: 'Brangus is a hardy and popular breed of beef cattle, a cross between an Angus and a Brahman. Animals eligible for registration as Brangus cattle are 5/8 Angus and 3/8 Brahman. Brangus is a registered trademark of the International Brangus Breeders Association (IBBA).',
		region: 'United States',
		image: 'brangus.jpg',
	},
	{
		name: 'Braunvieh',
		description: 'Braunvieh (German, "brown cattle") is a breed or group of breeds of domestic cattle originating in Switzerland and distributed throughout the Alpine region. The Braunvieh was originally a triple-purpose breed, used for milk production, for meat and for draught work; the modern Braunvieh is predominantly a dairy breed.',
		region: 'Switzerland',
		image: 'braunvieh.jpg',
	},
	{
		name: 'Brava',
		description: 'The Brava or Race de Combat is a French breed of domestic cattle raised in the Camargue, the delta of the Rhône in southern France. It is bred specifically for bull-fighting, either Spanish-style (on foot) or Portuguese-style (on horseback). It is one of two cattle breeds raised in semi-feral conditions in the Camargue: the other is the Raço di Biòu or Camargue breed, which is not a fighting breed but is used in a bloodless bull-sport, the course camarguaise. The Brava derives from Iberian fighting cattle imported in the nineteenth century, and may also be known as the Espagnole Brava.',
		region: 'Spain',
		image: '',
	},
	{
		name: 'British White',
		description: 'The British White is a naturally polled British cattle breed, white with black or red points, used mainly for beef. It has a confirmed history dating back to the 17th century.',
		region: 'Great Britain',
		image: 'british_white.jpg',
	},
	{
		name: 'British Friesian',
		description: 'While interest in increasing production through indexing and lifetime profit scores had a huge increase in Holstein bloodlines in the UK, proponents of the traditional British Friesian did not see things that way, and maintain these criteria do not reflect the true profitability or the production of the Friesian cow.<br/>' +
			'<br/>' +
			'Friesian breeders say modern conditions in the UK, similar to the 1950s through to the 1980s, with low milk price and the need for extensive, low-cost systems for many farmers, may ultimately cause producers to re-examine the attributes of the British Friesian.<br/>' +
			'<br/>' +
			'This animal came to dominate the UK dairy cow population during these years, with exports of stock and semen to many countries throughout the world. Although the idea of "dual-purpose" animals has arguably become outmoded, the fact remains that the Friesian is eminently suitable for many farms, particularly where grazing is a main feature of the system.<br/>' +
			'<br/>' +
			'Proponents argue that Friesians last for more lactations through more robust conformation, thus spreading depreciation costs. An added advantage of income from the male calf exists, which can be placed into barley beef systems (finishing from 11 months) or steers taken on to finish at two years, on a cheap system of grass and silage. Very respectable grades can be obtained, commensurate with beef breeds, thereby providing extra income for the farm.<br/>' +
			'<br/>' +
			'Such extensive, low-cost systems may imply lower veterinary costs, through good fertility, resistance to lameness, and a tendency to higher protein percentage, and, therefore, higher milk price. An 800-kg Holstein has a higher daily maintenance energy requirement than the 650-kg Friesian.<br/>' +
			'<br/>' +
			'Friesians have also been disadvantaged through the comparison of their type to a Holstein base. A separate "index" be composed to greater has been suggested to reflect the aspects of maintenance for bodyweight, protein percentage, longevity, and calf value. National Milk Records figures suggest highest yields are achieved between the fifth and seventh lactations; if so, this is particularly so for Friesians, with a greater lift for mature cows, and sustained over more lactations. However, production index only takes the first five lactations into account. British Friesian breeding has certainly not stood still, and through studied evaluation, substantial gains in yield have been achieved without the loss of type.',
		region: 'Great Britain',
		image: 'british_friesian.jpg',
	},
	{
		name: 'Brown Carpathian',
		description: 'The Brown Carpathian (Ukrainian: бypa кapпaтськa) is a breed of cattle from Western Ukraine. Found in the Trans-Carpathian region of Ukraine, the breed was the result of crossing Brown Swiss with the local cattle to produce a dual-purpose breed for dairy and beef production.[1][2] The breed was first recognized in 1972, and since the 1980s there have been further crossings with Brown Swiss and Jersey bulls.',
		region: 'Ukraine',
		image: '',
	},
	{
		name: 'Brown Caucasian',
		description: 'The Brown Caucasian is a cattle breed from the Caucasus (Armenia, Georgia, Azerbaijan and Dagestan (Russia)). Found in the Caucasus region the breed is the result of crossing Brown Swiss and Kostroma cattle onto the local cattle to produce a variable breed depending on the local stock, with strains for dairy and dairy-beef production.',
		region: 'Armenia',
		image: 'brown_caucasian.png',
	},
	{
		name: 'Brown Swiss',
		description: 'The Brown Swiss or American Brown Swiss is an American breed of dairy cattle. It derives from the traditional triple-purpose Braunvieh of the Alpine region of Europe, but has diverged substantially from it. It was selectively bred for dairy qualities only, and its draft and beef capabilities were lost. Milk yield was measured in 2013 at 10231 kg (22600 lb) per year;[2]:142 the milk has about 4% butterfat and 3.5% protein[3] and is suitable for making cheese.<br/>' +
			'<br/>' +
			'In the twentieth century the Brown Swiss became a world breed, with a global population estimated in 1990 at seven million head. It has been much used for cross-breeding[2]:142 and has influenced a number of modern breeds.',
		region: 'Switzerland',
		image: 'brown_swiss.jpg',
	},
	{
		name: 'Bue Lingo',
		description: 'The Buelingo is a modern American composite breed of belted beef cattle. It was created in North Dakota, in the United States, in the 1970s, and is named for one of the breeders, Russ Bueling. The hybridisation started from animals of Angus and Shorthorn type, which were crossed with Limousin and a Dutch Belted bull to fix the gene for belting; this was purely for appearance.[1]:68 Chianina blood was later added to improve the composite breed.[1]:68 In 1989 a breed society, the Buelingo Beef Cattle Society, was started.[1]:68<br/>' +
			'<br/>' +
			'The breed is noted for the following;<br/>' +
			'<br/>' +
			'Excellent quality and lean marbling<br/>' +
			'<br/>' +
			'Good maternal characteristics<br/>' +
			'<br/>' +
			'Fertility<br/>' +
			'<br/>' +
			'Docility<br/>' +
			'<br/>' +
			'Small Calving weights',
		region: 'United States',
		image: '',
	},
	{
		name: 'Burlina',
		description: 'The Burlina is a breed of cattle from the mountainous areas of the Veneto region of north-east Italy.[4]:144 It is distributed mainly in the provinces of Treviso, Verona and Vicenza.[5]:12 It is a dual-purpose breed, but is raised principally for milk production.[3][6] It has been suggested that it may be related to the similar Bretonne Pie Noir breed of small pied dairy cattle in Brittany.',
		region: 'Italy',
		image: '',
	},
	{
		name: 'Buša cattle',
		description: 'The Buša cattle (or also Busha; Bos brachyeros europeus[1]) is a small native breed of cattle with numerous strains found throughout southern parts of former Yugoslavia (Dinaric Alps). It belongs to the group of the shorthorn cattle.',
		region: 'former Yugoslavia (Dinaric Alps)',
		image: 'busa_cattle.jpg',
	},
	{
		name: 'Butana',
		description: 'Butana and Kenana breeds are part of the shorthorned Zebu group of breeds of eastern Africa. What makes them unusual is that they are dairy breeds, unlike other breeds like the Boran, Baggara, Fung, etc. The Butana breed is found to the east of Khartoum in central Sudan, in the Butana region. The Atbarah Research Station of the Sudanese Department of Agriculture in Atbarah has a special mission for preserving and improving the Butana breed. The Kenana breed is found just south of Butana, mainly in the region between the Blue Nile and the White Nile.',
		region: 'Sudan',
		image: '',
	},
	{
		name: 'Bushuyev',
		description: 'Bushuyev cattle (Russian: Бушуевская, romanized: Bushuyevskaya) are a cattle breed from Uzbekistan. They originated from cross breeding indigenous zebu cattle with western European dairy breeds. They are white coated with black spots, black ears and rims around eyes, and a black band around the muzzle.',
		region: 'Uzbekistan',
		image: '',
	},
	{
		name: 'Cachena Cattle',
		description: 'Cachena cattle is a triple-purpose breed from Portugal and Galicia, Spain. In Portugal, there is also the similar but larger cattle breed known by the name, Barrosão or Barrosã. Cachena and Barrosã are sometimes considered variants of the same race.',
		region: 'Portugal/Spain',
		image: 'cachena_cattle.jpg',
	},
	{
		name: 'Caldelana',
		description: '',
		region: 'Spain',
		image: '',
	},
	{
		name: 'Camargue',
		description: 'The Camargue is a breed of domestic cattle native to the Camargue marshlands of the river delta of the Rhône in southern France. It used for the traditional sport of course camarguaise, a kind of bloodless bull-fight, but not for the corrida, Iberian-style bull-fighting. It is one of two cattle breeds raised in semi-feral conditions in the Camargue; the other is the Brava or Race de Combat, a fighting breed. Since 1996 it has been officially known as the Provençal: Raço di Biòu.',
		region: 'France',
		image: 'camargue.jpg',
	},
	{
		name: 'Campbell Island Cattle',
		description: 'Campbell Island cattle were a feral breed of domestic cattle (Bos taurus) found on Campbell Island, New Zealand. From photographs taken in 1976 it appeared that the cattle were at least partly of shorthorn origin. This breed is now extinct.',
		region: 'New Zealand',
		image: '',
	},
	{
		name: 'Canadian Speckle Park',
		description: 'The Canadian Speckle Park is a breed of cattle native to the Canadian province of Saskatchewan. It is one of only a few beef cattle breeds developed in Canada. The latter half of the breed\'s name derives from the characteristic white, black and grey spots and patches of color that it is known for.<br/>' +
			'<br/>' +
			'The Canadian Speckle Park is one of the newest cattle breeds, having been officially recognized by the Canadian government in 2006. A breed association was formed in 1985, and exports of Canadian Speckle Park to the U.S. and Australia have occurred.<br/>' +
			'<br/>' +
			'Work on breeding the Canadian Speckle Park began in the 1950s with the crossing of a roan Shorthorn heifer to a Black Angus bull. The spotting became a dominant trait in the offspring, and the beginnings of a new breed emerged. Descended solely from British beef breeds, it is naturally polled and inherits many of the characteristics of popular cattle like the Angus.',
		region: 'Canada',
		image: 'canadian_speckle_park.jpg',
	},
	{
		name: 'Canadienne',
		description: 'Canadienne cattle, also known as Black Canadienne, French Canadienne, and Black Jersey, are the only breed of dairy cattle developed in Canada. They originated in the 16th century, when French settlers brought cattle over for foundation stock to settle Canada. The Canadienne were the most common breed of domestic cattle in Canada until the late 19th century, when other breeds began to displace them. Today, the Hereford and Holstein have become the most common types of cattle in Canada. The Canadienne, though still found on farms and ranches across the nation, is now comparatively rare except in certain areas of the province of Quebec. Efforts by an active breed society and the Quebec government have been made in recent years to preserve the breed from extinction.',
		region: 'Canada',
		image: 'canadienne_heifer.jpg',
	},
	{
		name: 'Canaria',
		description: '',
		region: 'Spain',
		image: '',
	},
	{
		name: 'Canchim',
		description: 'The Canchim is a breed of beef cattle developed in Central Brazil by crossing European Charolais cattle with Indubrazil cattle already kept in Brazil where Asian Zebu type cattle are best suited to the tropical conditions. When compared with Zebu bulls, Canchim bulls produce the same number of calves, but heavier and of superior quality. Compared to European breeds, the Canchim bull produces calves with the same weight but in larger numbers. The fast-growing progeny, from crossbred zebu cows with Canchim bulls, can be slaughtered at 18 months old from feedlots after weaning, up to 24 months old from feedlots after grazing and at 30 months from grazing on the range.',
		region: 'Brazil',
		image: 'canchim.jpg',
	},
	{
		name: 'Caracu',
		description: 'Caracu is a Brazilian dual purpose (beef and dairy) cattle breed known for its adaptability, hardiness and excellent maternal ability. .[1][2] Like the Mocho Nacional, the Caracu is a tropical European breed created in Brazil and its origin is of the race Minhota.[3] Its main use is as a cross to beef cattle. The Caracu accounts for less than 5% of Brazilian beef cattle; the Nelore breed is by far the predominant breed in Brazil.',
		region: 'Brazil',
		image: 'caracu.jpg',
	},
	{
		name: 'Cárdena Andaluza',
		description: '',
		region: 'Spain',
		image: '',
	},
	{
		name: 'Carinthian Blondvieh',
		description: 'Carinthian Blondvieh (German: Kärntner Blondvieh) is an old cattle breed that is native to Carinthia in Austria.',
		region: 'Austria',
		image: 'carinthian_blondvieh.jpg',
	},
	{
		name: 'Carora',
		description: 'The Tipo Carora[2] or Carora is a Venezuelan breed of dairy cattle. It was bred in the early part of the twentieth century by artificial insemination of local Criollo cows with imported semen from Brown Swiss bulls.[3][4] It is named for its place of origin, the town of Carora in the Venezuelan state of Lara.',
		region: 'Venezuelan',
		image: '',
	},
	{
		name: 'Chinese Central Plains Yellow',
		description: '',
		region: 'China',
		image: '',
	},
	{
		name: 'Charbray',
		description: '',
		region: 'United States',
		image: '',
	},
	{
		name: 'Charolais',
		description: 'The Charolais (French pronunciation: ​[ʃaʁɔlɛ]) or Charolaise is a French breed of taurine beef cattle. It originates in, and is named for, the Charolais area surrounding Charolles[2], in the département of Saône-et-Loire, in the Bourgogne-Franche-Comté region of eastern France. Charolais are raised for meat; they may be crossed with other breeds, including Angus and Hereford cattle.',
		region: 'France',
		image: 'charolaise.jpg',
	},
	{
		name: 'Chateaubriand',
		description: '',
		region: '—',
		image: '',
	},
	{
		name: 'Chiangus',
		description: '',
		region: '—',
		image: '',
	},
	{
		name: 'Chianina',
		description: 'The Chianina (Italian pronunciation: [kjaˈniːna])[3] is an Italian breed of cattle, formerly principally a draught breed, now raised mainly for beef. It is the largest and one of the oldest cattle breeds in the world.[4] The famous bistecca alla fiorentina is produced from its meat.',
		region: 'Italy',
		image: 'chianina.jpg',
	},
	{
		name: 'Chillingham Cattle',
		description: 'Chillingham cattle, also known as Chillingham wild cattle, are a breed of cattle that live in a large enclosed park at Chillingham Castle, Northumberland, England. In 2009 the cattle were described as "about 90 animals in Chillingham, which inhabit a very large park that has existed since the Middle Ages".[1] The herd has remained remarkably genetically isolated for hundreds of years, surviving despite inbreeding depression due to the small population.[2] There is also a small reserve herd of about 20 animals located on Crown Estate land near Fochabers, North East Scotland.',
		region: 'England',
		image: 'chillingham_cattle.jpg',
	},
	{
		name: 'Chinese Black Pied',
		description: 'The Chinese Black Pied or Chinese Black and White[2] is a Chinese breed of dairy cattle. It derives from cross-breeding with local cows of black and white dairy cattle of various breeds imported since the 1870s from Canada, Germany, Japan, the Netherlands, the United Kingdom and the United States. It is the most numerous dairy breed in China and is distributed throughout the country.',
		region: 'China',
		image: '',
	},
	{
		name: 'Cholistani',
		description: '',
		region: 'Pakistan',
		image: '',
	},
	{
		name: 'Coloursided White Back',
		description: '',
		region: '—',
		image: '',
	},
	{
		name: 'Commercial',
		description: '',
		region: '—',
		image: '',
	},
	{
		name: 'Corriente Cattle',
		description: 'Corriente cattle are a breed of Criollo cattle descended from Spanish animals brought to the Americas as early as 1493.[1] They are primarily used today as sport cattle for rodeo events such as team roping and bulldogging (steer wrestling). Some breeders raise them for their meat, which contains approximately half the fat of the meat from most modern beef cattle.[2]<br/>' +
			'Corrientes are fairly small cattle, with cows averaging well under 1,000 pounds (450 kg). They are lean, athletic, and have long upcurving horns. They are known as "easy keepers," as little human intervention is required in their calving, and they eat significantly less than the big beef cattle. Like other Criollo breeds, the corriente require less water and can live on sparse open range. Corrientes are also known as accomplished escape artists, as they can leap a standard barbed-wire fence and squeeze through fairly small openings.<br/>' +
			'Names for the breed differ. The official breed registry in the United States calls them Corriente cattle, which is the most common term in Northern Mexico. In other parts of Mexico, they are called Criollo or Chinampo cattle. They are closely related to Pineywoods and Florida Cracker cattle, two breeds from the Gulf Coast and Florida.<br/>',
		region: 'Spain',
		image: 'corriente.jpg',
	},
	{
		name: 'Corsican Cattle',
		description: 'Corsican Cattle or Corsicana is a French cattle breed.',
		region: 'Corsica',
		image: 'corsican_cattle.jpg',
	},
	{
		name: 'Costeño con Cuernos',
		description: '',
		region: 'Colombia',
		image: '',
	},
	{
		name: 'Crioulo Lageano',
		description: ' Crioulo Lageano longhorn beef cattle (or "raça Crioula Lageana") originated from cattle originally brought to Brazil from Portugal by the Jesuits (Jesuit Reductions) 400 years ago.[1] The breed was probably domesticated 4000 BC in Egypt, it came to the south of Spain from the North of Africa.[1][2] The center of the rest population (just 700 individuals) is the plateau of Lages, Santa Catarina, Brazil.[2][3][4]<br/>' +
			'<br/>' +
			'It is similar to the Franqueira breed (just 500 individuals, eight to ten farmers in Rio Grande do Sul), with the same origin, which coming from Franca, São Paulo, spread through the Brazilian territory.',
		region: '—',
		image: '',
	},
	{
		name: 'Dajal',
		description: '',
		region: 'Pakistan',
		image: '',
	},
	{
		name: 'Dangi cattle',
		description: 'Dangi (Marathi:डान्ग्गी) is an indigenous cattle breed of India. It originated in the hilly tracts of Dangs comprising the Nasik and Ahmednagar districts in the state of Maharashtra.[1] The breed is medium to large in body size. They are a very good draught breed and known for their adaptability to heavy rainfall areas. The skin of this breed secretes an oil element that enables them to tolerate heavy rains.',
		region: 'India',
		image: 'dangi.jpg',
	},
	{
		name: 'Danish Black-Pied',
		description: '',
		region: '—',
		image: '',
	},
	{
		name: 'Danish Jersey',
		description: 'The Danish Jersey is a breed of cattle developed in Denmark. It is based upon imported Jersey cattle.',
		region: 'Denmark',
		image: '',
	},
	{
		name: 'Danish Red',
		description: 'Danish Red cattle, also known as Red Danish or Red Dane, are a major dairy cattle breed in northern Europe.[1][2] There are 42,599 pedigree cows in Denmark. They can be used as a beef breed once they finish their useful lifetime.',
		region: 'Denmark',
		image: 'danish_red.jpg',
	},
	{
		name: 'Deep Red Cattle',
		description: '',
		region: '—',
		image: '',
	},
	{
		name: 'Deoni',
		description: 'The Deoni is an Indian breed of draught cattle. It is named after the taluk of Deoni in the Latur district of Maharashtra state, and is distributed mainly in the Latur, Nanded, Osmanabad and Parbhani districts of the Marathwada region of Maharashtra,[4]:36 as well as the Bidar district of Karnataka.',
		region: 'India',
		image: 'deoni.jpg',
	},
	{
		name: 'Devon',
		description: 'The Devon is an ancient breed of cattle from the south western English county of Devon.[1] It is a rich red or tawny colour, and this gives rise to the popular appellation of Devon Ruby or Red Ruby, also used as a marketing brand. The breed is also sometimes referred to as the North Devon to avoid confusion with the more recently developed South Devon cattle breed which is yellowish brown.',
		region: 'England',
		image: 'red_devon_bull.jpg',
	},
	{
		name: 'Dexter',
		description: 'Dexter cattle are a breed of cattle originating in Ireland.[1] The smallest of the European cattle breeds, they are about half the size of a traditional Hereford and about one-third the size of a Holstein Friesian milking cow. A rare breed until recently, they are now considered a recovering breed by the Livestock Conservancy.',
		region: 'Ireland',
		image: 'dexter.jpg',
	},
	{
		name: 'Dhanni',
		description: 'Dhanni is a cattle breed originating in Punjab province of Pakistan mainly in Attock, Chakwal, Fatehjang and tehsil Kot Fateh Khan. It is used for dairy, meat, and draught (including ploughing).[1]<br/>' +
			'<br/>' +
			'Dhanni is a medium size light draught breed of cattle. It is characterized with a straight back bearing a big hump, a small face, and short-alerted years. It is found in different color ranges with different spots that can be either black, brown, or red. It has a long tail ending with white switch. Bulls of this breed are known to be having great agility. A male weighs around 400 kg while a female weighs 300 kg. It is mainly a draught breed and frequently seen racing in locally popular bull cart races. A racing bull becomes very precious and sometimes may be sold at five times the price of a regular bull.<br/>' +
			'<br/>' +
			'The milk yield of females are around 1,000 - 1,200 litres.',
		region: 'Pakistan',
		image: 'dhanni.jpg',
	},
	{
		name: 'Doayo cattle',
		description: 'The Doayo cattle is a cattle in found foothills of Atlantika Mountains and Poli mountains in Bénoué division of North province of Cameroon and are also known as Namji, Namchi, Namshi, Poli, Donayo, or M\'Bougi. They are classified as Savannah Shorthorns and are maintained by the Doayo people.[1] They are dwarf animals, measuring only 97 to 110 cm at withers, with mainly uniform black, black-and-white or spotted black coats, though brown or spotted brown coats also occur. The first calving takes place at three years, with a calving interval of one year. The cattle are not used commercially, instead they are kept for social and religious purposes. Several Daoyo are slaughtered at a funeral, depending on the importance of the deceased, and the skins are used to wrap the body.',
		region: 'Cameroon',
		image: '',
	},
	{
		name: 'Doela',
		description: '',
		region: '—',
		image: '',
	},
	{
		name: 'Drakensberger',
		description: '',
		region: 'South Africa',
		image: '',
	},
	{
		name: 'Dølafe',
		description: 'The Dølafe is a rare breed of cattle.[1]<br/>' +
			'<br/>' +
			'The breed originates from the Gudbrand Valley, Østerdalen and Hedmarken in Norway. These areas offered good conditions for livestock with easy access to rich mountain pastures. Most Dølafe cattle today came from a single herd at Fåvang in the Gudbrand Valley. Once considered to be endangered, since the 1990s, the activity of the breed has increased and the number of animals has increased considerably.[2]<br/>' +
			'<br/>' +
			'The Dølafe is a small-boned cow with short legs. They are normally horned. It is a multicolored breed, ranging from almost uniformly dark brown to white, brown and black individuals. On average, they weigh approximately 450–500 kilograms (990–1,100 lb).',
		region: 'Norway',
		image: '',
	},
	{
		name: 'Droughtmaster',
		description: 'The Droughtmaster is a tropical breed of beef cattle developed in North Queensland, Australia by several cattlemen from crossing Brahman and British breed cattle, principally the Beef Shorthorn during the early 1900s.<br/>' +
			'<br/>' +
			'The breed was conceived in response to the need in the Australian Tropics for a breed of cattle which had good tick resistance and would be able to use the environment and the pastures in the most efficient manner to give higher weight gains and fertility.<br/>' +
			'<br/>' +
			'The Droughtmaster breed emerged after many years of crossbreeding and meticulous selection for the following properties:<br/>' +
			'<br/>' +
			'    calving ease,<br/>' +
			'    good meat quality,<br/>' +
			'    parasite resistance,<br/>' +
			'    heat tolerance,<br/>' +
			'    ability to adapt to the environment,<br/>' +
			'    high fertility, and<br/>' +
			'    docility.<br/>' +
			'<br/>' +
			'Other British breeds — mainly Hereford — have since been used in its development to arrive at a fixed tropical breed of approximately 50% Bos indicus and 50% Bos taurus genetics. Droughtmasters are medium to large with good walking and foraging abilities coupled with lower nutritional requirements to give them the ability to retain condition and keep breeding, irrespective of the prevailing conditions. Their short coat is generally red in colour, although variations from golden honey to dark red can occur. The red pigmentation in Droughtmasters helps protect the cattle from cancer eye, sunburnt udders and photosensitisation. The cattle may be polled or horned, but the vast majority are polled and exhibit only a moderate hump. They have medium to large ears and an extended dewlap.<br/>' +
			'<br/>' +
			'In pasture and feedlot trials these cattle have shown good average daily weight gains when compared to other breeds. Large commercial Droughtmaster herds are running on native pastures in both Queensland and the Northern Territory and they are rapidly gaining prominence in the traditional "British-bred" areas in southern Australia.<br/>' +
			'<br/>' +
			'Since the 1970s Droughtmaster cattle, semen and embryos have been exported to countries throughout Asia, Africa, Latin America, South America, the Middle East and the Pacific Islands. ',
		region: 'Australia',
		image: 'droughtmaster.jpg',
	},
	{
		name: 'Dulong',
		description: '',
		region: '—',
		image: '',
	},
	{
		name: 'Dutch Belted',
		description: 'The Dutch Belted (Lakenvelder) breed of dairy cattle is, according to records, the only belted breed of cattle tracing back directly to the original belted or "canvassed" cattle which were described in Switzerland and Austria. These "Gurtenvieh" were evidently moved by Dutch nobility from the mountain farms of canton Appenzell and County of Tyrol Mountains during or soon after the feudal period. The Dutch were very protective of their belted cattle and would generally not part with them. The cattle were highly prized for their milking and fattening abilities. The breed began to flourish in the Netherlands around 1750. Now, the cow is too rare to become a popular type of beef.<br/>' +
			'<br/>' +
			'Current cows are more productive, and there are small scale initiatives to preserve the breed.<br/>' +
			'<br/>' +
			'There is also a rare breed of domestic poultry called Lakenvelder that has this same belted colouring with a solid black neck hackle and black tail but with a pure white body.',
		region: 'Netherlands',
		image: 'dutch_belted.jpg',
	},
	{
		name: 'Dutch Friesian',
		description: '',
		region: 'Netherlands',
		image: '',
	},
	{
		name: 'Dwarf Lulu',
		description: 'The Dwarf Lulu is a breed of cattle that is native to the mountains of Central Asia. It has taurine, yak and zebu cattle genetics.[1]<br/>' +
			'<br/>' +
			'Cows weigh between 68 and 153 kg,[2] which makes Dwarf Lulu the presumably smallest cattle breed known.',
		region: '—',
		image: '',
	},
	{
		name: 'East Anatolian Red',
		description: '',
		region: '—',
		image: '',
	},
	{
		name: 'Eastern Finncattle',
		description: 'Eastern Finncattle are a breed of cattle from eastern Finland.[1] They are a dual purpose breed, used in dairy and beef production.<br/>' +
			'<br/>' +
			'Cows produce approximately 4100 kg of milk per lactation, with about 4.4% fat and 3.5% protein.<br/>' +
			'<br/>' +
			'The Eastern Finncattle cows were recognized as a separate breed in the 1890s. There was a need to improve milk production and the recognition of breeds was part of the development work. The general interest in well characterized breeds coincided with strong nationalistic feelings at the time.',
		region: 'Finland',
		image: 'fincattle.png',
	},
	{
		name: 'Eastern Red Polled',
		description: '',
		region: '—',
		image: '',
	},
	{
		name: 'Enderby Island Cattle',
		description: 'Enderby Island Cattle are a breed of cattle that existed in a wild state in isolation on Enderby Island, New Zealand for over 80 years. Only about seven specimens remain today, (on mainland New Zealand), after a rescue expedition by the Rare Breeds Conservation Society of New Zealand (RBCSNZ), and a culling program to protect the native flora and fauna of Enderby Island. There have since been intensive efforts at breeding the cattle, involving both in vitro fertilisation and cloning, and there is an ongoing program to perpetuate the breed in captivity.',
		region: 'New Zealand',
		image: '',
	},
	{
		name: 'English Longhorn',
		description: 'English Longhorn cattle (also formerly known as Lancashire cattle[1]) are a long-horned brown and white breed of beef cattle originating from Craven, in the north of England. The breed was initially used as a draught animal, which its body is well suited for; the milk was also collected for butter and cheese because of its high butterfat content. An individual farmer would have owned one or two cows; these would have been accompanied by a bull owned by the Lord of the Manor.[2] The notable long, curved horns that serve to distinguish this breed from others can make an individual appear aggressive, although by temperament they are usually friendly. Longhorns live surprisingly longer than other breeds of cattle and are also known for calving with ease. They have a white patch along the line of their spine and under their bellies.',
		region: 'England',
		image: 'english_longhorn.jpg',
	},
	{
		name: 'Ennstal Mountain Pied Cattle',
		description: 'The Ennstaler Bergscheck ("Ennstal Mountain Pied Cattle") is an endangered Austrian breed of domestic cattle. The name comes from the Ennstal, the valley of the Enns River.<br/>' +
			'<br/>' +
			'The small light Ennstaler Bergscheck was long believed to have originated from the Bavarian Weißkopfscheck ("White-headed Pied Cattle") but recent archaeological discoveries indicate descent from the local cattle of the La Tène period (5th–1st centuries BC).[1] Once they were almost totally foxy red before the white spots in their fur increased, until 75%–80% of the fur was white with only the loin and the side remaining clouded or with fringed spots. The inner ears are coloured. Horns, hooves and mucosas are mostly pigment free.[2]<br/>' +
			'<br/>' +
			'The breed was once popular as a draft and beef animal but in the 18th century was replaced by Murboden Cattle, Pinzgau Cattle, or Carinthian Blondvieh. The animals are fully developed after two years in the Alps, so they count as the earliest maturing alpine cattle breed. Although they do not become fat their beef is well marbled.[2]<br/>' +
			'<br/>' +
			'It was thought that the last two cows had been slaughtered in 1986, but some surviving animals were found. Their conservation is organised by the Union for the Conservation of Endangered Domestic Animal Breeds (VEGH) and the Austrian National Union for Gene Reserves. In the year 2004 there were in Austria 65 animals in 6 farms again. ',
		region: 'Austria',
		image: 'ennstal.jpg',
	},
	{
		name: 'Estonian Holstein',
		description: '',
		region: 'Estonia',
		image: '',
	},
	{
		name: 'Estonian Native',
		description: '',
		region: '—',
		image: '',
	},
	{
		name: 'Estonian Red cattle',
		description: 'Estonian red cattle (Estonian: Eesti punane veis) are a dairy cattle breed from Estonia. The color is red, but sometimes it varies from red-white to brown and rarely black. The Estonian Red was developed by using Angler, Native Estonian and the Danish Red dairy cattle.[1] In the last century the biggest breeders were Middendorff and Sievers.',
		region: '—',
		image: '',
	},
	{
		name: 'Evoline Cattle',
		description: 'Évolène Cattle are an old breed of dairy cattle from the Valais canton of Switzerland.[1] It is an endangered cattle breed.',
		region: 'Switzerland',
		image: 'evolene.jpg',
	},
	{
		name: 'Finnish Ayrshire',
		description: 'The Finnish Ayrshire is the most common cattle in Finland (74%). The breed stems from the importation of around 1600 Ayrshire cattle from Scotland and Sweden from 1847-1923. The Finnish Ayrshire is bred with the Swedish Red Cattle (SRB) and local Norwegian cow breeds to breed the Norwegian Red, which is the dominant breed in Norway. Semen is therefore imported from the Finnish Ayrshire to use for Norwegian Reds. In 2008, just one Finnish Ayrshire was used as the father of all Norwegian Reds.<br/>' +
			'<br/>' +
			'Finnish Ayrshires are most often horned and red-brown, with a calm disposition. Annual milk production can be up to 7400 kg, with 4.36% fat and 3.36% protein. The average living weight is 540 kg for grown cows.',
		region: 'Finland',
		image: 'finnish_ayrshire.jpg',
	},
	{
		name: 'Finnish cattle',
		description: 'Finncattle refers to three closely related cattle breeds of Finnish origin. Finncattle is most often kept for dairy production, and some animals are found in petting zoos and as pets. The Finncattle breeds are of small size and naturally polled; however, they differ in appearance and production levels. The Western Finncattle is red,[1] and the largest of the three breeds. The North Finnish cattle variety are white, the West Finnish are red, while the East Finnish are both white and red.',
		region: 'Finland',
		image: 'finnish_cattle.jpg',
	},
	{
		name: 'Finnish Holstein-Friesian',
		description: '',
		region: '—',
		image: '',
	},
	{
		name: 'Fjall',
		description: 'The Fjäll (Swedish: Fjällko or Svensk Fjällras) is a traditional Swedish breed of polled mountain cattle. It was threatened with extinction in the 1970s and 1980s, but recovered after a breed association was formed in 1995, partly thanks to stocks of frozen semen. Microsatellite analysis has shown it to be closely related to the endangered Bohuskulla breed.',
		region: 'Sweden',
		image: 'fjall.jpg',
	},
	{
		name: 'Fleckvieh',
		description: 'The Fleckvieh is a breed of dual-purpose cattle suitable for both milk and meat production. It originated in Central Europe in the 19th century from cross-breeding of local stock with Simmental cattle imported from Switzerland. Today, the worldwide population is 41 million animals.',
		region: 'Austria',
		image: 'fleckvieh.jpg',
	},
	{
		name: 'Florida Cracker',
		description: 'The Florida Cracker Cow is a breed of cattle developed in the state of Florida, and named for the Florida Cracker culture in which it was kept. Also known as the Florida Scrub or just as the Cracker cow, these cattle are one of the criollo-type breeds originally brought to the Southern U.S. by the Spanish Conquistadors.[1] The breed is very closely related to the Pineywoods cattle breed, but purebred Crackers have not been crossbred with any English breeds, like the Pineywoods has in the past been crossbred.[1] Other related breeds include the Corriente and Texas Longhorn.',
		region: 'United States',
		image: 'florida_cracker.jpg',
	},
	{
		name: 'Fogera',
		description: 'Fogera cattle is an Ethiopian breed of cattle.[1][2] One of its typical characteristics are broad hoofs, that allow it to move more easily in the marshes of the Fogera Plain. At Woreta, the agricultural research centre specialises in preserving the breed.',
		region: 'Ethiopia',
		image: '',
	},
	{
		name: 'French Simmental',
		description: 'French Simmental is a French cattle breed.',
		region: 'France',
		image: 'french_simmental.jpg',
	},
	{
		name: 'Fribourg black and white',
		description: '',
		region: '—',
		image: '',
	},
	{
		name: 'Friesian Red and White',
		description: '',
		region: '—',
		image: '',
	},
	{
		name: 'Fulani Sudanese',
		description: '',
		region: '—',
		image: '',
	},
	{
		name: 'Galician Blond',
		description: 'The Rubia Gallega, Galician: Rubia Galega, is a breed of cattle native to the autonomous community of Galicia in north-western Spain. It is raised mainly for meat.[3]:143 It is distributed throughout Galicia, with about 75% of the population concentrated in the province of Lugo.[4] The coat may be red-blond, wheaten, or cinnamon-coloured.',
		region: 'Spain',
		image: 'galician_blond.jpg',
	},
	{
		name: 'Galloway cattle',
		description: 'The Galloway is one of the world\'s longest established breeds of beef cattle, named after the Galloway region of Scotland, where it originated, during the 17th century.<br/>' +
			'<br/>' +
			'It is now found in many parts of the world, being exported to Canada in 1853, the US in 1882 and Australia in 1951. The breed enjoyed success during the 1950s but this subsided during the foot and mouth crisis. Today, the breed is enjoying a revival due to the demands of the beef market. The breed is considered average size and has a thick coat due to the climate of their native Scotland.',
		region: 'Scotland',
		image: 'galloway.jpg',
	},
	{
		name: 'Gangatiri cattle',
		description: 'Gangatiri (Hindi: गंगातिरी) is an indigenous cattle breed of India. It is known to be originated in the region along the banks of Ganga river in eastern Uttar Pradesh and western parts of Bihar state. This is an important dual purpose breed of North India. The cows are fairly good milk yielders.',
		region: 'India',
		image: 'gangatiri.jpg',
	},
	{
		name: 'Gaolao cattle',
		description: 'Gaolao is a breed of cattle native to India.[1] It belongs to the subspecies Bos Indicus. It is a dual purpose breed used both as draught and milk cattle. It originated in the region consisting of Wardha district in Maharashtra, Balaghat district and Chindwara Districts in Madhya Pradesh and Rajnandgaon district in Chhattisgarh state. The cattle are large and well built in size, and usually are of white to gray complexions.',
		region: 'India',
		image: 'gaolao.jpg',
	},
	{
		name: 'Garvonesa Cattle',
		description: 'The Garvonesa is a cattle breed originating in Portugal.',
		region: 'Portugal',
		image: '',
	},
	{
		name: 'Gascon cattle',
		description: 'Gascon Cattle is a breed of cow. Two different types of this breed of cattle are: à muqueuses noires and aréolé. These were combined in 1955 into a single herdbook, but in 1999 they were once again made two different breeds',
		region: 'France',
		image: 'gascon_cattle.jpg',
	},
	{
		name: 'Gelbvieh',
		description: 'Gelbvieh (pronounced [ɡɛlbfiː], German for "yellow cattle") is a cattle breed originating in several Franconian districts of Bavaria, Germany in the mid-18th century.[1] Gelbvieh were originally known as “red-yellow Franconian cattle” and were developed from several local breeds. Gelbviehs were originally bred to be triple purpose cattle (used for milk, beef, and draught), but the modern Gelbvieh is primarily used for beef production.',
		region: 'Germany',
		image: 'gelbvieh.jpg',
	},
	{
		name: 'Georgian mountain cattle',
		description: 'The Georgian Mountain (Georgian: საქართველოს მთის პირუტყვი) is a local cattle breed from The Republic of Georgia.They can be black, black and white or red and white in colour. It is a very small breed,[1] adapted to the harsh mountain conditions of the Caucasus; average height at the withers is 100 cm for cows and 112 cm for bulls.[1][2] The live weight of mature cows is 220–280 kg and that of bulls is 270–370 kg.',
		region: 'Georgia',
		image: '',
	},
	{
		name: 'German Angus Cattle',
		description: 'The German Angus (German: Deutsch Angus) is a modern German breed of beef cattle. It was bred in the 1950s in Germany by crossing Aberdeen Angus with various native German cattle breeds: German Black Pied, Deutsche Rotbunte, and Fleckvieh.',
		region: 'Germany',
		image: 'german_angus_cattle.jpg',
	},
	{
		name: 'German Black Pied Cattle',
		description: 'German Black Pied cattle are a breed of dairy cattle that originated in the North Sea coast regions of northern Germany and the Netherlands.<br/>' +
			'<br/>' +
			'Until the 18th century cattle of diverse colours were bred in these regions. After 1750 the black pied coloured type was dominant. But there are still also unicoloured red and red pied cattle.<br/>' +
			'<br/>' +
			'In 1878 in East Frisia (Germany), the first breeding company was founded. East Frisia and East Prussia (today Russia, Lithuania, and Poland) were the most important breeding regions of the breed. Later it extended over the whole of northern and central Germany. Since 1958 in West Germany the breed was crossed with Holstein Friesian cattle. Since the 1960s these crossed animals have been dominant, and so the German black-and-white cattle breed was born.[1]<br/>' +
			'<br/>' +
			'In East Germany the breed was crossed with Jersey cattle and Holstein Friesian cattle to create the German Black Pied Dairy cattle breed.[2]<br/>' +
			'<br/>' +
			'The original breeding type was conserved in East Germany as a genetic reserve. Individual breeders in West Germany and in the Netherlands were also able to conserve the original type.<br/>' +
			'<br/>' +
			'German Black Pieds are smaller than Holstein Friesians and with a lower milk volume, but they are more fertile and long-lived. A comparison was made between the rates of muscle growth and energy utilisation of Fleckvieh bulls as compared to German black pied bulls. It was found that the Fleckvieh bulls had faster growth rates, the carcases had a smaller proportion of fat, especially abdominal fat, and the animals could be slaughtered at an earlier date when fed on similar diets.[',
		region: 'Germany',
		image: '',
	},
	{
		name: 'German Black Pied Dairy',
		description: 'The German Black Pied Dairy[1] (German: Schwarzbuntes Milchrind (SMR)) was a dairy cattle breed of the GDR, created through combination breeding.<br/>' +
			'<br/>' +
			'In 1963, Georg Schönmuth[2] suggested that Jersey bulls from Denmark be crossed with German Black Pied cows. The descendants of this crossing were to be crossed with Holsteins.<br/>' +
			'<br/>' +
			'The goal of this three-breed cross was to create a cattle breed with high milk production, high milk fat content, and sufficient beef performance.<br/>' +
			'<br/>' +
			'This breed was continued until 1990. After German reunification the German Black Pied Dairy cattle were displaced by German Holstein cattle.',
		region: 'Germany',
		image: '',
	},
	{
		name: 'German Red Pied',
		description: 'The German Red Pied (German: Deutsche Rotbunte, Rotbuntes Niederungsvieh or Rotbuntes Niederungsrind) is a breed of cattle from Germany.[1]<br/>' +
			'<br/>' +
			'The development of the breed occurred in several regions in Germany during the 19th century, and in 1934 Meuse-Rhine-Issel blood was introduced.[1] The females average 1.35 metres (4 ft 5 in) in height and weigh 700 kilograms (1,500 lb). Bulls average 1.45 metres (4 ft 9 in) and 1,000 kilograms (2,200 lb).',
		region: 'Germany',
		image: '',
	},
	{
		name: 'Gir',
		description: 'The Gir or Gyr is one of the principal Zebu breeds originating in India. It has been used locally in the improvement of other breeds including the Red Sindhi and the Sahiwal. It was also one of the breeds used in the development of the Brahman breed in North America. In Brazil and other South American countries the Gir is used frequently because, as a Bos indicus breed, it is resistant to hot temperatures and tropical diseases. It is very known for its milk producing qualities and is often bred with Friesian cows to make the Girolando breed.<br/>' +
			'<br/>' +
			'The Gir is distinctive in appearance, typically having a rounded and domed forehead (being the only ultraconvex breed in the world), long pendulous ears and horns which spiral out and back. Gir are generally mottled with the colour ranging from red through yellow to white, black being the only unacceptable colour. They originated in southwest India in the state of Gujarat and have since spread to neighbouring Maharashtra and Rajasthan.<br/>' +
			'<br/>' +
			'Cows average 385 kg in weight and 130 cm in height; bulls weigh 545 kg on average, with a height of 140 cm.[3] At birth, calves weigh about 20 kg.[3] The average milk yield for the Gir is 1590 kg per lactation, with a record production of 3182 kg at 4.5% fat in India. In Brazil they average 3500 kg per lactation, with a world record production of 17 120 kg by the cow Profana de Brasília.[citation needed]<br/>' +
			'<br/>' +
			'In 2003 the Gir numbered about 915 000, or 37% of the 2.5 million cattle population of the Saurashtra region of Gujarat.[4] In 2010 the population in Brazil was estimated at approximately five million.',
		region: 'India',
		image: 'gir.jpg',
	},
	{
		name: 'Glan cattle',
		description: 'Glan cattle are a traditional cattle breed particularly found in the Rhineland-Palatinate region of Germany. At one time they were almost extinct, but today there are about 2,000 animals. Originally multipurpose, they are nowadays mainly used for beef production.',
		region: 'Germany',
		image: 'glan_cattle.jpg',
	},
	{
		name: 'Gloucester',
		description: 'They are large cattle, coloured a rich dark brown in the cows, calves and steers, and almost black in the bulls. They have a white belly and a white finching stripe along the spine and continuing over the tail, and they normally have well-developed white horns with black tips.',
		region: 'England',
		image: 'gloucester.jpg',
	},
	{
		name: 'Gobra',
		description: '',
		region: '—',
		image: '',
	},
	{
		name: 'Greek Shorthorn',
		description: 'The Greek Shorthorn is a rare breed of cattle under extensive husbandry condition in mountain areas of the northwest regions of Greece.<br/>' +
			'<br/>' +
			'Their height is typically between 0.97 and 1.14 meters. They have small heads with short and thin horns. The body weight of the males is roughly 300 kilograms (661 pounds). The average body weight of the females is around 200 kg (441 pounds).[1]<br/>' +
			'<br/>' +
			'They are usually grey-blond to dark brown in color.',
		region: 'Greece',
		image: '',
	},
	{
		name: 'Greek Steppe cattle',
		description: '',
		region: '—',
		image: '',
	},
	{
		name: 'Greyman Cattle',
		description: 'Greyman are an Australian breed of beef cattle developed in Queensland in the 1970s, specifically to suit the Queensland environment, by combining the outstanding genetic characteristics of both the Murray Grey and Brahman breeds.<br/>' +
			'<br/>' +
			'These cattle carry between 25% and 75% of Murray Grey blood, with the remainder made up of Brahman. This allows breeders the option of being able to select for optimal performance specific to the region and environmental conditions. Thus, Greymans can be bred with a greater emphasis on Brahman content in the tropical country, or with a higher percentage of Murray Grey blood to suit the southern states. Their sleek coats varying in colour from dark grey to a silver, the Greyman are natural polls and have a dark skin pigmentation that is not susceptible to skin or eye problems in severe climates.<br/>' +
			'<br/>' +
			'Greyman cattle offer breeders natural tick resistance, good mothering ability, drought and heat tolerance and efficient feed conversion. They are among the breeds that have been GeneSTAR tested positive for carrying copies of marbling and tenderness genes.<br/>' +
			'<br/>' +
			'Greymans were originally recorded within their own society, but the Greyman Society and its Herdbook were absorbed into the Murray Grey Beef Cattle Society in the mid 1990s, as part of the Murray Grey Composite Register. More recently a separate Greyman Register has been added to provide a more effective recording system.[1]<br/>' +
			'<br/>' +
			'The Greyman breed has attracted interest from overseas cattle producers as they are one of the few Australian breeds adapted to maximum performance and productivity under all conditions.',
		region: 'Australia',
		image: 'greyman_cattle.jpg',
	},
	{
		name: 'Groningen',
		description: 'The Dutch Belted (Lakenvelder) breed of dairy cattle is, according to records, the only belted breed of cattle tracing back directly to the original belted or "canvassed" cattle which were described in Switzerland and Austria. These "Gurtenvieh" were evidently moved by Dutch nobility from the mountain farms of canton Appenzell and County of Tyrol Mountains during or soon after the feudal period. The Dutch were very protective of their belted cattle and would generally not part with them. The cattle were highly prized for their milking and fattening abilities. The breed began to flourish in the Netherlands around 1750. Now, the cow is too rare to become a popular type of beef.<br/>' +
			'<br/>' +
			'Current cows are more productive, and there are small scale initiatives to preserve the breed.<br/>' +
			'<br/>' +
			'<br/>' +
			'There is also a rare breed of domestic poultry called Lakenvelder that has this same belted colouring with a solid black neck hackle and black tail but with a pure white body.',
		region: 'Netherlands',
		image: '',
	},
	{
		name: 'Groningen White-Headed',
		description: 'Blaarkop is a breed of dairy cattle. Blaarkop is Dutch for blister head. Its main breeding area is in Groningen (province), Netherlands.<br/>' +
			'<br/>' +
			'The breed has been mentioned as early as the 14th century. From the 19th century, there are also Blaarkoppen in the Utrecht and Leiden regions. The Blaarkop breed is sturdily built with matching muscles, a horned head, and strong legs. Both red (60% of the population) and black (40%) Blaarkoppen exist. The body is solid red or black, while the head is white with a red or black ring (blister) around the eyes; the tail has a white tip.<br/>' +
			'<br/>' +
			'Bulls are 1.45 to 1.50 m high and weigh 800 kg.<br/>' +
			'Cows are 1.35 to 1.40 m high and weigh 600 kg.<br/>' +
			'The average milk production is 6000 kg, with 4.35% butterfat and 3.60% protein.',
		region: 'Netherlands',
		image: '',
	},
	{
		name: 'Gudali',
		description: 'Mahmudabad-e Gudlar (Persian: محمودابادگودلر‎, also Romanized as Maḩmūdābād-e Gūdlar; also known as Gudali, Maḩmūdābād, and Makhmudabad)[1] is a village in Mavazekhan-e Sharqi Rural District, Khvajeh District, Heris County, East Azerbaijan Province, Iran. At the 2006 census, its existence was noted, but its population was not reported.',
		region: 'Iran/Persia',
		image: '',
	},
	{
		name: 'Guernsey',
		description: 'The Guernsey is a breed of dairy cattle from the island of Guernsey in the Channel Islands. It is fawn or red and white in colour, and is hardy and docile. Its milk is rich in flavour, high in fat and protein, and has a golden-yellow tinge due to its high β-carotene content. The Guernsey is one of three Channel Island cattle breeds, the others being the Alderney – now extinct – and the Jersey.',
		region: 'Channel Islands',
		image: 'guernsey.jpg',
	},
	{
		name: 'Guzerat',
		description: 'The Guzerá or Guzerat is a Brazilian breed of domestic cattle. It derives from cross-breeding of Indian Kankrej cattle, imported to Brazil from 1870 onwards, with local taurine Crioulo cattle of European origin.The name is a Portuguese spelling of that of the western Indian state of Gujarat.<br/>' +
			'<br/>' +
			'The herd-book for the breed was started in 1938; in it, a dual-purpose (meat and dairy) line is distinguished from the beef type, and a polled variant is also distinguished. In 2010 there were approximately 92 000 head registered, constituting some 3.5% of the total number of indicine cattle in Brazil.<br/>' +
			'<br/>' +
			'The Guzerá was one of the principal breeds from which the American Brahman developed in the twentieth century.',
		region: 'Brazil',
		image: 'guzerat.jpg'
	},
	{
		name: 'Hallikar',
		description: 'Hallikar (Kannada: ಹಳ್ಳಿಕಾರ್) is a breed of cattle native to the state of Karnataka, India. They are more common in the traditional Hallikar belt of Mysore, Mandya, Hassan and Tumkur districts of South Karnataka.<br/>' +
			'<br/>' +
			'Long, vertical and backward bending horns, large humps in males, moderate to long height and medium size of the body, and white to grey and occasionally black complexions, are the characteristics of the breed. The bulls of this breed of cattle are known for their strength and endurance, and are mainly used for draft purposes. It is classified as a draught breed in India.[3][4]<br/>' +
			'<br/>' +
			'It is one of the two breeds, along with Amrit Mahal, which have received the royal patronage and care from the erstwhile Maharajas of Mysore State through conservation and development. The breed is said to be the origin of Amrit Mahal cattle.[5]<br/>' +
			'<br/>' +
			'The Department of Posts, Government of India commemorated the breed by releasing a postage stamp in its name in 2000.',
		region: 'India',
		image: 'hallikar.jpg',
	},
	{
		name: 'Hanwoo',
		description: 'The Hanwoo (Korean: 한우), also Hanu, is a breed of small cattle native to Korea. This breed is raised mainly for meat and is the source of Hanwoo beef, one of the most rare and expensive meats in the world.[2]:193 It is one of four indigenous Korean breeds, the others being the Chikso, the Heugu and the Jeju Black.',
		region: 'Korea',
		image: 'hanwoo.jpg',
	},
	{
		name: 'Haryanvi cattle',
		description: 'Hariana (Hindi: हरियाना[1]) is an Indian Cow breed (Bhartiya govansh / भारतीय गोवंश[1] ) native to North India, specially in the state of Haryana. They produce about 5 liters of milk a day, compared to 8.9 liters when cross bred with Holstein Friesian cattle (HS), whereas pure HS can produce 50 liter a day but it is not as disease resistant in the conditions of North India.',
		region: 'India',
		image: 'haryanvi.jpg',
	},
	{
		name: 'Hartón del Valle',
		description: '',
		region: 'Colombia',
		image: '',
	},
	{
		name: 'Harz Red mountain cattle',
		description: 'The Harzer Rotvieh is a unicoloured red cattle breed from the Harz in Germany. They serve the purposes of providing milk, beef and draught power. The name means "red cattle of the Harz".',
		region: 'Germany',
		image: 'harz.jpg',
	},
	{
		name: 'Hays Converter',
		description: 'The Hays Converter is a breed of cattle native specifically to Alberta, Canada. Named for Harry Hays, the agriculturalist and politician who developed the breed, it was the first pure breed of cattle created in Canada.[1] Work on breeding the Hays Converter began in 1959, and it was officially recognized by the Canadian beef industry under the Canada Livestock Pedigree Act in December 1975.[2][3] Senator Hays wished to create a cattle breed that would be based solely on production, and as such would mature to market weight as fast as possible.',
		region: 'Canada',
		image: '',
	},
	{
		name: 'Heck Cattle',
		description: 'Heck cattle are a hardy breed of domestic cattle. These cattle are the result of an attempt by the Heck brothers to breed back the extinct aurochs from modern auroch-derived cattle in the 1920s and 1930s. Controversy revolves around methodology and success of the programme.[1] There are considerable differences between Heck cattle and the aurochs in build, height, and body proportions. Furthermore, there are other cattle breeds which resemble their wild ancestors at least as much as Heck cattle.',
		region: '—',
		image: 'heck_cattle.jpg',
	},
	{
		name: 'Hereford',
		description: 'The Hereford is a British breed of beef cattle that originated in the county of Herefordshire, in the West Midlands of England.[1][2] It has been exported to many countries, and there are more than five million purebred Hereford cattle in over fifty nations worldwide.[3] The breed was first exported from the United Kingdom in 1817, initially to Kentucky,[4] and spreading across the United States and Canada, through Mexico, to the great beef-raising countries of South America. Today, Hereford cattle dominate the world scene from Australasia to the Russian steppes. They can be found in Israel, Japan and throughout continental Europe and Scandinavia, in the temperate parts of Australia, Canada, the United States, Kazakhstan and Russia, in the centre and east of Argentina, in Uruguay, in Chile, and in New Zealand, where they make up the largest proportion of registered cattle.[5] They are found all around Brazil[6] and they are also found in some Southern African countries[7] (mainly in South Africa, Zambia and Zimbabwe). They originally found great popularity among ranchers of the American Southwest, testament to the hardiness of the breed; while originating in cool, moist Britain, they have proven to thrive in much harsher climates on nearly every continent.<br/>' +
			'<br/>' +
			'The World Hereford Council[8] is based in the United Kingdom. There are currently 20 Hereford societies in 17 member countries, and a further eight societies in 10 nonmember countries.[9] In the United States, the official Hereford organization and breed registry is the American Hereford Association. It is the second-largest society of its kind in the country.',
		region: 'England',
		image: 'hereford_bull.jpg',
	},
	{
		name: 'Herens',
		description: 'The Herens (Eringer in German) is a breed of cattle named after the Val d\'Hérens region of Switzerland. These small, horned alpine cattle are coloured black, brown or dark red, often with a lighter stripe along the spine.[1] The cows are used in organised cow fights.',
		region: 'Switzerland',
		image: 'herens.jpg',
	},
	{
		name: 'Hybridmaster',
		description: 'The Hybridmaster is a breed of cattle. The genetic makeup of Hybridmaster cattle is approximately 50% Angus cattle, 25% Brown Swiss cattle, 6.25% Brahman cattle, 6.25% Simmental cattle, 6.25% wild Southeast Asian gaur, and 6.25% wild North American bison.[citation needed]<br/>' +
			'<br/>' +
			'Developed by Joe Grose in Oklahoma, Hybridmasters have been selected for 35 years on four traits: milk, fertility, longevity, and growth.[citation needed][clarification needed] This breed was designed to produce large amounts of beef as well as milk.',
		region: '—',
		image: '',
	},
	{
		name: 'Highland Cattle',
		description: 'Highland cattle (Scottish Gaelic: Bò Ghàidhealach; Scots: Heilan coo), also called long-haired Highland cattle, long-haired Scottish cattle, North Highland cattle, Scottish cattle, Scottish Highland cattle, and West Highland cattle, are a Scottish breed of cattle descended from the Black Kyloe.They have long horns and long, wavy, woolly coats that are coloured red, ginger, black, dun, yellow, white, grey, "silver" (white but with a black nose and ears), or tan, and they also may be brindled. Highlands are raised primarily for their meat.[1] They originated in the Highlands and Outer Hebrides islands of Scotland and were first mentioned in the 6th century AD. The first herd book described two distinct types of highland cattle but crossbreeding between the two has brought about only one extant, registered type. They have since been exported worldwide.<br/>' +
			'<br/>' +
			'They are a hardy breed, having been bred to withstand the conditions in the Scottish Highlands. Their long hair gives the breed its ability to overwinter. Bulls can weigh up to 800 kilograms (1,800 pounds) and cows can weigh up to 500 kilograms (1,100 pounds). Their milk generally has a very high butterfat content, and their meat, regarded as of the highest quality, is gaining mainstream acceptance as it is lower in cholesterol than other varieties of beef.',
		region: 'Scotland',
		image: 'highland_cattle.jpg',
	},
	{
		name: 'Hinterwald Cattle',
		description: 'The Hinterwald (German: Hinterwälder-Rind) is an old local breed of cattle from the Black Forest. There is a breed association in Germany and one in Switzerland. The scientific name is Bos primigenius f. taurus.[1]<br/>' +
			'<br/>' +
			'The cows are small, only 115 to 125 centimetres (45 to 49 in) tall and weighing 380 to 480 kilograms (840 to 1,060 lb), making them the smallest breed of cattle still extant in Central Europe.[2][full citation needed] The head is mostly white, the remainder of the coat being pied light yellow to dark red-brown. Having been bred to cope with extreme conditions, such as cold winters, steep pastures and a frugal diet, they are well adapted to the Alpine climate. They are used for both beef and milk production and are noted for their thriftiness, longevity and lack of calving difficulties.<br/>' +
			'<br/>' +
			'These qualities have led to a significant rise in the number of Hinterwald cows in the Swiss Alps since the introduction of a breeding programme initiated by Pro Specie Rara, a non-profit organisation dedicated to the preservation of endangered domestic species. However, the breed is still endangered. The government of Baden-Württemberg pays husbandry bonuses to conserve it.<br/>' +
			'<br/>' +
			'The breed was "Domestic Animal of the Year" in Germany in 1992.',
		region: 'Germany',
		image: 'hinterwald_cattle.jpg',
	},
	{
		name: 'Holando-Argentino',
		description: 'Holando-Argentino is a breed of cattle primarily found in Argentina, and derived from Holstein-Friesian Cattle. It was first introduced from the Netherlands in 1880,[1] to the fertile regions of the Pampas, and devoted to the production of both beef and milk.<br/>' +
			'<br/>' +
			'Holando-Argentino cattle can be now found in the Argentine provinces of Buenos Aires, Santa Fe, Córdoba and Entre Ríos, as well as in small river basins in Salta, Tucumán, Formosa, Catamarca and Mendoza. They have also been exported to neighbouring countries. They are now primarily kept for milk production.<br/>' +
			'<br/>' +
			'The cows are medium-sized, standing 1.4 to 1.5 metres tall and weighing 600 to 650 kg. Good legs and feet allow extensive foraging.<br/>' +
			'<br/>' +
			'Promotion of this breed and technical resources to manage it are the goals of the Asociación Criadores de Holando-Argentino (ACHA, Holando-Argentino Breeders Association), founded in 1944.',
		region: 'Argentina',
		image: '',
	},
	{
		name: 'Red Holstein',
		description: 'he expression of red colour replacing the black in Holsteins is a function of a recessive gene.[24] Assuming the allele \'B\' stands for the dominant black and \'b\' for the recessive red, cattle with the paired genes \'BB\', \'Bb\', or \'bB\' would be black and white, while \'bb\' cattle would be red and white.',
		region: '—',
		image: 'red_holstein.jpg',
	},
	{
		name: 'Holstein',
		description: 'Holstein Friesians (often shortened to Holsteins in North America, while the term Friesians is often used in the UK and Ireland) are a breed of dairy cattle originating from the Dutch provinces of North Holland and Friesland, and Schleswig-Holstein in Northern Germany. They are known as the world\'s highest-production dairy animals.<br/>' +
			'<br/>' +
			'The Dutch and German breeders bred and oversaw the development of the breed with the goal of obtaining animals that could best use grass, the area\'s most abundant resource. Over the centuries, the result was a high-producing, black-and-white dairy cow.<br/>' +
			'<br/>' +
			'With the growth of the New World, markets began to develop for milk in North America and South America, and dairy breeders turned to the Netherlands for their livestock. After about 8,800 Friesians (black pied Germans) had been imported, disease problems in Europe led to the cessation of exports to markets abroad.[1]<br/>' +
			'<br/>' +
			'In Europe, the breed is used for milk in the north, and meat in the south. Since 1945, European national development has led to cattle breeding and dairy products becoming increasingly regionalized. More than 80% of dairy production is north of a line joining Bordeaux and Venice, which also has more than 60% of the total cattle. This change led to the need for specialized animals for dairy (and beef) production. Until this time, milk and beef had been produced from dual-purpose animals. The breeds, national derivatives of the Dutch Friesian, had become very different animals from those developed by breeders in the United States, who used Holsteins only for dairy production.<br/>' +
			'<br/>' +
			'Breeders imported specialized dairy Holsteins from the United States to cross with the European black and whites. For this reason, in modern usage, "Holstein" is used to describe North or South American stock and its use in Europe, particularly in the North. "Friesian" denotes animals of a traditional European ancestry, bred for both dairy and beef use. Crosses between the two are described by the term "Holstein-Friesian".',
		region: '—',
		image: 'holstein.jpg',
	},
	{
		name: 'Horro',
		description: 'Horro, Wallega or Wollega cattle are a breed of cattle native to Ethiopia.[1]<br/>' +
			'<br/>' +
			'Horro are usually brown in colour and have a hump at the rear. They can be used for milk, meat and draft. In Ethiopia, they are seen as a sign of wealth and prestige.',
		region: '—',
		image: '',
	},
	{
		name: 'Hungarian Grey',
		description: 'The Hungarian Grey (Hungarian: Magyar Szürke), also known as Hungarian Steppe Cattle,[3] is an ancient breed of domestic beef cattle indigenous to Hungary.[2][4]<br/>' +
			'<br/>' +
			'The breed belongs to the group of Podolic cattle[5][6] and is well adapted to extensive pasture systems.',
		region: 'Hungary',
		image: 'hungarian_grey.jpg',
	},
	{
		name: 'Iberian cattle',
		description: 'Iberian cattle are a group of cattle breeds native to the Iberian Peninsula.<br/>' +
			'<br/>' +
			'While native to the Iberian Peninsula, they are all wild and not considered farm animals.',
		region: '—',
		image: '',
	},
	{
		name: 'Icelandic',
		description: 'Icelandic cattle are a breed of cattle native to Iceland. Cattle were first brought to the island during the Settlement of Iceland a thousand years ago.[1] Icelandic cows are an especially colorful breed with a wide variety of colours and markings.[2] Icelandic cattle have been genetically isolated for centuries, but are most closely related to a breed in Norway called Blacksided Troender- and Nordland Cattle.[3] No cattle are permitted to be imported into Iceland, so they have been protected by strict disease-prevention measures.[4]<br/>' +
			'<br/>' +
			'The Icelandic cow is a dairy breed with a small body-size. About 95% are naturally polled, but the rest are horned. An average cow can produce about 6,000 kg (13,200 lb) of milk per year, with the best animals producing 11,000 kg (24,300 lb). They are housed for about eight months of the year and fed largely on hay, supplemented with cereals. They are grazed outside in the summer, and to prolong the growing season, cabbage, turnips, barley, and oats are grown for forage.[1] Fewer than 30,000 cows are on the island and their milk is used to create a mild, butter-flavoured cheese.[5]<br/>' +
			'<br/>' +
			'According to a report produced by the Agricultural University of Iceland, it would be more cost-effective to replace Icelandic cattle with Swedish cattle, as the latter produce more milk at a lower cost.[6] However, some have argued that Icelandic cattle are part of Iceland\'s cultural heritage and should not be replaced.[7][8]<br/>' +
			'<br/>' +
			'Guðni Ágústsson, former Icelandic minister of agriculture, once kissed an Icelandic cow.[9]<br/>' +
			'<br/>' +
			'The milk from Icelandic cows is used to make skyr.',
		region: 'Iceland',
		image: 'icelandic.jpg',
	},
	{
		name: 'Illawarra cattle',
		description: 'The Illawarra cattle breed was started by Australian dairymen improved their herd by introducing the bloodlines of superior cattle from a number of dairy breeds, especially the Ayrshire, Devon and Milking Shorthorn. The name Illawarra cattle was abbreviated from the earlier Australian Illawarra Shorthorn (AIS), and named after Illawarra, New South Wales where they developed from original Shorthorn imports and other breeds.',
		region: 'Australia',
		image: 'illawarra.jpg',
	},
	{
		name: 'Improved Red and White',
		description: '',
		region: '—',
		image: '',
	},
	{
		name: 'Indo-Brazilian',
		description: 'The Indu-Brasil or Indo-Brazilian is a Brazilian breed of zebuine beef cattle. It was bred in the early twentieth century in the Triângulo Mineiro in the western part of Minas Gerais state, and particularly in the area surrounding Uberaba. It was originally known as the Induberaba. It derives from imported Indian zebuine cattle, principally Gir and Kankrej (which in Brazil are known as "Guzerá").[3]:219 It was formerly an important beef breed, but in the twenty-first century is an endangered breed.[2]:205 It is characterised by particularly large ears, perhaps the largest seen in any breed of cattle.',
		region: '—',
		image: '',
	},
	{
		name: 'Irish Moiled',
		description: 'The Irish Moiled is a rare cattle breed from Ireland. It is a dual-purpose breed, reared for both beef and milk. It originated in County Leitrim, County Sligo, County Down and County Donegal, but the breed is now found throughout Ireland.',
		region: 'Ireland',
		image: 'irish_moiled.jpg',
	},
	{
		name: 'Israeli Holstein',
		description: '',
		region: '—',
		image: '',
	},
	{
		name: 'Israeli Red',
		description: '',
		region: '—',
		image: '',
	},
	{
		name: 'Istoben cattle',
		description: 'The Istoben cattle was a cattle breed named after the settlement of Istoben in the Kirov region of Russia[clarification needed] where a large creamery was established. They were recognized in 1943.<br/>' +
			'<br/>' +
			'According to the results of the 1981 evaluation, the average annual milk production of mature cows was 3107 kilograms (6850 pounds), and the fat content was 3.83%.',
		region: '—',
		image: '',
	},
	{
		name: 'Istrian cattle',
		description: '',
		region: '',
		image: '',
	},
	{
		name: 'Jamaica Black',
		description: '',
		region: '—',
		image: '',
	},
	{
		name: 'Jamaica Hope',
		description: 'Jamaica Hope (also known as a Jersey-Zebu or Montgomery-Jersey) is a dairy breed of cattle originating from Hope Farm in Jamaica. The breeding started in 1910, and was an attempt to develop an animal that was adjusted to the climate of the island.[1] It has a high heat tolerance, high resistance to ticks and tick-borne diseases, and can produce much milk even in the poor pasture land typical of tropical climates.[2] The breed consists of approximately 80% Jersey, 15% Zebu and 5% Holstein.[3] The whole process was to a great degree the work of Dr. Thomas Lecky, a pioneer in Jamaican agricultural science.[4] Jamaica Hope today make out about 50% of the cattle on the island. A mature cow weighs about 500 kg (1100 lbs.), while a male weighs between 700 and 800 kg (1500 – 1800 lbs).[3] A cow can produce 2,500 kg of milk per lactation period, which lasts for about 305 days. The butter fat content of the milk is around five percent.[5]<br/>' +
			'<br/>' +
			'Initial breeding, a government initiative, started with Ayrshire, Brown Swiss, Guernsey, Holstein Friesian, Jersey and Red Poll breeds. By a process of elimination, Ayrshire and Brown Swiss were discontinued in 1928, Red Poll in 1938 and Guernsey in 1943. By 1952 the breeding of the Holstein Friesians was also ended, though elements of the breed remain in today\'s animals. The Zebu element was added in 1920, through the introduction of one Sahiwal bull imported from Pusa, India.[6] Apart from the Indian Taylor breed, and the newly developed Australian Milking Zebu, the Jamaican Hope is the only tropical dairy breed that results from crossing Zebu with regular cattle.[6]<br/>' +
			'<br/>' +
			'There are today some 6,000 registered females of the breed. It has gained popularity, and is today extensively exported to other countries in the Caribbean, as well as Latin America.[6] In later years, however, the breed has seen a marked decline.[5] It has been suggested that the Jamaican Hope should be bred with the Australian Milking Zebu, to ensure greater genetic diversity.',
		region: 'Jamaica',
		image: '',
	},
	{
		name: 'Jamaica Red',
		description: '',
		region: '—',
		image: '',
	},
	{
		name: 'Jarmelista Cattle',
		description: 'The Jarmelista is a cattle breed from Continental Portugal, near Serra da Estrela. It is primarily used for beef.',
		region: 'Portugal',
		image: '',
	},
	{
		name: 'Javari Cattle',
		description: 'Javari (Kannada: ಜವಾರಿ) is a breed of cattle native to Hyderabad-Karnataka region in the state of Karnataka, India. It is considered as a dual purpose breed with good milking and draught capability. The cattle is of medium build and are of gentle temperament. They are known to have good heat and pest resistance, and is the most sought-after breed in its native region.',
		region: 'India',
		image: 'javari.jpg',
	},
	{
		name: 'Jersey',
		description: 'The Jersey is a British breed of small dairy cattle from Jersey, in the British Channel Islands. It is one of three Channel Island cattle breeds, the others being the Alderney – now extinct – and the Guernsey. It is highly productive – cows may give over 10 times their own weight in milk per lactation; the milk is high in butterfat and has a characteristic yellowish tinge.<br/>' +
			'<br/>' +
			'The Jersey adapts well to various climates and environments, and unlike many breeds originating in temperate climates, these cows can tolerate heat very well. It has been exported to many countries of the world; in some of them, including Denmark, France, New Zealand, and the United States, it has developed into an independent breed.[1]:212 In Nepal, it is used as a draught animal.',
		region: 'Channel Islands',
		image: 'jersey.jpg',
	},
	{
		name: 'Jutland cattle',
		description: 'Jutland cattle are a rare Danish breed of cattle used in both dairy and beef production. Bred from the indigenous cattle of Jutland the breed could be light grey, dark grey or black pied with upward curving horns. The first herdbook published in 1881 had a small dairy type and a larger beef type. The dairy cows were small, averaging 120 cm high and weighing 350 kg, producing between 800 and 1000 kg of milk per lactation.[1]<br/>' +
			'<br/>' +
			'In the first half of the 20th century the breed was extensively crossed with Dutch black and white cattle to boost milk production. By 1949 Dutch cattle and crosses were accepted into the herdbook and the name was changed to Danish Black and White Cattle. In 1955 the last purebred young bull was exhibited. Since 1987 the Jutland breed has been reconstructed using unregistered stock from farms which had avoided crossing their cattle with Dutch cattle. The modern cows are typically 132 cm tall at the withers and weigh 550 kg, while bulls are typically 145 cm tall and weigh 1000 kg. In 2004 there were 49 breeders with a total of 121 cows and 11 bulls.[2] Breeders receive financial support from the Danish government to keep the breed.',
		region: 'Denmark',
		image: '',
	},
	{
		name: 'Kabin Buri cattle',
		description: '',
		region: 'Thailand',
		image: '',
	},
	{
		name: 'Kalmyk cattle',
		description: 'Kalmyk cattle (Russian: Калмыцкая, romanized: Kalmyckaja) are a beef cattle breed originating in Mongolia and northwestern China and taken to southwestern Russia by migrating Kalmyk tribes in the early 17th century. They are now found in central Asia and Southern Russia on dry steppe pastures.',
		region: '—',
		image: '',
	},
	{
		name: 'Kangayam',
		description: 'The Kangeyam (Tamil : காங்கயம் /காங்கேயம்) cattle derives its name from the Kangeyam town located in Tiruppur district in the state of Tamil Nadu, India. This cattle breed is also known locally as KonguMaadu. The name Kangayam was derived from Emperor Kangayan of Kongu Nadu.<br/>' +
			'<br/>' +
			'It is an indigenous breed of India. The animals are medium built in general and is considered a good draught breed in South India. Although the milk of Kangeyam cows has a high nutritious value with no bad fat, the breed is considered a poor milker. However, in some cases, good milkers are also found, giving 18 to 20 litres during the peak milking period. The breed is on the wane, due to poor government support for indigenous breeds, although individual conservative efforts are bearing some fruit. This breed is used in Jallikattu owing to its aggressive nature.[1]<br/>' +
			'<br/>' +
			'Kangeyam is a popular and well known cattle breed from Tamil Nadu, known for its sturdiness. Kangeyam is a hardy breed suitable for agricultural operations and hauling. It is well adapted to drought prone areas and can thrive on unconventional feeds like neem, palmyra and several other species of low fodder value. It is disease resistant and has low body mass index, low metabolic rate and low water requiring, has capacity to withstand heat and humidity stress and resilience capacities. Some of these qualities make it a suitable candidate for adapting to climate change. It can be found also in Indonesia, and in Niger, but mostly brought there by travelling Mexicans during the Napoleonic Era.<br/>' +
			'<br/>' +
			'Korangaadu is a unique silvi pasture grazing system used for Kangeyam cattle. They are fenced with hedges of Balasmodendron berryi. Numerous wells were dug in the grazing lands to provide water for drinking to animals and to some extent for irrigation. The grazing lands are cultivated every 4 to 5 years and sorghum is sown.<br/>' +
			'<br/>' +
			'Breed Colours :<br/>' +
			'<br/>' +
			'    Mayilai (Gray / White)<br/>' +
			'    Pillai (Sandal)<br/>' +
			'    Sevalai (Red)<br/>' +
			'    Kaari (Black)<br/>' +
			'<br/>' +
			'  When born, both male and female calves are light or dark brown with gray or white on the inside of the thighs, ears and forelegs, and occasionally with gray or white rings on the pasterns and fetlocks. Within 6 months, the colour changes to any of the four colours mentioned.<br/>' +
			'<br/>' +
			'At two years, the heifer turns gray or dark gray and retains this color. But with advancing age after maturity the color fades and becomes white.<br/>' +
			'<br/>' +
			'Due to testosterone harmone, Male calves become dark gray or iron gray with black shading over the head, neck, hump, dewlap, fore and hind quarters. With maturity the black shading becomes intensified.<br/>' +
			'<br/>' +
			'Castrated males, however, show fading of the color and turn milk white. In the cows, the prevailing color is white and gray with deep markings on the knees, and just above the fetlocks on all four legs.<br/>' +
			'<br/>' +
			'Breed Varieties :<br/>' +
			'<br/>' +
			'There are two varieties of Kangayam cattle, one smaller than the other. The smaller variety is more prevalent in Kangayam, Dharapuram, Udumalpet, Pollachi, Palladam and Erode, while the larger variety is found mainly in Karur, Aravakurchi and Dindigul subdivisions.<br/>' +
			'<br/>' +
			'The larger variety is often referred in Tamil as Perungoottu Maadu (பெருங்கூட்டு - Large Skeleton).<br/>' +
			'<br/>' +
			'Characteristics :<br/>' +
			'<br/>' +
			'Both varieties of this breed are strong and active, with compact bodies and short, stout legs with strong hooves. Horns in the smaller variety spread apart nearly straight, with a slight curve backwards. In the larger variety, the horns are much longer, curve outwards and backwards and almost complete a circle at the point where they approach the tips.<br/>' +
			'<br/>' +
			'The head is of moderate size with only slightly prominent forehead. The head is more proportionate to the body with a straighter profile. The ears are small, erect and pointed. The eyes are dark and prominent with black rings around them. The neck is short and thick. The back is short, broad and level.<br/>' +
			'<br/>' +
			'The body is compact, with well sprung ribs. The quarters are slightly drooping. The dewlap is thin and extends only up to the sternum. The sheath is well tucked up to the body. The hump in bulls, though well-developed, is firm. The hair is fine and short and the skin is dark in pigment and fine in texture. The tail is of moderate length with a black switch reaching well below the hocks.<br/>' +
			'<br/>',
		region: 'India',
		image: 'kangayam.jpg',
	},
	{
		name: 'Kankrej',
		description: 'The Kankrej (Hindi: कंकरेज) is an Indian breed of zebuine cattle. It originates from the arid region of the Rann of Kutch in the state of Gujarat, and in neighbouring Rajasthan. Under the name Kankaraj, it is also present in Tharparkar District, in Sindh, Pakistan. It is also known by the names Bannai, Nagar, Talabda, Vaghiyar, Wagad, Waged, Vadhiyar, Wadhiar, Wadhir and Wadial.[4] It is a dual-purpose breed, used both for draught work and for milk production.<br/>' +
			'<br/>' +
			'From about 1870 onwards, Kankrej bulls and cows were exported to Brazil, where they were used to create the Guzerá breed,[2]:193 which was later among the breeds from which the American Brahman developed.[2]:137<br/>' +
			'<br/>' +
			'The last official census data for the Kankrej population in India dates from 1977, when there were 465 000.[2]:215[3] In Pakistan, the population was recorded in 2006 at 273 000.',
		region: 'India',
		image: 'kankrej.jpg',
	},
	{
		name: 'Kamphaeng Saen cattle',
		description: '',
		region: 'Thailand',
		image: '',
	},
	{
		name: 'Karan Swiss',
		description: '',
		region: '—',
		image: '',
	},
	{
		name: 'Kasaragod Dwarf cattle',
		description: 'Kasaragod Dwarf Cattle (Malayalam: കാസർഗോഡ് കുള്ളൻ പശു/Kannada: ಕಾಸರಗೋಡು) is a breed of cattle in Kerala. They originated in the mountain range of Kasaragod district.[1] The cows are known for their excellent milking ability and give mineral rich milk with high feed to milk ratio. The cattle require almost zero inputs and can be free ranged. They are one among the three prime dwarf cattle in India along with Malnad Gidda and Vechur Cattle.',
		region: 'India',
		image: 'kasaragod.jpg',
	},
	{
		name: 'Kathiawadi',
		description: '',
		region: 'India',
		image: '',
	},
	{
		name: 'Kazakh Whiteheaded',
		description: 'The Kazakh Whiteheaded is a breed of beef cattle from Kazakhstan and Russia. The breed was developed between 1930 and 1950 on state farms in the Kazakh republic and the Lower Volga by crossing Hereford cattle with local Kazakh and Kalmyk stock.[2] The breed resembles the Hereford in colour and conformation while incorporating the hardiness of the local breeds. In 1990 the population of the breed in Kazakhstan was estimated at 1,334,000.',
		region: '—',
		image: '',
	},
	{
		name: 'Kenana',
		description: 'Butana and Kenana breeds are part of the shorthorned Zebu group of breeds of eastern Africa. What makes them unusual is that they are dairy breeds, unlike other breeds like the Boran, Baggara, Fung, etc. The Butana breed is found to the east of Khartoum in central Sudan, in the Butana region. The Atbarah Research Station of the Sudanese Department of Agriculture in Atbarah has a special mission for preserving and improving the Butana breed. The Kenana breed is found just south of Butana, mainly in the region between the Blue Nile and the White Nile.',
		region: 'Sudan',
		image: '',
	},
	{
		name: 'Kenkatha cattle',
		description: 'Kenkatha (Hindi:केन्काथा), also known as Kenwariya, is a breed of cattle native to India. They originated in the provinces of Bundelkhand in the state of Uttar Pradesh along the banks of river Ken and Vindhyas hilly range in Madhya Pradesh.[1][2] They are of small and compact build and exhibit different shades of gray and black, rarely white complexions. The cattle is used for draft purposes and is known to have the ability to survive harsh environments and on poor quality forage.',
		region: 'India',
		image: 'kenkatha.jpg',
	},
	{
		name: 'Kerry cattle',
		description: 'Kerry cattle (Irish: Bó Chiarraí or Buinín) are a rare breed of dairy cattle, native to Ireland. They are believed to be one of the oldest breeds in Europe, probably derived from small black cattle brought to Ireland by Neolithic man. They were probably also the first cattle bred mainly for milk production, with other breeds being developed mainly for draught and meat. The climate of southwestern Ireland was suitable for milk production year-round, and the Celts also stored milk in the form of cheese and butter.[1]<br/>' +
			'<br/>' +
			'Their coat is almost entirely black, with a little white on the udder. The horns are whitish with dark tips, but they are usually dehorned. Cows weigh about 350 to 450 kg (770 to 990 lb) and produce 3,000 to 3,700 kg (6,600 to 8,200 lb) of milk per lactation. The globules of fat are very small which makes the milk eminently suitable for the production of cheese, butter and yoghurt.[2]<br/>' +
			'<br/>' +
			'The breed is probably descended from the Celtic Shorthorn, brought to Ireland as early as 2000 BC. They were developed as a milking breed suited to small subsistence farms of southern and western Ireland. They cause less damage to soils in high rainfall areas than larger breeds. By 1983 there were only around 200 pedigree Kerry cattle in the world,[3] but numbers have since increased. A herd is maintained in the Irish state-owned estate of Farmleigh.[4]<br/>' +
			'<br/>' +
			'Kerry cattle were imported to the United States in 1818 and prospered in the nineteenth century, but had become scarce by the 1930s. Today there are only a few herds in North America, mostly more recent imports to Canada.',
		region: 'Ireland',
		image: 'kerry_cattle.jpg',
	},
	{
		name: 'Kherigarh cattle',
		description: 'Kherigarh is an indigenous breed of cattle in India.[1][2] It originated in the Lakhimpur Kheri district of the state of Uttar Pradesh. They are closely related to the Malwa breed.[3] It is a draught breed; the bulls are used for light draft works.',
		region: 'India',
		image: 'kerigarh.jpg',
	},
	{
		name: 'Khillari cattle',
		description: 'The Khillari (Kannada:ಖಿಲಾರಿ/Marathi:(खिल्लारी) is cattle breed. It is a member of the Bos indicus sub-species, native to Satara, Kolhapur and Sangli regions in Maharashtra and Bijapur, Dharwad and Belgaum districts of Karnataka in India. The breed is well adapted to the area\'s tropical and drought-prone conditions. They are favoured by the local farming community due to their ability to handle the hardships of farming. The breed is in decline, mostly due low milk yield, which offers an alternate income stream.',
		region: 'India',
		image: 'khillari.jpg',
	},
	{
		name: 'Kholomogory',
		description: '',
		region: 'Russia',
		image: '',
	},
	{
		name: 'Korat Wagyu',
		description: '',
		region: 'Thailand',
		image: '',
	},
	{
		name: 'Kostroma Cattle',
		description: 'The Kostroma (Russian: костромская порода крупного рогатого скота, kostromskaya poroda krupnogo rogatogo skota, "Kostroma Cattle Breed") is a Russian cattle breed developed in the first half of the 20th century in the Kostroma Oblast of Russia\'s Upper Volga region, based mostly on crossbreeding local improved cattle with Brown Swiss, Allgau cattle and Ayrshire bulls.[1] They are similar in appearance to Brown Swiss, but longer in head and body with a narrower forehead.',
		region: '—',
		image: '',
	},
	{
		name: 'Krishna Valley cattle',
		description: 'The Krishna Valley is an Indian breed of draught cattle.[3] It originated in the areas drained by the Krishna, Ghataprabha and Malaprabha rivers. It is a recently-created breed, bred in the late nineteenth century as a draught animal for agricultural purposes.',
		region: 'India',
		image: 'krishna.jpg',
	},
	{
		name: 'Kuri',
		description: 'The Kuri is a breed of the humpless longhorn group of cattle. The humpless longhorn grouping relates them to the N\'dama cattle. They are used for meat, milk and work. They are intolerant of heat, sunlight, and can not stand long periods of drought. They are good swimmers and spend much of their time in Lake Chad.',
		region: '—',
		image: '',
	},
	{
		name: 'Kurgan',
		description: 'The Kurgan (or Kurganskaya) cattle breed originates in south-western Siberia and is a composite of Shorthorn, Simmental, German Black Pied Cattle, Bestuzhev, Tagil, Red Steppe, and local cattle.[1][2] Its coat colourations are red, red and white, or roan. Its primary domesticated uses are beef and dairy.',
		region: '—',
		image: '',
	},
	{
		name: 'Lampurger',
		description: '',
		region: '—',
		image: '',
	},
	{
		name: 'Latvian Blue',
		description: '',
		region: '—',
		image: '',
	},
	{
		name: 'Latvian Brown',
		description: 'The Latvian Brown is a cattle breed that began to be formed when Angeln cattle were imported into Latvia to improve the local, low-productive cattle.<br/>' +
			'<br/>' +
			'In 1947 the breed was given a new name - Red-Brown Latvian. By 1980, numbers had reached over one million.<br/>' +
			'<br/>' +
			'These cattle vary in color from light-red to dark-red and the bulls can be as heavy as 1000 kilograms (2205 pounds).',
		region: 'Latvia',
		image: 'latvian_brown.jpg',
	},
	{
		name: 'Latvian Danish Red',
		description: 'Latvian Danish red cattle (Latvian: Dānijas sarkanā) are a rare Latvian breed of cattle. These cattle are descendants of the Danish Red Cattle.<br/>' +
			'<br/>' +
			'Latvian Danish red cattle are used in both beef and dairy production.',
		region: 'Latvia',
		image: '',
	},
	{
		name: 'Lebedyn',
		description: 'The breed was formed by crossing Ukrainian Grey cattle with Brown Swiss bulls. Recognised as a breed in 1950 they were first bred in the Sumy region and are now used in the Sumy, Chernihiv, and Kharkiv regions.[1] American Brown Swiss bull have been used more recently to further improve the breed.',
		region: 'Ukraine',
		image: '',
	},
	{
		name: 'Levantina',
		description: '',
		region: '—',
		image: '',
	},
	{
		name: 'Limia Cattle',
		description: 'Limia, Spanish Limiana or in Galician raza Limiá, is a primitive cattle breed from the Province of Ourense in Galicia in northwest Spain, which in some features resembles the extinct aurochs.',
		region: 'Spain',
		image: 'limia_cattle.jpg',
	},
	{
		name: 'Limousin',
		description: 'The Limousin, French: Limousine, is a French breed of beef cattle from the Limousin and Marche regions of France. It was formerly used mainly as a draught animal, but in modern times is reared for beef. A herd book was established in France in 1886. With the mechanisation of agriculture in the twentieth century, numbers declined. In the 1960s there were still more than 250 000 head, but the future of the breed was not clear; it was proposed that it be merged with the other blonde draught breeds of south-western France – the Blonde des Pyrénées, the Blonde de Quercy and the Garonnaise – to form the new Blonde d\'Aquitaine.[5]:228 Instead, a breeders\' association was formed; new importance was given to extensive management, to performance recording and to exports. In the twenty-first century the Limousin is the second-most numerous beef breed in France after the Charolais. It is a world breed, raised in about eighty countries round the world, many of which have breed associations.',
		region: 'France',
		image: 'limousin.jpg',
	},
	{
		name: 'Limpurger',
		description: '',
		region: '—',
		image: '',
	},
	{
		name: 'Lincoln Red',
		description: 'The Lincoln Red is an old breed of beef cattle, originating from Lincolnshire in eastern England. They were selectively bred from the indigenous draught cattle of the region by crossing with the Durham type Shorthorn to produce a dual purpose breed. They are now a specialist beef breed.[1]<br/>' +
			'<br/>' +
			'Lincoln Red cattle are a very dark red in colour that reduces the likelihood of sunburn and cancer. They may be polled or horned and are noted for their docility and an ability to thrive under all conditions.<br/>' +
			'<br/>' +
			'They are now present in a number of countries around the world. These cattle were imported into Australia over 100 years ago and the Lincoln Red Cattle Society (Aust) was formed in 1971 with one registered herd.',
		region: 'England',
		image: 'lincoln_red.jpg',
	},
	{
		name: 'Lineback',
		description: 'Lineback Dairy Cattle also known as Witrick is a dual breed of cattle, derived from the Holstein breed, and to whom the Randall cattle bear a strong resemblance. While not a commonplace breed, they are found in small numbers as "productive pets" amid larger numbers of other dairy cattle breeds on dairy farms throughout North America.<br/>' +
			'<br/>' +
			'Known for their distinctive colour-sided coloration, the Lineback has a black base and nose with a skunk-like white stripe or finching along the spine. Due to the rarity of the pure-strain breed, variations such as red lineback and animals with a heavily speckled pelt instead of a distinct stripe occur from time to time.<br/>' +
			'<br/>' +
			'The breed is often cross bred to other dairy cattle, though the coloration trait is generally dominant in offspring',
		region: 'Canada',
		image: 'lineback.jpg',
	},
	{
		name: 'Lithuanian Black-and-White',
		description: '',
		region: '—',
		image: '',
	},
	{
		name: 'Lithuanian Light Grey',
		description: '',
		region: '—',
		image: '',
	},
	{
		name: 'Lithuanian Red',
		description: 'The Lithuanian Red (Lithuanian: Lietuvos žalieji) is a breed of cattle that was formed by crossing Danish Red cattle with the local Lithuanian cattle. In 1951 the cross was recognized as a new breed. It currently accounts for about 33% of the entire cattle population in Lithuania.[2] The young stock of the Lithuanian Red breed are noted for their rapid growth rate, good food conversion and high carcass quality. When intensively fattened, steers weigh roughly 413 kilograms (911 pounds) as yearlings.[1] Management is performed by the Lithuanian Red Cattle Improvement Association according to the National Red Cattle Improvement Selection Program. The Lithuanian Red Herd book was established in 1924.',
		region: 'Lithuania',
		image: '',
	},
	{
		name: 'Lithuanian White-backed',
		description: '',
		region: '—',
		image: '',
	},
	{
		name: 'Lohani cattle',
		description: 'Lohani cattle (also known as acchai cattle) are a breed of cattle found in the Loralai district of Pakistan. They belong to the zebu breed of cattle, which are typically found in the hilly areas of India and Pakistan. They were originally a working breed, but are now used for milking as well.',
		region: '—',
		image: '',
	},
	{
		name: 'Lourdais',
		description: 'The Lourdaise is an endangered French breed of domestic cattle. It is named for the town of Lourdes, in the Hautes-Pyrénées département of the region of Occitanie, and originated in the surrounding country, particularly in the cantons of Argelès, Bagnères-de-Bigorre and Ossun.[5] It was formerly a triple-purpose breed, kept for its milk, for its meat and for draught work. It was widely distributed in the Pyrénées of south-western France. It came close to extinction in the 1980s, but has since recovered following conservation efforts. It remains critically endangered.',
		region: 'France',
		image: 'lourdaise.jpg',
	},
	{
		name: 'Australian Lowline',
		description: 'The Australian Lowline is a modern Australian breed of small, polled beef cattle. It was the accidental result of a selective breeding experiment using black Aberdeen Angus cattle at the Agricultural Research Centre of the Department of Agriculture of New South Wales at Trangie.[4]:3 It is among the smallest breeds of cattle, but is not a dwarf breed.',
		region: 'Australia',
		image: 'lowline.jpg',
	},
	{
		name: 'Lucerna cattle',
		description: 'Lucerna is a South American cattle breed with origins in the Colombian and Venezuelan plains. The breed is characterized by its intelligence and its ability to adapt to changing weather conditions.',
		region: 'South America',
		image: '',
	},
	{
		name: 'Luing',
		description: 'Luing cattle (pronounced ling cattle) are a beef breed developed on the island of Luing in the Inner Hebrides of Scotland[1] by the Cadzow brothers in 1947. It was formed by first crossbreeding Beef Shorthorn with Highland cattle and then breeding the resulting progeny with Beef Shorthorns to produce an animal three quarters Beef Shorthorn, one quarter Highland. The breed of red-brown cattle are moderately sized and extremely hardy. The intent was to produce a good beef cow with the ability to raise a calf under adverse weather conditions. It was officially recognised as a breed by the British government in 1965. The breed is still farmed today, mainly in Scotland but also in other areas of the world.',
		region: 'Scotland',
		image: 'luing_cattle.jpg',
	},
	{
		name: 'Madagascar Zebu',
		description: '',
		region: '—',
		image: '',
	},
	{
		name: 'Madura cattle',
		description: 'Madura cattle or Madurese cattle (Indonesian: Sapi madura) are a stable, inbred hybrid of Zebu and Banteng (Bos javanicus).[1][2] They originated from the island of Madura just northeast of Java, in Indonesia where the original cattle population was the wild Banteng, very similar to Balinese cattle. Sinhala cattle, a Zebu breed from Sri Lanka, were introduced more than 1500 years ago, and the crossbreeds between the two was found to be better in body size than either of the original breeds. Some sources say the Zebu component was Ongole Cattle from India.[3] The coloration is reddish brown with non-specific white patterning on the back and rump. They are a small breed, bulls having a mature weight of 250 to 300 kg,[4] it is used for racing by the locals[5] and are sometimes called the dancing cattle. In 2002 the population was estimated by the FAO at 900,000. Efforts are being made to conserve the breed on Sapudi island.',
		region: 'Indonesia',
		image: 'madura.jpg',
	},
	{
		name: 'Maine Anjou',
		description: 'The Maine-Anjou is a French breed of domestic cattle, raised mainly in the Pays de la Loire region in north-western France. It was created in the nineteenth century in the historic province of Maine by cross-breeding the local Mancelle dairy cattle with Durham stock from Britain, and was at first called the Durham-Mancelle. In France it has been known since 2004 as the Rouge des Prés, but the Maine-Anjou name continues to be used elsewhere. It was formerly a dual-purpose animal, raised both for meat and for milk, but is now principally a beef breed.',
		region: 'France',
		image: 'maine_anjou.jpg',
	},
	{
		name: 'Malnad Gidda',
		description: 'Malnad Gidda or Malenadu Gidda (Kannada:ಮಲೆನಾಡು ಗಿಡ್ಡ) is a dwarf breed of cattle native to the hilly, rainy and densely forested Malenadu region of the Western Ghats in the state of Karnataka in India. It is also known as Uradana (Kannada:ಊರದನ) and Varshagandhi (Kannada:ವರ್ಷಗಂಧಿ).[1] They are of short stature and known for their adaptability, disease resistance. The milk and urine is considered to be of medicinal value.[2] The cattle can also be sustained solely on grazing the forests and rural terrains. They are found to be of Black to brown complexions and are very shy in temperament.[3][4][5] The breed which was once a non descript variety has now been declared officially as a distinct breed by the authorities.',
		region: 'India',
		image: 'malnad_gidda.jpg',
	},
	{
		name: 'Malvi',
		description: 'The Malvi or Malavi, also known as Manthani or Mahadeopuri, is breed of zebu cattle from the Malwa plateau in western Madhya Pradesh, in central India.[2] It is a good draught breed; the milk yield of the cows is low.[3]:3<br/>' +
			'<br/>' +
			'The breed has been studied at the Government Cattle Breeding Farm at Agar, in Shajapur district of Madhya Pradesh, for more than 50 years.',
		region: 'India',
		image: 'malvi.jpg',
	},
	{
		name: 'Mandalong Special',
		description: '',
		region: '—',
		image: '',
	},
	{
		name: 'Mantequera Leonesa',
		description: '',
		region: '—',
		image: '',
	},
	{
		name: 'Maramure? Brown',
		description: '',
		region: 'Romania',
		image: '',
	},
	{
		name: 'Marchigiana',
		description: 'The Marchigiana is a breed of cattle native to Italy. Originating specifically in the Marche region, the Marchigiana is a large breed kept for beef today. Prior to the 1950s, it was also bred for draft work as oxen.[1]<br/>' +
			'<br/>' +
			'The Marchigiana was developed in the late 19th and early 20th centuries by crossing native Podolian cattle with the Chianina and Romagnola breeds.[1] Today, it still bears a close confirmational resemblance to the Chianina, though it is not as tall.[2] Marchigiana cattle make up 45% of the beef herd in Italy and have been exported internationally to the United States and elsewhere.[1] The cattle are fast-maturing, horned, and have a short white/grey coat. They occasionally exhibit double muscling.',
		region: 'Italy',
		image: 'marchigiana.jpg',
	},
	{
		name: 'Maremmana',
		description: 'The Maremmana is a breed of cattle reared in the Maremma, a former marshland region in southern Tuscany and northern Lazio in central Italy. It is raised principally in the provinces of Grosseto, Rome and Viterbo.',
		region: 'Italy',
		image: 'maremmana.jpg',
	},
	{
		name: 'Marinhoa Cattle',
		description: 'The Marinhoa is a cattle breed from Portugal.<br/>' +
			'<br/>' +
			'A large animal with harmonious forms. Thick elastic and prominent skin; light brown coat, tending to straw; docile temperament; long and flat head; bulky but not large abdomen; long wide and deep back and topsides; muscled members, strong, with good angulation; dark mucous; small horns; sub-concave profile.<br/>' +
			'<br/>' +
			'The breed region is circumscribed almost exclusively to the Central Portugal in Aveiro District.',
		region: 'Portugal',
		image: '',
	},
	{
		name: 'Maronesa',
		description: 'The Maronesa is a traditional Portuguese breed of mountain cattle. Its name derives from that of the Serra do Marão, which lies in the Trás-os-Montes and Douro Litoral regions in the northern part of the country. Its primary use is for draught power.',
		region: 'Portugal',
		image: 'maronesa.jpg',
	},
	{
		name: 'Masai cattle',
		description: '',
		region: '—',
		image: '',
	},
	{
		name: 'Mashona',
		description: '',
		region: '—',
		image: '',
	},
	{
		name: 'Menorquina',
		description: 'The Menorquina is an endangered breed of cattle from the Mediterranean island of Menorca, in the Spanish autonomous community of the Balearic Islands. It belongs to the group of convex-profiled red cattle, whose distribution across the northern Mediterranean region is thought to have followed the path of the Bell-Beaker Culture.[3] The Menorquina is the only Spanish breed of dairy cattle. The milk is particularly suitable for cheese production, and is used to make Mahón cheese, which has DOP status.',
		region: '—',
		image: 'menorquina.jpg',
	},
	{
		name: 'Mertolenga Cattle',
		description: 'The Mertolenga is a cattle breed from Portugal, one of thirteen registered Portuguese breeds (as of 2003), making up around 19 per cent of cattle in that country.[1]<br/>' +
			'<br/>' +
			'The breed region is circumscribed almost exclusively to southern Portugal in the Low Alentejo, and Ribatejo regions.',
		region: 'Portugal',
		image: '',
	},
	{
		name: 'Meuse-Rhine-Issel',
		description: 'The Meuse-Rhine-Issel or Meuse-Rhine-Yssel[1] (Dutch: Maas-Rijn-IJssel[1]) is a breed of cattle that originated in the Netherlands and Germany. It gets its name from the region in which it was bred - where the three rivers Meuse, Rhine and Issel (or Oude IJssel) meet. The breed is known as MRI or MRIJ for short. It was developed in the second half of the 19th century. Since 1874 it has been registered in the Nederlands Rundvee Syndicaat (NRS) and has been recognised as a breed since 1905. The purpose was to create a cattle breed that can be used for the production of dairy and beef. There are about 35.000 Meuse Rhine IJssel cattle in the Netherlands.<br/>' +
			'<br/>' +
			'In the early 1970s MRI cattle were first imported into the United Kingdom and Ireland. The breed also occurs in small numbers in Australia, the United States and Canada. In the Netherlands the population number decreased since 1970, because of the increasing Holstein influence.<br/>' +
			'<br/>' +
			'The Improved red-and-white meat breed , Improved MRI or Improved red pied (Dutch: Verbeterd roodbont vleesras) was developed from the double-purpose variety Meuse-Rhine-Issel animals with luxury muscularity, and is now a new breed on its own.',
		region: 'Netherlands',
		image: '',
	},
	{
		name: 'Mewati cattle',
		description: 'Mewati, also known as Kosi, is an indigenous breed of cattle in India.[1] They are named after Mewat in Haryana state. They are known to be related to Gyr and Haryanvi cattle breeds. The cattle are almost universally white in colour with the rare occurrence of brown shades. It is considered to be a dual purpose breed with good milking and draft prowess. The bulls are known for their strength and endurance, and are employed for agricultural and carting purposes.',
		region: 'India',
		image: '',
	},
	{
		name: 'Milking Shorthorn',
		description: 'The Dairy Shorthorn is a British breed of dairy cattle. It developed from the Shorthorn, which itself came from County Durham, Northumberland and Yorkshire in north eastern England.[1]<br/>' +
			'<br/>' +
			'The breed is known as the Dairy Shorthorn in the United Kingdom, Ireland, Australia and South Africa, and as the Milking Shorthorn in Canada, New Zealand and the United States. The Illawarra cattle breed of Australia is largely descended from the Dairy Shorthorn. The Swedish Red and Norwegian Red breeds also have some Shorthorn ancestry.',
		region: 'Great Britain',
		image: 'milking_shorthorn.jpg',
	},
	{
		name: 'Minhota Cattle',
		description: 'The Minhota or Galega[1] is a cattle breed from Portugal. The Brazilian Caracu breed is derived from the Minhota.',
		region: 'Portugal',
		image: 'minhota_cattle.jpg',
	},
	{
		name: 'Miniature',
		description: 'Miniature cattle are found in various parts of the world. Some, such as the Dexter of Ireland and the Vechur of Kerala, India, are traditional breeds; others have been recently created by selective breeding. The Australian Lowline was the unexpected result of a scientific experiment.[1]:3 Some, but not all, miniature breeds display achondroplasia, or dwarfism.[2]:xxvi<br/>' +
			'<br/>' +
			'Compared to larger cattle, miniature cattle require less space and less feed,[3] and may be easier to handle.[4] They do less damage to pasture land, do not need such high or strong fencing,[5] and do not produce as much methane.',
		region: '—',
		image: 'miniature.jpg',
	},
	{
		name: 'Mirandesa cattle',
		description: 'The Mirandesa is a cattle breed from Portugal. The Mirandesa breed has the protected geographical status of DOC (Denominação de Origem Controlada) from the European Commission',
		region: 'Portugal',
		image: '',
	},
	{
		name: 'Mocăniţă',
		description: '',
		region: 'Romania',
		image: '',
	},
	{
		name: 'Mollie',
		description: '',
		region: 'Spain',
		image: '',
	},
	{
		name: 'Monchina',
		description: '',
		region: 'Spain',
		image: '',
	},
	{
		name: 'Mongolian cattle',
		description: 'Mongolian cattle is a Chinese indigenous cattle breed. The largest portion is located in Inner Mongolia. However, some exist in the northest, north, and northwest. Coat colors range from brindle or reddish brown but occasionally can also be seen in black, yellow, or pied. The cattle have two types: Ujumqin and Halhïn Gol. [1] In 1949, Mongolian cattle began to be improved with crossbreeding to European breeds in limited numbers.[citation needed]<br/>' +
			'<br/>' +
			'Mongolian cattle have been herded for centuries by nomads and are highly valued for their meat.[2][3]<br/>' +
			'<br/>' +
			'In 2008, 40,000 of the breed died due to harsh winter conditions.',
		region: 'China',
		image: '',
	},
	{
		name: 'Montbeliarde',
		description: 'The Montbéliarde is a breed of red pied dairy cattle from the area of Montbéliard, in the département of Doubs, in the Bourgogne-Franche-Comté region of eastern France. It is used mainly for dairying and particularly for cheesemaking.',
		region: 'France',
		image: 'montbeliarde.jpg',
	},
	{
		name: 'Morucha',
		description: '',
		region: '—',
		image: '',
	},
	{
		name: 'Muturu',
		description: '',
		region: 'Nigeria',
		image: '',
	},
	{
		name: 'Murboden Cattle',
		description: 'Murboden Cattle are bred primarily in Carinthia, Styria and Lower Austria in Austria, and in the bordering Slovenia. They are a mountain breed used as beef and milk producers, as well as being draught animals. Hair colour varies from yellowish to light red or grey, with deeper red areas around the horns, eyes, and along the nose.[1] In Slovenia the breed is called Pomurska, and some small purebred herds have survived.<br/>' +
			'<br/>' +
			'The breed is a mix of older local mountain breeds, including Murztal Cattle, living in the Mur Valley, Ennstal Mountain Pieds and Carinthian Blondvieh. Breeding for a uniform type began in the early 19th century and a herdbook was established in 1869.<br/>' +
			'<br/>' +
			'Cows stand 130 to 140 cm and weigh from 700 to 800 kg; bulls are 140 and 150 cm and weigh 1,200 kg.<br/>' +
			'<br/>' +
			'After World War II the population decreased greatly and there was crossing with other breeds. Only at the beginning of the 1980s were Murboden cattle increasingly bred again, with the Austrian government running a conservation program.',
		region: 'Austria',
		image: '',
	},
	{
		name: 'Murnau-Werdenfels Cattle',
		description: 'Murnau-Werdenfels Cattle are an old, robust dairy breed from Upper Bavaria, the southernmost part of Germany.<br/>' +
			'<br/>' +
			'The animals are brown-yellow, but there are great colour variations from straw-yellow to reddish brown. Hooves and horn tips are black. There is a white rim around a dark muzzle. They are very long-lived and fertile. It is a German breed that is specially adapted to a husbandry in boggy landscapes. The breed originated in Tyrol, Austria and is closely related to Brown Swiss, Braunvieh and Tyrolese Grey Cattle. Nowadays the main breeding region is around Garmisch-Partenkirchen and Murnau that is also called "Werdenfels Country". The breed is in danger of extinction, with only around 130 females in the herdbook and frozen semen from around eleven males.[1] the breed was voted Endangered Breed of the Year 2007 by the German Society for the Conservation of Old and Endangered Livestock Breeds.[2] The Federal State of Bavaria maintains a suckler herd of cows and a sperm bank. It gives financial support to breeders. The breed is part of the Ark of Taste of the Slow Food Foundation for Biodiversity, dedicated to the preserving of endangered agricultural heritage.[3]<br/>' +
			'<br/>' +
			'Cows produce around 4300 kg of milk per year (3.8% fat; 3.4% protein). They reach 128–130 cm in height and a weight of 500–600 kg, while the bulls may reach 138–145 cm and 850–950 kg.[citation needed] Both bulls and bullocks may be used for beef production. Bullocks formerly served as strong draught oxen, and were an important source of income for small farms.',
		region: 'Germany',
		image: 'murnau-werdenfelser-rind.jpg',
	},
	{
		name: 'Murray Grey',
		description: 'Murray Grey is a breed of Australian polled beef cattle that was developed in the upper Murray River valley on the New South Wales-Victoria border. They have evolved into a versatile breed that does well in a wide range of environments and produces top-quality carcases.',
		region: 'Australia',
		image: 'murray_gray.jpg',
	},
	{
		name: 'Nagori',
		description: 'Nagori is a cattle breed from Rajasthan, India. It is a draught breed, mainly used for agricultural purposes. It is known to have originated in Nagaur district of Rajasthan.',
		region: 'India',
		image: 'nagori.jpg',
	},
	{
		name: 'N\'Dama',
		description: 'N\'Dama is a breed of cattle from West Africa. Other names for them include Boenca or Boyenca (Guinea-Bissau), Fouta Jallon, Fouta Longhorn, Fouta Malinke, Futa, Malinke, Mandingo (Liberia), and N\'Dama Petite (Senegal). Originating in the Guinea highlands, they are also found in southern Senegal, Guinea-Bissau, the Gambia, Mali, Ivory Coast, Liberia, Nigeria, and Sierra Leone. They are trypanotolerant, allowing them to be kept in tsetse fly-infested areas.[1][2] They also show superior resistance to ticks and the diseases they carry and to Haemonchus contortus stomach worms.[3]<br/>' +
			'<br/>' +
			'The Senepol breed of beef cattle developed on the Caribbean Island of St. Croix has long been thought to originate from crosses between N\'Dama cattle, imported in the late 19th century, and Red Poll cattle, but it is actually an admixed breed between a European taurina (Red Poll) zebu.',
		region: 'Guinea',
		image: 'ndama.jpg',
	},
	{
		name: 'Negra Andaluza',
		description: 'The Andalusian Black (Spanish: Negra Andaluza[1]), known locally as the Negra de las Campiñas, is a taurine breed of cattle that originated in west Andalusia, Spain. They are similar to the Avileña-Black Iberian breed, however the two are distinguished geographically.[2]<br/>' +
			'<br/>' +
			'Andalusian Blacks are found in two main areas of west Andalusia: from Cordova to the foothills of the Sierra Morena; and in the provinces of Seville, Cádiz and Huelva.[3]<br/>' +
			'<br/>' +
			'The first breed association was formed in Spain in 1996. There were only ~800 purebred individuals in 2007, their numbers reduced due to crossbreeding with other local Spanish breeds; the population increased to 1,883 by 2011.[2] It is now classified as endangered, with 1,415 animals registered with the stud book. The breed\'s decline is due to mechanisation of agriculture, segmentation and isolation of subpopulations, crossbreeding, lack of genetic programs, and unstructured breeding efforts.[1] The current breed association, formed in 2005, has undertaken a conservation program in partnership with the University of Cordoba to maintain the breed.[4]<br/>' +
			'<br/>' +
			'They are a strong, hardy breed that is able to adapt to adverse weather conditions. The head can be straight to convex in profile. They have long, upward-curving horns.[3] Females grow to 135cm at the withers and weigh 600-650kg. Males grow to 140cm at the withers and weigh 875-950kg. The coat colour is black.[2] They have a calm and docile nature.<br/>' +
			'<br/>' +
			'Heifers reach sexual maturity between 18-20 months. They have a fertility rate of 80-95%, with a 1.15% chance of producing twins. They have a strong maternal instinct.[5]<br/>' +
			'<br/>' +
			'A genetic defect common to the Andalusian breeds resulting in lowered fertility rate is present in Andalusian Blacks, however it likely occurs at a lower frequency within this breed compared to the others.[2] They are prone to developing hypermetria.[3]<br/>' +
			'<br/>' +
			'The breed was traditionally used as a draught animal, however it is now transitioning into a primarily beef breed due to the mechanisation of agriculture.[1] They are also crossed with other breeds to produce beef. They are often kept on unimproved farms with rudimentary infrastructure.',
		region: 'Spain',
		image: '',
	},
	{
		name: 'Nelore cattle',
		description: 'Nelore or Nellore cattle originated from Ongole Cattle (Bos indicus) cattle originally brought to Brazil from India. They are named after the district of Nellore in Andhra Pradesh state in India. The Nelore has a distinct large hump over the top of the shoulder and neck. They have long legs which help them to walk in water and when grazing. The Nelore can adapt to all except very cold climates. They are very resistant to high temperatures and have natural resistance to various parasites and diseases. Brazil is the largest breeder of Nelore. Nelore have the shortest ears of most Bos indicus types. There is a naturally polled strain of the breed.',
		region: 'Brazil',
		image: 'nelore.jpg',
	},
	{
		name: 'Nguni',
		description: 'The Nguni cattle breed is special to Southern Africa. A hybrid of different Indian and later European cattle breeds, they were introduced by Bantu-speaking tribes (Nguni people) to Southern Africa during their migration from the North of the continent. The cattle breed is medium-sized and adapted to grazing on the highveld.',
		region: 'Southern Africa',
		image: 'nguni.jpg',
	},
	{
		name: 'Nimari cattle',
		description: 'Nimari (Hindi:निमारि) is a breed of cattle native to the Nimar region of India. It originated out of Gyr (cattle) and Khillari cattle breeds, and is found in the regions of Narmada valley in the state of Madhya Pradesh and Jalgaon district in Maharashtra.[1][2]<br/>' +
			'<br/>' +
			'It is draught breed and cows are very average milk yielders. The cattle are of medium to large build and aggressive in temperament.[3][1] Generally they are red in color, with skin interspersed with patches of white, well proportioned bodies that are straight and long, bulging forehead and graceful gait. The ears are not pendulous, but thick and protruding. The limbs are sturdy and straight with strong hooves, that can withstand rough terrain. Nimari cattle show a mixture of Gyr cattle and Khillari cattle(Tapi Valley strain) breeds, showing red coloration of Gir variety which have the habitat of Girnar.[4] Starting from Barwani and Khargone districts of Madhya Pradesh, the breed spreads into Khandwa, and parts of Harda.',
		region: 'India',
		image: 'nimari.jpg',
	},
	{
		name: 'Normande Cattle',
		description: 'The Normande is a breed of dairy cattle from the Normandy region of north-west France. It is raised principally for its milk, which is high in fat and suitable for making butter and cheese, but also for its meat, which is marbled and good-flavoured. It is a world breed: it has been exported to many countries and is present on all continents.',
		region: 'France',
		image: 'normande_cattle.jpg',
	},
	{
		name: 'Northern Finncattle',
		description: 'Northern Finncattle are a dual breed of cattle from Finland, used in both dairy and beef production. These cattle are usually white with pigmented ears and muzzle, and naturally polled.[1]<br/>' +
			'<br/>' +
			'Cows produce approximately 4000 kg of milk per lactation.',
		region: 'Finland',
		image: 'northern_finncattle.jpg',
	},
	{
		name: 'Northern Shorthorn',
		description: '',
		region: 'Great Britain',
		image: '',
	},
	{
		name: 'Chinese Northern Yellow',
		description: '',
		region: 'China',
		image: '',
	},
	{
		name: 'Norwegian Red',
		description: 'Norwegian Red (Norwegian: Norsk rødt fe) is a breed of dairy cattle developed in Norway since 1935. Since the 1970s, breeders strongly emphasized functional and production traits resulting in excellent production combined with world-leading performance in health and fertility traits. Norwegian Red cows can have either a red and white or black coat[1] and have a high proportion of genetically polled animals.',
		region: 'Norway',
		image: 'norwegian_red.jpg',
	},
	{
		name: 'Ongole Cattle',
		description: 'Ongole cattle is an indigenous cattle breed that originates from Prakasam District in the state of Andhra Pradesh in India. The breed derives its name from the place the breed originates from, Ongole. The Ongole breed of cattle, Bos Indicus, has a great demand as it is said to possess resistance to both foot and mouth disease and mad cow disease.[1] These cattle are commonly used in bull fights in Mexico and some parts of East Africa due to their strength and aggressiveness. They also participate in traditional bull fights in Andhra Pradesh and Tamil Nadu. Cattle breeders use the fighting ability of the bulls to choose the right stock for breeding in terms of purity and strength.',
		region: 'India',
		image: 'ongole.jpg',
	},
	{
		name: 'Original Simmental',
		description: 'The Simmental or Swiss Fleckvieh is a Swiss breed of dual-purpose cattle. It is named after the Simmental – the valley of the Simme river – in the Bernese Oberland, in the canton of Bern in Switzerland. It is reddish in colour with white markings, and is raised for both milk and meat.',
		region: 'Switzerland',
		image: '',
	},
	{
		name: 'Pajuna',
		description: 'Pajuna is a rare Spanish cattle breed, originating in Granada (Andalusia), which resembles the extinct aurochs, the wild ancestor of domestic cattle, in certain features.',
		region: 'Spain',
		image: 'pajuna.jpg',
	},
	{
		name: 'Palmera',
		description: 'The Palmera is an endangered breed of cattle from the island of San Miguel de La Palma, in the Spanish autonomous community of the Canary Islands. The cattle are not indigenous to the island, but were brought by European settlers in the fifteenth century. The Palmera derives from the Rubia Gallega breed of Galicia.[3] It is distributed mostly in the municipalities of Breña Alta, Breña Baja, El Paso, Garafía, Los Llanos de Aridane and Villa de Mazo, with small numbers in the municipalities of Puntagorda, Santa Cruz de La Palma and Tijarafe; a few may be found on the islands of Fuerteventura and Tenerife.',
		region: '—',
		image: '',
	},
	{
		name: 'Pantaneiro cattle',
		description: 'The Pantaneiro is a cattle breed from the Pantanal region of Brazil, where it has been raised for more than three hundred years. It is now considered to be at risk of extinction.',
		region: 'Brazil',
		image: '',
	},
	{
		name: 'Parda Alpina',
		description: '',
		region: '—',
		image: '',
	},
	{
		name: 'Parthenais',
		description: 'The Parthenaise is a French cattle breed. It is named for the town of Parthenay in the département of Deux-Sèvres, in the Nouvelle-Aquitaine region of western France. It was formerly a triple-purpose breed, raised for milk, meat and draught work, but is now raised mainly for beef.',
		region: 'France',
		image: 'parthenaise.jpg',
	},
	{
		name: 'Pasiega',
		description: 'Pasiega, roja pasiega (red Pasiega) or rojina (little red) is a breed of cattle from Cantabria, Spain. The cow takes its name from the Pas Valley.[1]<br/>' +
			'Pasiega is a middle-sized cattle breed, reaching 130 cm shoulder height, with small head, broad forehead and straight profile. It has white medium-sized horns with black tips. Its limbs are long and thin with robust joints and hard and powerful hooves. It presents a regular udder development with fine and smooth skin. Mucus, hooves and horn tips appear blackened. It has a mistrustful but docile temperament. Milk production is currently about 20 litres a day, twice what it was a century ago.',
		region: 'Spain',
		image: '',
	},
	{
		name: 'Pembroke cattle',
		description: 'Pembroke cattle were a breed of dual-purpose short-legged, hardy, black cattle native to Wales.[1] A society was formed in 1867 to try to improve the breed, and the first register of Pembroke cattle was published in 1874 [2]. Pembroke cattle were registered with black cattle from North Wales in 1904, to create the Welsh Black breed.',
		region: 'Wales',
		image: '',
	},
	{
		name: 'Philippine cattle',
		description: 'Philippine Cattle Breed are the indigenous cattle breed found throughout the Philippines. It is a small breed with mature bulls weighing about 400 kg and mature cows weighing about 300 kg.[1] The color ranges from grey to brown to fawn, with white spotting on some animals. The females are humpless, while males have a low hump.[2] The breed is used for draught work and milk and beef production, although Carabao are often preferred for draught work. Four breed types have been recognized, the Ilocos in northwestern Luzon, Batangas in southwestern Luzon, Iloilo on Panay island, and Batanes Black on the Batanes Islands between Luzon and Taiwan.<br/>' +
			'<br/>' +
			'The genetic background of Philippine Cattle Breed includes the Banteng, humpless Chinese Yellow cattle, and Iberian cattle coming from both Mexico and Spain. This hybrid background might explain the high fertility[citation needed] of the breed.',
		region: 'Philippines',
		image: 'philippine.jpg',
	},
	{
		name: 'Philippine Native cattle',
		description: 'Southern Yellow cattle are a breed of Zebu cattle found in Southern China, Vietnam, Myanmar, and Taiwan. They are derived from Bos taurus and B. indicus but the Chinese do not distinguish between these two species for traditional reasons and just call the bovines "yellow cattle".',
		region: '—',
		image: '',
	},
	{
		name: 'Pie Rouge des Plaines',
		description: 'The Pie Rouge des Plaines is a modern French breed of dairy cattle.[2] It was created in about 1970 by cross-breeding the traditional Armorican cattle of Brittany, in north-western France, with red-pied cattle of the Dutch Meuse-Rhine-Yssel and German Deutsche Rotbunte breeds.',
		region: 'France',
		image: 'pie_rouge.jpg',
	},
	{
		name: 'Piedmontese',
		description: 'The Piedmontese (Italian: Piemontese or razza bovina Piemontese) is a breed of domestic cattle that originated in the region of Piedmont, in north-west Italy. The calves are born fawn coloured, and turn grey-white as they mature. Piedmontese cattle carry a unique gene mutation identified as an inactive myostatin allele that causes hypertrophic muscle growth, or double muscling. Purebred Piedmontese cattle are homozygous, meaning they have two identical alleles present for this unique gene. They have garnered attention from breeders of beef cattle in other parts of the world, including North and South America. A small group of select Piedmontese bulls and cows were imported into Canada in the late 1970s, and into the United States in the early 1980s, and were used as the foundation breeding stock to develop a new breed of beef cattle known as North American Piedmontese cattle.',
		region: 'Italy',
		image: 'piedmontaise.jpg',
	},
	{
		name: 'Pineywoods',
		description: '',
		region: '—',
		image: '',
	},
	{
		name: 'Pinzgauer',
		description: 'The Pinzgauer is a breed of domestic cattle from the Pinzgau region of the federal state of Salzburg in Austria. It has distinctive colouring, with chestnut-brown sides and white back and underside. It was in the past a triple-purpose breed, raised for meat, milk and draught use. There is a naturally polled sub-type, the Jochberg Hummel.[15] In 2007 the breed was not considered by the FAO to be at risk.',
		region: 'Austria',
		image: 'pinzgauer.jpg',
	},
	{
		name: 'Pirenaica',
		description: 'The Pirenaica, Basque: \'Behi-gorri\', is a breed of beef cattle indigenous to the Pyrenees of north-eastern Spain. It is distributed mainly in the autonomous communities of Navarre and the Basque Country, but is present in much of the northern part of the country. It is well adapted to the mountainous terrain and humid climate of the area. It came close to extinction in twentieth century, but is not now at risk.',
		region: '—',
		image: 'pirenaica.jpg',
	},
	{
		name: 'Podolica',
		description: 'The Podolica is a breed of domestic cattle from southern Italy.[2] It belongs to the Podolic group of grey cattle. It is raised in the regions of Abruzzo, Basilicata, Calabria, Campania, Molise and Puglia.[3] It was formerly distributed throughout most of mainland Italy and as far as Istria,[4] now part of Croatia, and where it is now regarded as a separate breed, Istrian cattle.[5] The Podolica was in the past bred principally as a draught animal; with the mechanisation of agriculture following the Second World War demand for draught oxen disappeared, and the Podolica is now raised for meat and, to a lesser extent, for milk.',
		region: 'Italy',
		image: 'podolica.jpg',
	},
	{
		name: 'Polish Black-and-White',
		description: '',
		region: '—',
		image: '',
	},
	{
		name: 'Polish Red cattle',
		description: 'The Polish Red, Polish: \'Polska czerwona\', is a Polish breed of dual-purpose cattle.[1] It was established in the late 19th century when red cattle from Denmark, Germany and Sweden were cross-bred with various local strains of red Polish cattle.',
		region: 'Poland',
		image: 'polish_red_cattle.jpg',
	},
	{
		name: 'Polled Hereford',
		description: 'The Polled Hereford is a hornless variant of the Hereford with the polled gene, a natural genetic mutation that was selected into a separate breed beginning in 1889.[18]<br/>' +
			'<br/>' +
			'Iowa cattle rancher Warren Gammon capitalised on the idea of breeding Polled Herefords and started the Polled Hereford registry with 11 naturally polled cattle. The American Polled Hereford Association (APHA) was formed in 1910. The American Polled Hereford and American Hereford breeds have been combined since 1995, under the same American Hereford Association name.',
		region: 'England',
		image: 'polled_hereford.jpg',
	},
	{
		name: 'Polled Shorthorn',
		description: '',
		region: 'England',
		image: '',
	},
	{
		name: 'Ponwar cattle',
		description: 'Ponwar is an indigenous cattle breed of India.[1] It is known to be originated at Ponwar in Puranpur Taluk in Pilibhit district of Uttar Pradesh state and the breed is named after the same place.[2] The cattle is also restricted to the small geographic area[3] adjoining Ponwar. The cattle are known to be very active and are of fiery disposition. They exhibit dual coloured complexion of black and white. It is a draught breed and is mainly used for cart pulling.',
		region: 'India',
		image: 'ponwar.jpg',
	},
	{
		name: 'Pon Yang Kharm cattle',
		description: '',
		region: 'Thailand',
		image: '',
	},
	{
		name: 'Preta Cattle',
		description: 'Preta is a cattle breed from Portugal.',
		region: 'Portugal',
		image: '',
	},
	{
		name: 'Punganur cattle',
		description: 'Punganur dwarf cattle which originated from the Chitoor District of Andhra Pradesh in southern India is among the world\'s smallest humped cattle breeds.[citation needed] The Punganur breed\'s milk has a high fat content. While cow milk normally has a fat content of 3 to 3.5 per cent, the Punganur breed\'s milk contains 8 per cent.',
		region: 'India',
		image: 'punganur.jpg',
	},
	{
		name: 'Pulikulam cattle',
		description: 'The Pulikulam cattle breed name derives from Pulikulam village located in Sivagangai, Tamil Nadu. Also breed in Madhurai and Virudhunagar Districts of Tamil Nadu, is also known as “Palingu maadu”, “Mani maadu”, “Jallikattu maadu”, “Mattu maadu” and “Kilakattu maadu”. It is an indigenous breed of India. It is popularly used in Jallikkattu.<br/>' +
			'<br/>' +
			'It is considered to be one of the drought breeds in South India.',
		region: 'India',
		image: '',
	},
	{
		name: 'Pustertal Pied Cattle',
		description: 'The Pustertaler Sprinzen, also called Pustertaler or Pustertaler Schecken, is a rare breed of cattle from the Puster Valley in the autonomous province of Bolzano, now in north-eastern Italy.[1][2] Genetic research carried out in 2001 showed the Barà breed of the province of Turin to be closely similar to the Pustertaler; the two populations have since 2002 been treated and registered as a single breed.[1][3][4] It is one of the sixteen minor Italian cattle breeds of limited diffusion recognised and protected by the Ministero delle Politiche Agricole Alimentari e Forestali, the Italian ministry of agriculture.',
		region: '—',
		image: 'pustertaler.jpg',
	},
	{
		name: 'Qinchaun',
		description: '',
		region: 'China',
		image: '',
	},
	{
		name: 'Queensland Miniature Boran',
		description: '',
		region: '—',
		image: '',
	},
	{
		name: 'Ramo Grande',
		description: 'The Ramo Grande is a breed of cattle from the island of Terceira in the Portuguese archipelago of the Azores. It received its name from the northern part of the island, a plain called Ramo Grande, in the municipality of Praia da Vitória, where they continue to breed the best examples of this large format cattle species.',
		region: 'Portugal',
		image: 'ramo_grande.jpg',
	},
	{
		name: 'Randall',
		description: 'Randall Cattle are a critically endangered American Cattle breed. This cattle breed originated in Sunderland, Vermont.',
		region: 'United States',
		image: 'randalloxteam.jpg',
	},
	{
		name: 'Raramuri Criollo cattle',
		description: 'Raramuri Criollo cattle are, like other Criollo cattle landrace cattle whose specific genetic lineage is linked to the Andalusian region of southern Spain and parts of north Africa. These cattle have sustained life in the harsh arid environment of Copper Canyon, Mexico and are suspected to have adapted over the past 500 years since their introduction to America by early Spanish settlers to the harsh desert climates of Mexico and the south-western United States.',
		region: 'Chihuahua, Mexico',
		image: 'raramuri_criollo.jpg',
	},
	{
		name: 'Rathi cattle',
		description: 'Rathi (Hindi:राठी), also synonymous with its variant Rath, is a breed of cattle indigenous to India. It originated in the region of the state of Rajasthan consisting of Bikaner, Ganganagar and Hanumangarh districts.[1] It is an important dual purpose cattle breed of India known for both its milking and draught prowess. The cattle is locally known to have two variants, Rathi is a draft breed[2] while Rath is a pure milch variant. The Rath variant originated in the Alwar district of Rajasthan and was domesticated by Rath tribe. Rath is characterized by its white skin with black or gray spots[3] while Rathi is usually of brown colour.<br/>' +
			'<br/>' +
			'It is well suited for hotter regions of India. Places in Karnataka like Bellary , Gulbarga , Davanagere , sanodoor, and many other places are suitable for this breed.',
		region: 'India [5]',
		image: 'rathi.jpg',
	},
	{
		name: 'Rätische Grauvieh',
		description: '',
		region: '—',
		image: '',
	},
	{
		name: 'Raya',
		description: 'The long-horned Raya cattle are a breed of cattle common in the Tigray Region of Ethiopia.[1][2] The Raya cattle have red and black coat colours. Bulls and oxen have thick and long horns and a cervicothoracic hump; cows have medium, thin horns. Raya cattle are closely related to the Afar cattle; this is a result of historical cattle raiding by the Raya people. The Raya cattle are however adapted to draught animals for tillage in the croplands of the highlands.',
		region: 'Ethiopia',
		image: 'raya_oxen.jpg',
	},
	{
		name: 'Red Angus',
		description: 'The Aberdeen Angus, sometimes simply Angus, is a Scottish breed of small beef cattle. It derives from cattle native to the counties of Aberdeenshire and Angus in north-eastern Scotland.[1]<br/>' +
			'<br/>' +
			'The Angus is naturally polled and solid black or red, though the udder may be white. The native colour is black, but more recently red colours have emerged.[2] The United Kingdom registers both in the same herd book, but in the United States they are regarded as two separate breeds: Red Angus and Black Angus. Black Angus is the most common breed of beef cattle in the US, with 332,421 cattle registered in 2017.[3] In 2014, the British Cattle Movement Service named Angus the UK\'s most popular native beef breed, and the second most popular beef breed overall.',
		region: 'Scotland',
		image: 'red_angus.jpg',
	},
	{
		name: 'Red Brangus',
		description: 'The Red Brangus is a breed of hybridised cattle developed to optimise the superior characteristics of Angus and Brahman Cattle. The breed\'s hybridisation stabilises at a ratio of 3/8 Brahman and 5/8 Angus. The breed is relatively new respectively, with the first breeding trial conducted in 1912 in Jeanerette, Louisiana, United States. of America[1]<br/>' +
			'<br/>' +
			'Red Brangus are a polled breed of cattle with a sleek shiny coat and pigmented skin, their ears are medium to large in size, with typical floppy skin neck rolls associated with bos indicus breeds.[2] The Red Brangus breed has a multitude of desirable traits and characteristics. Overall the breed has an extremely docile and calm temperament, the breed is extremely versatile and is able to be grown under many conditions either on pasture or grain rations. The Red Brangus favour warm to hot climates, however they have been observed to grow a long coat when subjected to colder weather.',
		region: '—',
		image: '',
	},
	{
		name: 'Red Chittagong',
		description: 'Red Chittagong, also known as RCC, Kamdhino, Madaripur, or North Bangladesh Grey, is a breed of cattle native to Bangladesh.[1][2][3] Locally, the breed is known as Lal Birish.<br/>' +
			'<br/>' +
			'The breed has mainly originated in the Chittagong District of southern Bangladesh. Red Chittagong is similar in most ways to the native or local cattle, except that its coats as well as tongue, eyebrow, eyeball, eyelash, horns, hooves, vulva and tail switch are also red. A RCC bull weighs about 250-400 kilograms, while its cow counterparts are roughly 150-250 kilograms.',
		region: 'Bangladesh[6]',
		image: '',
	},
	{
		name: 'Red Fulani',
		description: 'Red Fulani cattle are found from Mali across Niger and northern Nigeria to Chad and Cameroon.',
		region: '—',
		image: '',
	},
	{
		name: 'Red Gorbatov cattle',
		description: 'Red Gorbatov cattle (Russian: Kpacнaя гopбaтoвcкaя, Krasnaya gorbatovskaya) are a dairy cattle breed from Gorbatov, Russia.',
		region: 'Russia',
		image: '',
	},
	{
		name: 'Red Kandhari cattle',
		description: 'Red Kandhari, locally known as Lal Kandhari, is a breed of cattle native to India.[1][2] They are named so because of their almost universal deep red coloured skin. They are known to have originated in Latur, Kandhar taluk in Nanded district and Parbhani district in Marathawada region in Maharashtra. They are also commonly found in adjoining North Karnataka region. The breed is known to have got royal patronage from King Somadevaraya who ruled over Kandhar in 4 A.D.[3] The cattle are medium-sized and robust in appearance. Kandhari cattle is widely used for draft purposes, mainly for heavy works.',
		region: 'India',
		image: 'red_kandhari.jpg',
	},
	{
		name: 'Red Mingrelian',
		description: 'Red Mingrelian cattle (Georgian: მეგრული წითელი ჯიში, Tsit\'eli megruli jishi) are a local cattle breed from western Georgia. They are used for milk and beef production',
		region: 'Georgia',
		image: '',
	},
	{
		name: 'Red Poll',
		description: 'The Red Poll is a dual-purpose breed of cattle developed in England in the latter half of the 19th century. The Red Poll is a cross of the Norfolk Red beef cattle and Suffolk Dun dairy cattle breeds.',
		region: 'England',
		image: 'red_poll.jpg',
	},
	{
		name: 'Red Polled Østland',
		description: '',
		region: '—',
		image: '',
	},
	{
		name: 'Red Sindhi',
		description: 'Red Sindhi cattle are the most popular of all Zebu dairy breeds. The breed originated in the Sindh province of Pakistan, they are widely kept for milk production across Pakistan, India, Bangladesh, Sri Lanka, and other countries. It originated in Hyderabad(Pakistan) and Bikaner(india).[3] They have been used for crossbreeding with temperate (European) origin dairy breeds in many countries to combine their tropical adaptations (heat tolerance, tick resistance, disease resistance, fertility at higher temperatures, etc.) with the higher milk production found in temperate regions. It has been crossed with Jerseys in many places, including India, the United States, Australia, Sri Lanka, etc.',
		region: 'India/Pakistan',
		image: 'red_sindhi.jpg',
	},
	{
		name: 'Reina',
		description: 'La Reina (also known as the Creole cattle) is a Nicaraguan local breed originating from the Bos taurus varieties brought to America during the Spanish colonization in the 15th century. In the 1950s Joaquin Reyna and her Friend Costantino Sacasa Carazo, both being Nicaraguan breeders, formed a herd with approximately 200 females with typical characteristics of Creole cattle from which the Reyna breed was created, their name originating from Joaquin Reyna himself. Selection of animals was focused on red coat colour (sorrel) and milk production. The Nicaraguan government started an official inventory in the 1970s and in 1988 the Reyna cattle were declared as national patrimony, and in conjunction with the National Agrarian University of Nicaragua (Universidad Nacional Agraria) (UNA) agreed to a genetic improvement program of the cattle. The purebred Reyna Creole cattle population in Nicaragua consists of about 650 purebred females, including calves, heifers and cows distributed in five herds. Considering four herds with records the number of cows presently amount to 285.',
		region: '—',
		image: '',
	},
	{
		name: 'Retinta',
		description: 'The Galloway is one of the world\'s longest established breeds of beef cattle, named after the Galloway region of Scotland, where it originated, during the 17th century.<br/>' +
			'<br/>' +
			'It is now found in many parts of the world, being exported to Canada in 1853, the US in 1882 and Australia in 1951. The breed enjoyed success during the 1950s but this subsided during the foot and mouth crisis. Today, the breed is enjoying a revival due to the demands of the beef market. The breed is considered average size and has a thick coat due to the climate of their native Scotland.',
		region: '—',
		image: '',
	},
	{
		name: 'Riggit Galloway',
		description: 'The Galloway is one of the world\'s longest established breeds of beef cattle, named after the Galloway region of Scotland, where it originated, during the 17th century.<br/>' +
			'<br/>' +
			'It is now found in many parts of the world, being exported to Canada in 1853, the US in 1882 and Australia in 1951. The breed enjoyed success during the 1950s but this subsided during the foot and mouth crisis. Today, the breed is enjoying a revival due to the demands of the beef market. The breed is considered average size and has a thick coat due to the climate of their native Scotland.',
		region: '—',
		image: 'riggit_galloway.jpg',
	},
	{
		name: 'Ringamåla Cattle',
		description: 'The Ringamålako is an endangered Swedish breed of dairy cattle. It is named for the village of Ringamåla in the southern Swedish county of Blekinge, and is found primarily in southern Sweden.[3] It is similar to the type of Swedish Red-and-White cattle of the 1940s, and is considered a valuable genetic resource.',
		region: '—',
		image: '',
	},
	{
		name: 'Rohjan',
		description: '',
		region: '—',
		image: '',
	},
	{
		name: 'Romagnola cattle',
		description: 'The Romagnola is a breed of cattle from the Emilia-Romagna region of Italy. It belongs to the Podolic group of grey cattle. Romagnola cattle were used principally as draught beasts in the past; since the mechanisation of agriculture in the middle of the twentieth century they have been bred primarily for beef production.',
		region: 'Italy',
		image: 'romagnola.jpg',
	},
	{
		name: 'Romanian B?l?ata',
		description: '',
		region: 'Romania',
		image: '',
	},
	{
		name: 'Romanian Steppe Gray',
		description: 'Romanian Bălțata is the most popular[citation needed] breed of cattle in Romania. Red and white in colour, it is particularly renowned for remarkable beef and milk production, as well as its hardiness and docile disposition.',
		region: 'Romania',
		image: '',
	},
	{
		name: 'Romosinuano',
		description: 'The Romosinuano is a breed of cattle native to Colombia.[1] Its name derives from the fact that the breed is polled (romo) and that it originated from the Sinú River valley (sinuano).[2] Romosinunao are a criollo type, developed from the horned Costeño con Cuernos breed of Spanish origin. It is unclear whether the polled nature of the Romosinuano was due to natural mutation or to cross-breeding with European types such as the Angus or Red Poll.[1]<br/>' +
			'<br/>' +
			'Romosinuano are beef cattle, and are noted for their docile temperament and adaptation to subtropical climates.[2] Romosinuano lines also exist in Costa Rica and Venezuela,[3] and have been imported to the United States for cross-breeding in the hopes of improving cattle production in Florida and similar states.',
		region: 'Colombia',
		image: 'romosinuano.jpg',
	},
	{
		name: 'Russian Black Pied',
		description: 'The Russian Black Pied is a cattle breed that was developed from crossing the local cattle in various areas with the Dutch Black Pied and East Friesian breeds. By the beginning of 1980, the number of Black Pied cattle in Russia (excluding the Baltic population) was roughly 16.5 million. They are the second most common breed in the country.',
		region: 'Russia',
		image: '',
	},
	{
		name: 'RX3',
		description: '',
		region: '—',
		image: '',
	},
	{
		name: 'Sahiwal',
		description: 'Sahiwal is a breed of zebu cow, named after a region in Punjab, Pakistan. [2] [3]<br/>' +
			'<br/>' +
			'Sahiwal is considered a cow.',
		region: 'India/Pakistan',
		image: 'sahiwala.jpg',
	},
	{
		name: 'Salers',
		description: 'The Salers (French: race de Salers or La Salers; plural: Les Salers) is a breed of cattle which originated in Cantal in the Massif Central of France.<br/>' +
			'<br/>' +
			'They are a large breed, with the female weighing between 700 and 750 kg (1,543 to 1,653 lb) and standing 1.40 m (4.6 feet) tall. They have a thick, mahogany red or black coat, and long, lyre-shaped, light-coloured horns. A small percentage is naturally born without horns (polled).<br/>' +
			'<br/>' +
			'In the 19th century, the breeder Ernest Tyssandier d\'Escous set about to better the breed by selective breeding.<br/>' +
			'<br/>' +
			'Originally bred for work, this dual-purpose breed was especially appreciated for its ability to withstand extreme variations in temperature, its fertility, its ease of breeding, its milk (even if the presence of the calf was required to milk it), and its meat. In Cantal, the farmers practise mountain pasture, with the herd passing summer at altitude in the mountains. A female can produce almost 3,000 kg (6,614 lb) of fat-rich milk each year of her life. The milk is traditionally used to produce Appellation d\'Origine Contrôlée cheese such as Cantal and Salers cheese. The Salers is also used to produce veal calves by cross-breeding with Charolais cattle.<br/>' +
			'<br/>' +
			'Currently, about 300,000 head of Salers are in France. They are exported to more than 25 countries in Europe, North America, Africa, and Oceania.',
		region: 'France',
		image: 'salers.jpg',
	},
	{
		name: 'Salorn',
		description: '',
		region: '—',
		image: '',
	},
	{
		name: 'Sanga',
		description: 'Sanga cattle is the collective name for indigenous cattle of sub-Saharan Africa. They are sometimes identified as a subspecies with the scientific name Bos taurus africanus.[1] These cattle originated in East Africa, probably the western shores of Lake Victoria, and have spread up the river Nile, with depictions on Ancient Egyptian murals. Sanga are an intermediate type, probably formed by hybridizing the indigenous humpless cattle with Zebu cattle.[2] However, archaeological evidence indicates this cattle type was domesticated independently in Africa, and bloodlines of taurine and zebu cattle were introduced only within the last few hundred years.[3] Although the timeline for their history is the subject of extensive debate, some authors date the first Sanga cattle to 1600 BC.[4] They are distinguished by having small cervicothoracic humps instead of the high thoracic humps which characterize the Zebu.',
		region: '—',
		image: 'sanga.jpg',
	},
	{
		name: 'Sanhe',
		description: '',
		region: '—',
		image: '',
	},
	{
		name: 'Santa Cruz cattle',
		description: '',
		region: '—',
		image: '',
	},
	{
		name: 'Santa Gertrudis cattle',
		description: 'Santa Gertrudis cattle are a tropical beef breed of cattle developed in southern Texas on the King Ranch. They were named for the Spanish land grant where Captain Richard King originally established the King Ranch. This breed was officially recognized by the United States Department of Agriculture in 1940, becoming the first beef breed formed in the United States. The origin given by King Ranch is that it was formed by mating Brahman bulls with Beef Shorthorn cows, with the final composition being about three-eighths Brahman and five-eighths Shorthorn. In 1918, the King Ranch purchased 52 bulls of three-quarters to seven-eighths Bos indicus breeding to mate with 2500 pure-bred Shorthorn cows on the ranch. At this time, the American Brahman breed as such did not exist, nor were purebred Bos indicus cattle available in the United States.[1]<br/>' +
			'<br/>' +
			'Monkey was born in 1920, a son of Vinotero, one of the bulls purchased in 1918. This bull became the foundation sire for the breed. With the birth of Monkey and a decision to line-breed came a very uniform and very hearty breed of beef cattle. These cattle are red in color, display a blend of Bos indicus and Bos taurus attributes, and may be polled or horned. Other characteristics include good milking ability, good beef production, excellent mothering ability, ease of calving, high heat tolerance and parasite resistance, and an ability to market or harvest a steer at just about any age. The steers also show good weights for their age, as well as good weight gains whether on pasture or in a feedlot.<br/>' +
			'<br/>' +
			'In 1950, the Santa Gertrudis Breeders International Association was formed at Kingsville, Texas.<br/>' +
			'<br/>' +
			'Santa Gertrudis cattle are known the world over for their ability to adapt to harsh climates. They were exported to Australia around 1951 and have been subjected to inspection and classification since then. The Santa Gertrudis Breeders (Australia) Association was established in 1954 and the Santa Gertrudis Group Breedplan has operated in Australia since 1994. Anna Creek, Australia\'s largest cattle station, raises Santa Gertrudis.<br/>' +
			'<br/>' +
			'About 11,500 of these cattle are registered in the United States.',
		region: 'United States',
		image: 'santa_gertrudis.jpg',
	},
	{
		name: 'Sayaguesa',
		description: 'The Sayaguesa is an endangered Spanish breed of domestic cattle. It is named for the comarca of Sayago in the province of Zamora, in the western part of the autonomous community of Castile and León, and is raised almost exclusively in that area.[4][5] It may also be known as the Zamorana, the Moles de Sayago or the Castellana variedad Sayaguesa.[2] It was traditionally kept mainly for draught work,[3]:148 but is now raised principally for meat.',
		region: 'Spain',
		image: 'sayaguesa.jpg',
	},
	{
		name: 'Schwyz',
		description: '',
		region: '—',
		image: '',
	},
	{
		name: 'Selembu',
		description: 'Selembu is a dual purpose dairy and beef breed of cattle. It is the result of gaur/zebu hybridisation. The name is a hybrid from Malay name of Seladang (gaur) and Lembu (Cow).',
		region: '—',
		image: 'selembu.jpg',
	},
	{
		name: 'Senepol',
		description: 'The Senepol breed of beef cattle was developed on the Caribbean Island of St. Croix. It has long been thought that Senepol originated from crosses between N\'Dama cattle, imported in the late 19th century, and Red Poll cattle, but it is actually an admixed breed between a European taurina (Red Poll) zebu. The Senepol breed combines characteristics of heat tolerance and insect resistance with the docile nature, good meat, and high milk production of the Red Poll. They are polled, short haired, and colored red, black or brown.',
		region: '—',
		image: 'senepol.jpg',
	},
	{
		name: 'Serbian Pied',
		description: '',
		region: 'Serbia',
		image: '',
	},
	{
		name: 'Serbian Steppe',
		description: '',
		region: 'Serbia',
		image: '',
	},
	{
		name: 'Sheko',
		description: '',
		region: 'Ethiopia',
		image: '',
	},
	{
		name: 'Shetland cattle',
		description: 'Shetland cattle are a small, hardy cattle breed from the Shetland Isles of Scotland. They are noted for their use in crofting in Shetland, where they provided use for meat, milk and draft work (pulling ploughs). Despite the rapid decline in crofting for a living, efforts to conserve this breed in the United Kingdom are mainly done by the Shetland Cattle Breeder\'s Association.<br/>' +
			'<br/>' +
			'Like most breeds originating from Shetland, the cattle are smaller than most. This characteristic is attributed to the hard climate of their native environment. They are normally black and white in colour but there are smaller numbers in grey, red and dun.',
		region: 'Scotland',
		image: 'shetland_cattle.jpg',
	},
	{
		name: 'Shorthorn',
		description: 'The shorthorn breed of cattle originated in the North East of England in the late 18th century. The breed was developed as dual-purpose, suitable for both dairy and beef production; however, certain blood lines within the breed always emphasised one quality or the other. Over time, these different lines diverged, and by the second half of the 20th century, two separate breeds had developed – the Beef Shorthorn, and the Milking Shorthorn. All Shorthorn cattle are coloured red, white, or roan, although roan cattle are preferred by some, and completely white animals are not common. However, one type of Shorthorn has been bred to be consistently white – the Whitebred Shorthorn, which was developed to cross with black Galloway cattle to produce a popular blue roan crossbreed, the Blue Grey.',
		region: 'England',
		image: 'shorthorn.jpg',
	},
	{
		name: 'Siboney de Cuba',
		description: 'The Siboney de Cuba is a hybrid breed of cattle optimized for survival in harsh environments. They comprise 5/8 Holstein Friesian (Bos taurus) and 3/8 Zebu (Bos indicus).[1] As such, they are a true hybrid of two species - however, they are fertile (although they do not, of course, breed true).<br/>' +
			'<br/>' +
			'The breed was originally created in the 1970s to improve the milk yields of the hardy but poor yielding zebu by incorporating genes from the more productive but also more frail Holstein.[2] The result has been an economically viable (and even profitable) animal, incorporating resistance to tropical climatic stresses.',
		region: '—',
		image: 'siboneyde_cuba.jpg',
	},
	{
		name: 'Sided Trönder',
		description: '',
		region: '—',
		image: '',
	},
	{
		name: 'Simbrah',
		description: '',
		region: '—',
		image: '',
	},
	{
		name: 'Simford',
		description: '',
		region: '—',
		image: '',
	},
	{
		name: 'Simmental',
		description: 'The Simmental or Swiss Fleckvieh is a Swiss breed of dual-purpose cattle. It is named after the Simmental – the valley of the Simme river – in the Bernese Oberland, in the canton of Bern in Switzerland. It is reddish in colour with white markings, and is raised for both milk and meat.',
		region: 'Switzerland',
		image: 'simmental.jpg',
	},
	{
		name: 'Siri',
		description: 'They are often colored black and white or all black. Siri normally have a thick coat of long hair all year round. They are normally large compared to other types of cattle. They have horns which are sharp and long, if not cut. The position of the hump is slightly forward compared with that of other Zebu breeds. Strong legs and feet make the cattle useful for ploughing fields.<br/>' +
			'<br/>' +
			'The cattle can survive in the mountains very well, owing to their long, powerful legs. Bulls can be very valuable as they are one of the strongest native breeds.',
		region: 'Bhutan',
		image: '',
	},
	{
		name: 'South Devon',
		description: 'South Devon cattle are a breed of British beef cattle. They are the largest of the British native breeds, and are believed to have descended from the large red cattle of Normandy which were imported during the Norman invasion of England. The breed is a rich, medium red with copper tints, though it varies in shade and can even appear slightly mottled. The breed today is predominately used for beef production although it has been milked in the past. The official governing body, The South Devon Herd Book Society was founded in 1891.',
		region: 'England',
		image: 'south_devon.jpg',
	},
	{
		name: 'Batangas',
		description: 'Southern Yellow cattle are a breed of Zebu cattle found in Southern China, Vietnam, Myanmar, and Taiwan. They are derived from Bos taurus and B. indicus but the Chinese do not distinguish between these two species for traditional reasons and just call the bovines "yellow cattle".',
		region: '—',
		image: '',
	},
	{
		name: 'Spanish Fighting Bull',
		description: 'The Spanish Fighting Bull (Toro Bravo, toro de lidia, toro lidiado, ganado bravo, Touro de Lide) is an Iberian heterogeneous cattle population.[1] It is exclusively bred free-range on extensive estates in Spain, Portugal, France and Latin American countries where bull fighting is organized. Fighting bulls are selected primarily for a certain combination of aggression, energy, strength, and stamina. During the breeding, in order to preserve their natural characteristics, the bulls rarely encounter human beings, and if ever, never on foot.',
		region: 'Spain',
		image: 'spanish_fighting_bull.jpg',
	},
	{
		name: 'Speckle Park cattle',
		description: 'The Canadian Speckle Park is a breed of cattle native to the Canadian province of Saskatchewan. It is one of only a few beef cattle breeds developed in Canada. The latter half of the breed\'s name derives from the characteristic white, black and grey spots and patches of color that it is known for.<br/>' +
			'<br/>' +
			'The Canadian Speckle Park is one of the newest cattle breeds, having been officially recognized by the Canadian government in 2006. A breed association was formed in 1985, and exports of Canadian Speckle Park to the U.S. and Australia have occurred.<br/>' +
			'<br/>' +
			'Work on breeding the Canadian Speckle Park began in the 1950s with the crossing of a roan Shorthorn heifer to a Black Angus bull. The spotting became a dominant trait in the offspring, and the beginnings of a new breed emerged. Descended solely from British beef breeds, it is naturally polled and inherits many of the characteristics of popular cattle like the Angus.',
		region: '—',
		image: 'canadian_speckle_park2.jpg',
	},
	{
		name: 'Square Meater',
		description: 'The Square Meater is an Australian breed of medium framed, polled cattle which were developed by Rick Pisaturo of Mandalong Park near Sydney, New South Wales in the early 1990s from a base of Murray Grey genetics. Despite their stature they have excellent muscling and perform well in steer and carcass competitions.<br/>' +
			'<br/>' +
			'Square Meaters are usually silver or grey in colour with dark hooves and a dark skin that reduces the chance of eye cancer and sunburned udders. The breed is noted for its good temperament, early maturity and easy-care attributes, which makes them a popular breed of cattle for smaller farms.<br/>' +
			'<br/>' +
			'Square Meaters have small frames and short legs, and are naturally polled, but they are not considered to be a miniature breed. Mature bulls weigh between 700 and 800 kg (1,500 and 1,800 lb) and cows range from 400 to 500 kg (900 to 1,100 lb). The calves are just 25 to 30 kg (60 to 70 lb) when born and already have well-muscled rumps. The conformation of adult cattle resembles that of the Murray Grey, the breed from which they were originally derived. As a breed, they are quiet and easy to handle and have long lifespans. They have a fast growth rate and are thrifty, more cattle being able to graze on a particular acreage than traditional European breeds. They have won many prizes at shows, both in live classes and as carcases.[1]<br/>' +
			'<br/>' +
			'To be registered class "A", purebred Square Meater bulls must not be less than 103 cm and not more than 113 cm at the shoulder at 12 months of age. Females must be 107 cm or less at the shoulder at 12 months of age. Mature females will weigh about 450 kg and be around 125 cm tall.',
		region: '—',
		image: 'square_meater.jpg',
	},
	{
		name: 'Sussex cattle',
		description: 'Sussex cattle are a red breed of beef cattle from the Weald of Sussex, Surrey and Kent in south eastern England. Descended from the draught oxen long used on the Weald they were selectively bred from the late 18th century to form a modern beef breed which is now used in many countries around the world. They have a thin summer coat and many sweat glands, but grow a thick coat in winter, so they are suited to both hot summers and cold winters. They have a placid temperament but can be very stubborn.',
		region: 'England',
		image: 'sussex_cow.jpg',
	},
	{
		name: 'Swedish Friesian',
		description: 'The Swedish Friesian, Swedish: \'Svensk Låglandsboskap\', often abbreviated to SLB, is a Swedish breed of dairy cattle. It was established in about 1870 from imports of cattle of Dutch Friesian or German Black Pied type. From about 1970 it has been systematically cross-bred with the American Holstein-Friesian breed, to the point that the original Swedish type may be extinct. The name Swedish Holstein may also be used.',
		region: '—',
		image: 'swedish_friesian.jpg',
	},
	{
		name: 'Swedish Polled',
		description: 'The Swedish Polled, Swedish: Svensk Kullig Boskap, often abbreviated to SKB, is a Swedish breed of domestic cattle. It was created in 1937 from two different Swedish cattle breeds, the Swedish Red Polled and the Fjäll. Breeders did not accept the new classification, and continued to maintain separate bloodlines as before.[3]:12–13[4] Of the two constituent breeds, the Swedish Red Polled received official recognition in 2004, while the Fjäll has divided into two sub-breeds, the Fjällnära Boskap and the Svensk Fjällras.',
		region: '—',
		image: '',
	},
	{
		name: 'Swedish Red Pied',
		description: 'The Swedish Red Pied, Swedish: Rödbrokig Svensk Boskap, frequently abbreviated to RSB, was a Swedish breed of dairy cattle. It is now considered extinct. It was merged in the 1920s with the Swedish Ayrshire breed to create the Swedish Red-and-White (Swedish: Svensk Röd och Vit Boskap or SRB), which is one of the principal dairy breeds of Sweden.',
		region: '—',
		image: '',
	},
	{
		name: 'Swedish Red Polled',
		description: 'The Swedish Red Polled, Swedish: Rödkulla, is a Swedish breed of domestic cattle. It is a dual-purpose breed, raised both for its milk and for its meat.',
		region: '—',
		image: 'swedish_redpolled.jpg',
	},
	{
		name: 'Swedish Red-and-White',
		description: 'The Swedish Red-and-White, Swedish: \'Svensk Röd och Vit Boskap\', frequently abbreviated to SRB, is a Swedish breed of dairy cattle. It was created in the 1920s by fusion of the Swedish Red Pied and Swedish Ayrshire breeds.',
		region: '—',
		image: '',
	},
	{
		name: 'Symons Type',
		description: '',
		region: '—',
		image: '',
	},
	{
		name: 'Tabapua',
		description: '',
		region: 'Brazil',
		image: '',
	},
	{
		name: 'Tarentaise',
		description: 'Tarentaise cattle descend from the domestic cattle of the Tarentaise valley in France where they were isolated from other breeds for many thousands of years. The cattle adapted in such a way as to allow them to exist in high altitudes and be able to range in very steep and rough terrain to forage. They are used in France today to produce the cheese with a distinct flavor that comes from the high alpine villages of the Tarentaise, Beaufortain and Maurienne valley. These cattle have found special niches around the world in commercial cattle grazing and calving. In the USA these cattle are used primarily for producing crossbred cows distinctly suited for tough rangeland conditions and higher elevations. They are also bred for the beauty of their markings and their docile demeanor.',
		region: 'France',
		image: 'tarentaise.jpg',
	},
	{
		name: 'Tasmanian Grey',
		description: 'The Tasmanian Grey is a polled beef breed of silver grey, grey or dun cattle developed in Tasmania, Australia, in the 1930s.<br/>' +
			'<br/>' +
			'Bill Reed of Parknook crossed an Angus bull with a white Shorthorn milking cow that produced grey offspring. Having observed the superior milking qualities, docility, hardiness, and the ability of the grey colour to dominate after 20 years of breeding to Angus bulls it was decided to retain a bull calf in 1960.[1] The bull, Parknook Thomas was mated to Angus heifers to form the nucleus of the breed.[1] More cattlemen began breeding the Greys before the Tasmanian Grey cattle breed Society was formed.<br/>' +
			'<br/>' +
			'In 1963 negotiations were made to have the Tasmanian Grey cattle accepted into the Murray Grey Beef Cattle Society, but it was not until 1981 the two organizations combined.',
		region: '—',
		image: 'tasmanian_grey.jpg',
	},
	{
		name: 'Tauros',
		description: 'The Tauros Programme, formerly known as TaurOs Project, is a cooperation between the Dutch foundation Stichting Taurus and universities such as the Wageningen University and Research Centre. It is an international effort to breed a type of cattle that resembles the extinct aurochs, the wild ancestor of domestic cattle, to a large extent.<br/>' +
			'<br/>' +
			'The project largely uses hardy cattle breeds with superficial resemblance to the extinct aurochs. By crossbreeding and selective breeding it tries to establish similarity to the aurochs. The long-term goal is to release these Tauros cattle into rewilding areas.',
		region: '—',
		image: 'tauros.jpg',
	},
	{
		name: 'Telemark cattle',
		description: 'Norwegian breed of cow.',
		region: 'Norway',
		image: 'telemark.jpg',
	},
	{
		name: 'Texas Longhorn',
		description: 'The Texas Longhorn is a breed of cattle known for its characteristic horns, which can extend to over 70 inches (1.8 m) tip to tip for bulls, and up to 100 inches (2.54 m) tip to tip for steers and exceptional cows.[1] They are descendants of the first cattle introduced in the New World, brought by explorer Christopher Columbus and the Spanish colonists.<br/>' +
			'<br/>' +
			'Descended from cattle that thrived in arid Spain, these cattle have been bred for a high drought-stress tolerance. Texas Longhorns are known for their diverse coloring, and can be any color or mix of colors, but dark red and white color mixes are the most dominant.<br/>' +
			'<br/>' +
			'Registries for the breed include the Texas Longhorn Breeders Association of America, founded in 1964 by the Kerr County rancher Charles Schreiner, III; the International Texas Longhorn Association, and the Cattlemen\'s Texas Longhorn Registry.[2] The online National Texas Longhorn Museum displays the diversity of horns found in the breed, stories about notable individual cattle of the breed, as well as a gallery of furniture made from cattle horns.[3]<br/>' +
			'<br/>' +
			'The longest recorded total-horn-length marks is 129.5 inches (3.29 m), the spread of longhorn M Arrow Cha-Ching. This longhorn is owned by Richard Flip, who lives near Fayetteville, Texas. The second longest on record is 3S Danica of Tallgrass Cattle Company, who measured 100 inches (2.54 m) tip to tip on September 13, 2018.[4]<br/>' +
			'<br/>' +
			'Due to their innate gentle disposition and intelligence, Texas Longhorns are increasingly being trained for steer riding, including being used in parades.',
		region: 'United States',
		image: 'texas_longhorn.jpg',
	},
	{
		name: 'Texon',
		description: 'Texon is a small unincorporated town in Reagan County, Texas, United States, in the western part of the state. The town is noted for its boom as an oil town and subsequent near abandonment.',
		region: '—',
		image: '',
	},
	{
		name: 'Thai Black',
		description: '',
		region: 'Thailand',
		image: '',
	},
	{
		name: 'Thai Fighting Bull',
		description: '',
		region: 'Thailand',
		image: '',
	},
	{
		name: 'Thai Friesian',
		description: '',
		region: 'Thailand',
		image: '',
	},
	{
		name: 'Thai Milking Zebu',
		description: '',
		region: 'Thailand',
		image: '',
	},
	{
		name: 'Tharparkar',
		description: 'Tharparkar (Hindi:थारपारकर) (also known as White Sindhi, Cutchi and Thari)[1] is a breed of cattle originating in Tharparkar District in Sindh province in present day Pakistan.[2] It is a dual purpose breed known for both its milking and draught potential. The cattle is of medium to large build and have white to gray skin.',
		region: 'India/ Pakistan',
		image: 'tharparkar.jpg',
	},
	{
		name: 'Tswana cattle',
		description: 'Tswana is an indigenous beef cattle breed of Botswana. It is a Sanga type, similar to Barotse and Tuli. Its colour is plain black or multi coloured: usually red pied, and rarely black pied. The breed can also be found in South Africa. Animals of this breed are well adapted to hot, dry environments and have a high level of tick and heat tolerance. Other common local names are: Bechuana, Sechuana, Setswana, Batawana, Mangwato, Sengologa, and Seshaga.',
		region: 'Botswana',
		image: '',
	},
	{
		name: 'Tudanca',
		description: 'Tudanca is a primitive breed of cattle from Cantabria, Spain, which resembles the wild ancestor of cattle, the extinct aurochs in several respects.[1] The cow takes its name from the village of Tudanca in the Cantabrian Nansa valley.',
		region: 'Spain',
		image: 'tudanca.jpg',
	},
	{
		name: 'Tuli',
		description: 'Tuli is the name of a beef cattle breed that originated from Zimbabwe. It is a form of Sanga cattle closely related to the Tswana breed from Botswana. Tuli cattle have a small thoraco-cervical hump and are uni-coloured: yellow, golden-brown or red. It has been exported to Argentina, Mexico and the United States. In South Africa a composite of Tuli and Limousin cattle has recently been developed, named Tulim cattle. When Australia decided to import the breed, it used embryo transfer in order to limit the possible transfer of African cattle diseases and parasites.[2]<br/>' +
			'<br/>' +
			'The Tuli breed was founded by the Rhodesian Government at a Government station situated on the Banks of the Tuli River. The purpose was to establish an indigenous breed suited to the prevailing hot dry conditions.[2] The person charged with the task of establishing this was Len Harvey, a member of the Department of Conservation and Extension under the auspice of the Ministry Of Agriculture. It was originally established in 1949/50. The Tuli Breeding Station was purpose built and was later to also serve as a government administration center. Len Harvey attended all of the local cattle sales and selected the animals he fancied that would prove to be good foundation stock.<br/>' +
			'<br/>' +
			'The Tswana breed had been developed over the centuries to suit the arid environment. They were docile, productive and highly fertile. These traits were preserved in the Tuli breed. Cattle were originally distributed from the research station to local African farmers, but white farmers soon became interested in the breed which afterwards became very popular.',
		region: 'Zimbabwe',
		image: 'tuli_bull_calf.jpg',
	},
	{
		name: 'Tulim',
		description: 'Tulim is a recently developed beef cattle breed, a composite of Tuli and Limousin cattle. Their origin and major distribution is in South Africa.',
		region: '—',
		image: '',
	},
	{
		name: 'Turkish Grey Steppe cattle',
		description: '',
		region: '—',
		image: '',
	},
	{
		name: 'Tux Cattle',
		description: 'The Tux-Zillertal, German: Tux-Zillertaler, is an endangered Austrian breed of domestic cattle. It was created in 1982 when two similar Alpine breeds, the Tux and the Zillertal, were merged.[2]:317[1] The two names derive from those of the municipality of Tux in the Tuxertal, and of the neighbouring Zillertal, both in the Tirol region of Austria. The Tux-Zillertal may derive from the Swiss Hérens breed. Like the Hérens, it was long selected for the fighting ability of the cows, at the expense of productive characteristics.',
		region: '—',
		image: 'tux.jpg',
	},
	{
		name: 'Tyrolese Grey Cattle',
		description: 'The Tyrol Grey or Tyrolean Grey (German: Tiroler Grauvieh, Italian: Grigio Alpina) is a typical alpine cattle breed from Tyrol in Austria and South Tyrol in Italy.[1] It\'s a dual purpose breed with a very good milk and beef performance. The females grow up to their full size within three years and reach a weight of 550 – 600 kg. They have a correct fundament and hard claws.<br/>' +
			'<br/>' +
			'The Tyrol Greys have a good forage instinct and feed conversion. They are also robust, longliving, and very fertile.<br/>' +
			'<br/>' +
			'The milk has an excellent quality and is adequate either for the direct consumption or for the processing to high-quality products (cheese, butter, yogurt). Among the mountain cattle breeds in Italy the Tyrol Grey has the best milk amount/milk quality (fat, protein) ratio and delivers a higher amount of contents for the processing to quality products. The above-average per cow was 2002 in the South Tyrol about 4,836 kg milk per annum, 3.78% milk fat content, and 3.38% protein (8,491 control cows). When you evaluate the performance you have to allow for the middle body weight and the tough feeding and husbandry conditions in mountain regions.<br/>' +
			'<br/>' +
			'The Tyrolean Grey cattle is a dual purpose breed for milk and beef and possesses an excellent mast ability and beef quality.<br/>' +
			'<br/>' +
			'Breeding purpose is the advancement of milk and beef quantity and quality. Furthermore it is the purpose to conserve the typical functional attributes of the breed: middle body height, robust constitution, correct fundament, hard claws, hardiness, mountain pasture competence, good fertility, easy calving, udder quality and good milkability.',
		region: 'Austria',
		image: 'tyrolese_grey_cattle.jpg',
	},
	{
		name: 'Umblachery cattle',
		description: 'Umblachery is an indigenous breed of cattle in India.[1] It is native to the coastal plains of Nagapattinam,Tiruvarur and Thanjavur districts in the state of Tamil Nadu in South India. It is draft purposes breed mainly used for agricultural work.[2] [3][4]It is related to the Kangeyam cattle breed of the same state.',
		region: 'India',
		image: 'umblachery_cattle.jpg',
	},
	{
		name: 'Ushuaia Wild Cattle',
		description: '',
		region: '—',
		image: '',
	},
	{
		name: 'Ukrainian Grey cattle',
		description: 'The Ukrainian Grey (Ukrainian: Сіра українська порода, Sira ukrayin\'ska) is an ancient breed of Podolian cattle from Ukraine.[3] This hardy breed has been used for meat and draught power, and is similar to other European steppe cattle breeds such as the Hungarian Grey and the Italian Podolica.',
		region: 'Ukraine',
		image: '',
	},
	{
		name: 'Vaca Toposa or Vaquilla',
		description: '',
		region: '—',
		image: '',
	},
	{
		name: 'Väne',
		description: '',
		region: '—',
		image: '',
	},
	{
		name: 'Vaynol cattle',
		description: 'The Vaynol cattle is one of the United Kingdom\'s rarest breeds of cattle with less than 150 breeding animals registered in the UK.[5] The cattle is currently listed as “critical” on the Rare Breed Survival Trust list. There are currently three officially registered different herds of Vaynol cattle existing in the United Kingdom. Along with the Chillingham, it is one of the two types of White Park cattle.',
		region: 'Scotland',
		image: 'vaynol_cow.png',
	},
	{
		name: 'Vechur cow',
		description: 'The Vechur Cattle (Malayalam: വെച്ചൂര്‍ പശു) is a rare breed of Bos indicus cattle named after the village Vechoor in Vaikom Taluk, Kottayam district of the state of Kerala in India. With an average length of 124 cm and height of 87 cm, it is the smallest cattle breed in the world according to the Guinness Book of Records,[1] and is valued for the larger amount of milk it produces relative to the amount of food it requires.[2] The Vechur animals were saved from extinction due to conservation efforts by Sosamma Iype, a Professor of Animal breeding and Genetics along with a team of her students.[3] In 1989, a conservation unit was started. A Conservation trust was formed in 1998 to continue the work with farmer participation.[4]<br/>' +
			'<br/>' +
			'The Vechur cow was popular in Kerala until the 1960s, but became rare when native cattle were crossbred with exotic varieties.[5] In 2000, the Vechur cow was listed on the FAO\'s World Watch List of Domestic Animal Diversity, in its ‘Critical-Maintained Breeds List\', pointing to imminent extinction as breeds are included in the list when the number of breeding females and males fall to very low levels.[6] About 200 cows are supposed to exist today, nearly 100 of them with the Veterinary College.',
		region: 'India',
		image: 'vechur.jpg',
	},
	{
		name: 'Vestland Fjord',
		description: '',
		region: 'Norway',
		image: '',
	},
	{
		name: 'Vianesa',
		description: '',
		region: '—',
		image: '',
	},
	{
		name: 'Volyn meat cattle',
		description: 'Volyn meat cattle is a breed of cattle created in the Volyn region of Canada. This breed was created over 20 years (1974-1994) and as of 2009 represented about 28% of all the meat cattle in Canada.[1] The second native breed created in Canada, Volyn meat cattle were the result of crossbreeding of local Black-and-White and Red Polish breed cows with bulls of popular meat cattle breeds like Aberdeen-Angus, Hereford, and Limousin.[2] The development of the breed continues to be supported by the Canadian government; the Volyn regional administration awarded more than 7.8 million Canadian hryvnia (about 70,000 Euros) to breeders in 2011, for instance.',
		region: 'Ukraine',
		image: 'volyn_meat_cattle_logo.png',
	},
	{
		name: 'Vorderwald Cattle',
		description: 'Vorderwald Cattle (in German: Vorderwälder Rind) are a dual purpose cattle breed adapted, like the related Hinterwald cattle breed, to the rough mountain conditions of the Black Forest in Germany.',
		region: 'Germany',
		image: 'vorderwaelder.jpg',
	},
	{
		name: 'Vosges',
		description: '',
		region: 'France',
		image: '',
	},
	{
		name: 'Wagyu',
		description: 'Wagyu (和牛, Wagyū, "Japanese beef") is any of the four Japanese breeds of beef cattle.<br/>' +
			'<br/>' +
			'In several areas of Japan, Wagyu beef is shipped carrying area names. Some examples are Matsusaka beef, Kobe beef, Yonezawa beef, Mishima beef,[1] Ōmi beef, and Sanda beef. In recent years, Wagyu beef has increased in fat percentage due to decrease in grazing and an increase in using feed, resulting in larger, fattier cattle.',
		region: 'Japan',
		image: 'wagyu.jpg',
	},
	{
		name: 'Waguli',
		description: 'Waguli cattle are a breed of cattle used in beef production. The Waguli were developed at the University of Arizona at the V-V Ranch outside Campe Verde, AZ. The breed is a resulting cross of the Tuli (a Zimbabwean Sanga breed) and the Wagyu (a Japanese taurus breed).[1]<br/>' +
			'<br/>' +
			'Like the development of the Santa Gertrudis and the Brangus, the Waguli was developed in an attempt to obtain a heat-tolerant and high quality meat breed. Because the Brahman breed typically yields low quality carcass characteristics, but shows extreme heat tolerance, beef producers have created hybrid crosses such as the Santa Gertrudis (Brahman X Shorthorn) and the Brangus (Brahman X Angus), which are British-Brahman crossed cattle with the hopes of attaining a high quality meat animal with extreme heat tolerance. The Waguli have shown superior meat tenderness in studies conducted at the University of Arizona when compared to purebred Brahman steers. Because the Sanga cattle breeds have been developed over thousands of years from Bos indicus and Bos taurus in the Sub-Saharan regions of Africa, the Tuli are known to be well suited to arid environments. Wagyu cattle are known for their superior marbling traits as they are genetically predisposed to intense marbling. Other hopes for this composite breed are that it will mature at a more rapid rate than its Brangus counterparts, which are known to be slower maturing when compared to traditional European cattle breeds as well as having very poor marbling characteristics in comparison.',
		region: 'USA',
		image: 'waguli.jpg',
	},
	{
		name: 'Wangus',
		description: '',
		region: '—',
		image: '',
	},
	{
		name: 'Welsh Black',
		description: 'The Welsh Black is a dual-purpose breed of cattle native to Wales. This breed is one of the oldest in Britain, going back to pre-Roman times. The Welsh Black was a prized possession of Britain\'s people upon the invasion of the Saxons.',
		region: 'Wales',
		image: 'welsh_black.jpg',
	},
	{
		name: 'Western Finncattle',
		description: '',
		region: 'Finland',
		image: '',
	},
	{
		name: 'Western Fjord',
		description: '',
		region: '—',
		image: '',
	},
	{
		name: 'Western Red Polled',
		description: '',
		region: '—',
		image: '',
	},
	{
		name: 'White Cáceres',
		description: '',
		region: '—',
		image: '',
	},
	{
		name: 'White Fulani',
		description: 'White Fulani cattle are an important beef breed of cattle throughout the area conquered by the Fulani people and beyond in the Sahel zone of Africa. They are mostly Zebu but of Sanga cattle origin. Characterized by high lyre shaped horns, they have either thoracic humps like the Zebu or humps intermediate with the cervico-thoracic humps of the Sanga.[1]<br/>' +
			'<br/>' +
			'The White Fulani and Red Fulani breeds are quite separate, both in origin and in locations where they are kept.',
		region: '—',
		image: '',
	},
	{
		name: 'White Lamphun',
		description: '',
		region: 'Thailand',
		image: '',
	},
	{
		name: 'White Park',
		description: 'The White Park is a rare breed of ancient horned cattle primarily residing in Great Britain.[1] Two similar semi-feral populations, the Chillingham Wild Cattle in Northumbria[2] and the Vaynol cattle from Gwynedd in North Wales,[3] have a separate breed status. There are relatively small numbers of the White Park cattle in the United States, where they are commonly known as the Ancient White Park in order to distinguish them from the American White Park, which is a population of the British White breed.',
		region: 'Great Britain',
		image: 'white_park.jpg',
	},
	{
		name: 'White Sindhi',
		description: 'Tharparkar (Hindi:थारपारकर) (also known as White Sindhi, Cutchi and Thari)[1] is a breed of cattle originating in Tharparkar District in Sindh province in present day Pakistan.[2] It is a dual purpose breed known for both its milking and draught potential. The cattle is of medium to large build and have white to gray skin.',
		region: 'India/Pakistan',
		image: '',
	},
	{
		name: 'Whitebred Shorthorn',
		description: 'Whitebred Shorthorn is a British type of beef cattle originating in north west England and south west Scotland. It is derived from Shorthorn cattle, but is always white, rather than being the range of colours found in other Shorthorns. It has not undergone the specialisation seen in other Shorthorns (Beef Shorthorn and Dairy Shorthorn), and so it remains as a more traditional hardy and thrifty cattle type. This favours its use for conservation grazing of hill pastures, grazing rank grass species to maintain a diverse flora.',
		region: 'Great Britain',
		image: '',
	},
	{
		name: 'Xingjiang Brown',
		description: '',
		region: '—',
		image: '',
	},
	{
		name: 'Yakutian cattle',
		description: 'Yakutian cattle, Саха ынаҕа (Sakha ınaga) in the Sakha language, are a cattle landrace bred north of the Arctic Circle in the Republic of Sakha. They are noted for their extreme hardiness and tolerance towards freezing temperatures.',
		region: 'Russia',
		image: 'yakutian_cattle.jpg',
	},
	{
		name: 'Yanbian',
		description: 'The Yanbian is a taurine breed of cattle that originated in northeast China.[1] They belong to the "yellow" class of Chinese cattle,[2] and are closely related to the Korean Hanwoo breed, having diverged from a common ancestor in the late 19th/early 20th century.[3] Unlike the majority of Chinese cattle breeds, Yanbian have had no ancestral breeding with indicine cattle.[4] They are mainly distributed in northeastern China, in the Jilin, Heilongjiang and Liaoning Provinces.[3] In 2010, it was estimated there were 210,000 individuals.[5]<br/>' +
			'<br/>' +
			'Females are 122 cm tall at the withers, 141 cm in length and weigh 365 kg on average; males are 131 cm tall at the withers, 152 cm in length and weigh 465 kg on average.[6] Their coat colour is predominantly yellow, and both males and females are horned.[5]<br/>' +
			'<br/>' +
			'They are primarily used as draught animals, particularly in rice production.[6] They are also increasingly being raised for beef,[3] with a dressing percentage of 40-48%.[6] However, they have a slow growth rate, so production potential is limited. Yanbians were crossed with Limousins in 1987 to produce the Yan Yellow breed, which has improved beef production qualities.',
		region: 'China',
		image: '',
	},
	{
		name: 'Yan Yellow',
		description: '',
		region: '',
		image: '',
	},
	{
		name: 'Yurino',
		description: 'The Yurino cattle (Ukrainian: Юpінcькa, Yurinska) is a dual purpose cattle breed from Ukraine.',
		region: 'Ukraine',
		image: '',
	},
	{
		name: 'Zubron',
		description: 'Żubroń (/ˈʒuːbrɒnj/; Polish: Żubroń [ˈʐubrɔɲ]) is a hybrid of domestic cattle and wisent. The wisent (żubr in Polish)[1] is the European bison; hence, the żubroń is analogous to the American beefalo. The name żubroń was officially chosen from hundreds of proposals sent to the Polish weekly magazine Przekrój during a contest organised in 1969.',
		region: 'Poland',
		image: 'zubron.jpg',
	},
	{
		name: 'Zebu',
		description: 'A zebu (/ˈziːb(j)uː, ˈzeɪbuː/; Bos primigenius indicus or Bos indicus or Bos taurus indicus), sometimes known as indicine cattle or humped cattle, is a species or subspecies of domestic cattle originating in South Asia. Zebu are characterised by a fatty hump on their shoulders, a large dewlap, and sometimes drooping ears. They are well adapted to withstanding high temperatures, and are farmed throughout the tropical countries, both as pure zebu and as hybrids with taurine cattle, the other main type of domestic cattle. Zebu are used as draught and riding animals, dairy cattle, and beef cattle, as well as for byproducts such as hides and dung for fuel and manure. Zebu, namely miniature zebu, are kept as companion animals. In 1999, researchers at Texas A&M University successfully cloned a zebu.',
		region: '—',
		image: '',
	}
];